import AddIcon from "@mui/icons-material/Add";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import EditIcon from "@mui/icons-material/Edit";
import MenuIcon from "@mui/icons-material/Menu";
import SaveIcon from "@mui/icons-material/Save";
import SearchIcon from "@mui/icons-material/Search";
import UpdateIcon from "@mui/icons-material/Update";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import passwordKey from "../../images/passwordKey.png";
import WarningIcon from "@mui/icons-material/Warning";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import DialogActions from "@mui/material/DialogActions";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import CheckPermissions from "../../authorization/authorization";
import {
  actionableNormal,
  resetState as resetActionableNormal,
} from "../../features/actionable/actionableNormalSlice";
import {
  actionableOverdue,
  resetState as resetActionableOverdue,
} from "../../features/actionable/actionableOverdueSlice";
import {
  signOut,
  updateEmail,
  updateName,
  updatePhone,
  updateProfilePicture,
} from "../../features/authentication/authenticationSlice";
import { resetState as resetStateDueDate } from "../../features/billingAndCollection/dueDateExtensionNormalSlice";
import { resetState as resetStateInstallmentsNormal } from "../../features/billingAndCollection/installmentsNormalSlice";
import { resetState as resetStateInstallmentsOverdue } from "../../features/billingAndCollection/installmentsOverdueSlice";
import { resetOverallPerformanceState } from "../../features/dashboard/overallPerformance";
import { resetState as resetStateColNormal } from "../../features/generalServices/colNormalSlice";
import { resetState as resetStateColOverdue } from "../../features/generalServices/colOverdueSlice";
import { resetState as resetStateConNormal } from "../../features/generalServices/coaNormalSlice";
import { resetState as resetStateConOverdue } from "../../features/generalServices/coaOverdueSlice";
import { resetState as resetStateCotNormal } from "../../features/generalServices/cotNormalSlice";
import { resetState as resetStateCotOverdue } from "../../features/generalServices/cotOverdueSlice";
import { resetState as resetStateNcNormal } from "../../features/generalServices/ncNormalSlice";
import { resetState as resetStateNcOverdue } from "../../features/generalServices/ncOverdueSlice";
import {
  fetchFeederStatus,
  resetFeederStatusState,
} from "../../features/geoJson/feedersStatus";
import {
  fetchGeoJson,
  resetGeoJsonState,
} from "../../features/geoJson/geoJson";
import {
  fetchPaginatedAllComplaints,
  resetState as resetStateAllComplaints,
} from "../../features/powerComplaints/getComplaintSlice";
import { allStatsAPI, removeStats } from "../../features/stats/statsSlice";
import { updateHomeButton } from "../../features/powerComplaints/homeButtonSlice";
import Complaintsmanagemnt from "../../images/Complaintsmanagemnt.png";
// import {  } from "../../features/powerComplaints/homeButtonSlice";
import UserIconImage from "../../images/user.jpg";
import Allocated1 from "../../images/AllocatedComplaints.png";
import FESCOLOGO from "../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../images/DISCO Logos/TESCO.png";
import SUNDARLOGO from "../../images/discologos/sundar-logo.png";

import Escalated1 from "../../images/EscalatedComplaints.png";
import Onhold1 from "../../images/OnholdComplaints.png";
import Complaints from "../../images/Alert.png";
import Pending1 from "../../images/PendingComplaints.png";
import Alarm from "../../images/alarm.png";
import Reports1 from "../../images/Reports.png";
import smartphone from "../../images/smartphone.png";
import Resolved1 from "../../images/ResolvedComplaints.png";
import Working1 from "../../images/WorkingComplaints.png";
import bell from "../../images/bell.png";
import closeIconWhite from "../../images/close_icon_white.png";
import circleIcon from "../../images/dashboard/Circle.png";
import divisionIcon from "../../images/dashboard/Division.png";
import subDivisionIcon from "../../images/dashboard/Sub-Division.png";
import trendingUpIcn from "../../images/dashboard/green_arrow_icon.png";
import trendingDownIcn from "../../images/dashboard/red_arrow_icon.png";
import EOps from "../../images/eops.png";
import feederIcon1 from "../../images/feedericon.png";
import Home1 from "../../images/home.png";
import InfoImage from "../../images/informationButton.png";
import Key1 from "../../images/key.png";
import lineman1 from "../../images/lineman.png";
import Logout1 from "../../images/log-out.png";
import PDF1 from "../../images/pdf.png";
import complaints from "../../images/sidebaricons/complaints.jpeg";
import cnicupdation from "../../images/sidebaricons/small/CNIC Updation.png";
import companyIcon from "../../images/sidebaricons/small/Company.png";
import duplicateBill from "../../images/sidebaricons/small/Duplicate Bill.png";
import amendDuplicateBill from "../../images/amendDuplicateBill.png";
import partPayment from "../../images/partPayment.png";
import adjustLastBill from "../../images/adjustLastBill.png";

import supportCenterIcon from "../../images/sidebaricons/small/Facilitation Centre.png";
import meterChangeRequest from "../../images/sidebaricons/small/Meter Change Request.png";
import permissionManagement from "../../images/sidebaricons/small/Permission Management.png";
import installments from "../../images/sidebaricons/small/bill installment icon.png";
import usermanagement from "../../images/sidebaricons/small/businessman.png";
import ChangeOfName1 from "../../images/sidebaricons/small/change_name_load_icon.png";
import dateextension1 from "../../images/sidebaricons/small/date_extention_icon.png";
import Disconnection1 from "../../images/sidebaricons/small/disconnection_icon.png";
import ChangeOfLoad1 from "../../images/sidebaricons/small/extention_load_icon.png";
import GIS from "../../images/sidebaricons/small/map.png";
import OptForNetMetering1 from "../../images/sidebaricons/small/net_meter_icon.png";
import NewConnection1 from "../../images/sidebaricons/small/new_connection_icon.png";
import readingcorrection1 from "../../images/sidebaricons/small/reading_correction_icon.png";
import ChangeOfTariff1 from "../../images/sidebaricons/small/reduction_load_icon.png";
import roleMgmt from "../../images/sidebaricons/small/role management.png";
import transformer1 from "../../images/transformer.png";

import apmsdashboard from "../../images/apmsdashboard.png";
import MEPCOWaterMark from "../../images/DiscosWater/mepcco-watermark.png";
import LESCOWaterMark from "../../images/DiscosWater/lescowatermark.png";
import IESCOWaterMark from "../../images/DiscosWater/iescowatermark.png";
import FESCOWaterMark from "../../images/DiscosWater/fesco-watermark.png";
import GEPCOWaterMark from "../../images/DiscosWater/gepco-watermark.png";
import HAZECOWaterMark from "../../images/DiscosWater/hazeco-watermark.png";
import HESCOWaterMark from "../../images/DiscosWater/hesco-watermark.png";
import TESCOWaterMark from "../../images/DiscosWater/tesco-watermark.png";
import SEPCOWaterMark from "../../images/DiscosWater/sepco-watermark.png";
import PESCOWaterMark from "../../images/DiscosWater/pesco-watermark.png";
import QESCOWaterMark from "../../images/DiscosWater/qesco-watermark.png";
import home1 from "../../images/home.png";
import IESCODDLOGO from "../../images/discologos/iesco logo.png";
import FESCODDLOGO from "../../images/discologos/fesco.jpg";
import GEPCODDLOGO from "../../images/discologos/gepco.jpg";
import HAZECODDLOGO from "../../images/discologos/hazeco_logo-removebg-preview.png";
import HESCODDLOGO from "../../images/discologos/hesco logo.png";
import LESCODDLOGO from "../../images/discologos/lesco.jpg";
import MEPCODDLOGO from "../../images/discologos/mepco1.jpg";
import PESCODDLOGO from "../../images/discologos/pesco1.jpg";
import PITCDDLOGO from "../../images/discologos/pitc11-removebg-preview.png";
import QESCODDLOGO from "../../images/discologos/qesco.png";
import SEPCODDLOGO from "../../images/discologos/sepco.jpg";
import TESCODDLOGO from "../../images/discologos/tesco.jpg";
import { Menu } from "antd";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import batchIcon from "../../images/batchWarning.png";
import eOpsLogo from "../../images/eops.png";
import excel from "../../images/excel.png";
import mepcoLogo from "../../images/mepcoLogo.png";
import pdf from "../../images/pdf.png";
import pencilIcon from "../../images/pencil.png";
import print from "../../images/print.png";
import Profile1 from "../../images/user-edit.png";
import {
  deleteWFData,
  getFieldStaffDesignations,
  getWorkforceData,
} from "../../network/APIs/APIs";
import { cfpBaseUrl, cpBaseUrl, wfsBaseUrl } from "../../network/urls";
import {
  convertDatewithTime,
  convertDateYYYYMMDD,
  dBillAPI,
  getName,
  numberFormatting,
  officeName,
  subdivisionName,
  companyShortName,
  permissionsVariables,
} from "../../services/Functions";
import { internalIconStyles } from "../../style/common";
import {
  BulkDistributionTheft,
  damagedMeter,
  DelayedBillingNewConnection,
  DetectionBill,
  electricFire,
  ElectricityTheft,
  fluctuation,
  imageExtensions,
  InstalledTransformerMeterWireTheft,
  lineFault,
  lowVoltageLongTerm,
  lowVoltageShortTerm,
  MeterPosition,
  NonDeliveryofBill,
  otherComplaintsArray,
  otherComplaintsArrayCommerical,
  others,
  passwordRegex,
  powerOutage,
} from "../../utils/PortalName";
import SearchPopup from "../SearchPopups/SearchPopup";
import SearchResultsPopup from "../SearchPopups/SearchResultsPopup";
import Error from "../error/error";
import Time from "../time/time";
import "./sidebar.scss";

import { fetchDivisionGeoJson } from "../../features/geoJson/divisionGeoJson";
import AddButton from "../AddButton/AddButton";
import { useSearchFormik } from "../../hooks/useSearchFormik";
import JsBarcode from "jsbarcode";
import mepcologo from "../../images/mepcoLogo.png";
import watermarkLowReso from "../../images/DiscosWater/mepcco-watermark.png";
import UserIcon from "../../images/user.jpg";
import staffPerformance from "../../images/staffperformance.png";
import pitcLogo from "../../images/pitc.png";
import Success from "../success/success";
import APMSComplaintsSummary from "../../pages/PowerComplaints/Complaints/APMSComplaintsSummary";

const IconWithLabel = (icon, label) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        gap: "5px",
      }}
    >
      <img src={icon} alt={label} width="25" height="25" /> {label}
    </div>
  );
};

const Sidebar = () => {
  const {
    code: userCode,
    name: userName,
    roleName: userRole,
    wmsPrivateToken,
  } = useSelector((state) => state.auth);

  const {
    userId,
    token,
    cscID,
    permissions,
    code,
    hierarchy,
    showAllApplicationsFlag,
    name,
    roleName,
    profilePicture,
    roleTypeId,
    phoneNo,
    roleId,
    cnic,
    email,
    circleCode,
    cfcLevelId,
    roleTypeName,
  } = useSelector((state) => state.auth);
  const {
    totalNewConnectionApplications,
    totalChangeOfLoadApplications,
    totalChangeOfNameApplications,
    totalChangeOfTariffApplications,
    totalChangeOfMeterRequrestApplications,
    totalOptForSmartMeterApplications,
    totalDueDateExtensionApplications,
    totalBillInstallmentApplications,
    totalComplaintsApplications,
    totalMeterReadingCorrectionApplications,
    totalNetMeteringApplications,
    error,
  } = useSelector((state) => state.stats);

  const [pendings, setPendings] = useState([]);

  const { totalRecords: totalActionablesNormal } = useSelector(
    (state) => state.actionableNormal,
  );
  const { totalRecords: totalActionablesOverdue } = useSelector(
    (state) => state.actionableOverdue,
  );

  const [openAmendBillPopup, setOpenAmendBillPopup] = useState(false);
  const [success, setSuccess] = useState(false);

  const onCloseAmendBillPopup = () => {
    setOpenAmendBillPopup(false);
  };
  const logoutfunction = async () => {
    const sessionId = sessionStorage.getItem("sessionId");
    let tabs = JSON.parse(localStorage.getItem("appTabs"));
    tabs = tabs.filter((id) => id != sessionId);
    localStorage.setItem("appTabs", JSON.stringify(tabs));

    await callLogoutAPI();
    dispatch(resetStateNcNormal());
    dispatch(resetStateNcOverdue());
    dispatch(resetStateConNormal());
    dispatch(resetStateConOverdue());
    dispatch(resetStateColNormal());
    dispatch(resetStateColOverdue());
    dispatch(resetStateCotNormal());
    dispatch(resetStateCotOverdue());
    dispatch(resetStateDueDate());
    dispatch(resetStateInstallmentsNormal());
    dispatch(resetStateInstallmentsOverdue());
    dispatch(removeStats());
    dispatch(resetOverallPerformanceState());
    dispatch(resetFeederStatusState());
    dispatch(resetGeoJsonState());
    dispatch(resetActionableNormal());
    dispatch(resetActionableOverdue());
    dispatch(resetStateAllComplaints());
    dispatch(signOut());
  };

  const items = [
    {
      key: "OperationalPerformance",
      icon: IconWithLabel(Home1, permissionsVariables.operationalPerformance),
      label: "",
      onClick: () => handleItemClick("OperationalPerformance"),
      permission: CheckPermissions(
        permissions,
        "Dashboard",
        permissionsVariables.operationalPerformance,
      ),
    },
    {
      key: "CFCDashboard",
      icon: <></>,
      label: "Dashboard",
      onClick: () => handleItemClick("CFCDashboard"),
      permission: CheckPermissions(permissions, "Dashboard", "CFC Dashboard"),
    },
    {
      key: "CFCPerformance",
      icon: <></>,
      label: "CFC Performance",
      onClick: () => handleItemClick("CFCPerformance"),
      permission: CheckPermissions(
        permissions,
        "Dashboard",
        permissionsVariables.commercialOperations,
      ),
    },
    {
      key: "FieldOfficeDashboard",
      icon: <></>,
      label: "Tech & Comm Dashboard",
      onClick: () => handleItemClick("FieldOfficeDashboard"),
      permission: CheckPermissions(
        permissions,
        "Dashboard",
        "Field Office Dashboard",
      ),
    },
    {
      key: permissionsVariables.commercialOperations,
      label: permissionsVariables.commercialOperations,
      onClick: () => handleItemClick("CommercialPerformance"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.generalServices,
      ),
      icon: <></>,
      children: [
        {
          key: "Actionables",
          label: "",
          icon: IconWithLabel(bell, "Actionables"),
          onClick: () => handleItemClick("Actionables"),
          permission:
            (totalActionablesNormal || totalActionablesOverdue) &&
            (CheckPermissions(
              permissions,
              permissionsVariables.generalServices,
            ) ||
              CheckPermissions(
                permissions,
                permissionsVariables.billingAndCollection,
              )),
        },
        {
          key: "NewConnection",
          label: "",
          icon: IconWithLabel(NewConnection1, "New Connection"),
          onClick: () => handleItemClick("NewConnection"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.newConnection,
          ),
        },
        {
          key: "DueDateExt",
          label: "",
          icon: IconWithLabel(dateextension1, "Due Date Ext."),
          onClick: () => handleItemClick("DueDateExt"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.billingAndCollection,
            permissionsVariables.dueDateExtension,
          ),
        },
        {
          key: "BillInstallments",
          label: "",
          icon: IconWithLabel(installments, "Bill Installments"),
          onClick: () => handleItemClick("BillInstallments"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.billingAndCollection,
            permissionsVariables.billInstallments,
          ),
        },
        {
          key: "AmendDuplicateBill",
          label: "",
          icon: IconWithLabel(amendDuplicateBill, "Amend Duplicate Bill"),
          onClick: () => handleItemClick("AmendDuplicateBill"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.amendDuplicateBill,
          ),
        },
        {
          key: "amendBill2636",
          label: "",
          icon: IconWithLabel(partPayment, "Part Payment"),
          onClick: () => handleItemClick("AmendBill2636"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.partPayment,
          ),
        },
        // { key: 'SetAside', label: '', icon: IconWithLabel(installments, 'Set Aside / Withdrawal ('.concat('0', ")")), onClick: () => handleItemClick('SetAside'), permission: CheckPermissions(permissions, permissionsVariables.billingAndCollection, "Installments") },
        {
          key: "Reconnection",
          label: "",
          icon: IconWithLabel(NewConnection1, "Reconnection"),
          onClick: () => handleItemClick("Reconnection"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.reConnection,
          ),
        },
        // { key: 'BillCorrection', label: '', icon: IconWithLabel(NewConnection1, 'Bill Correction ('.concat('0', ")")), onClick: () => handleItemClick('BillCorrection'), permission: CheckPermissions(permissions, permissionsVariables.generalServices, "Reconnection") },
        // { key: 'MeterReadingCorrection', label: '', icon: IconWithLabel(bell, 'Meter Reading Correction'), onClick: () => handleItemClick('MeterReadingCorrection'), permission: CheckPermissions(permissions, permissionsVariables.billingAndCollection, "Meter Reading Correction") },
        {
          key: "ChangeofAttributes",
          label: "",
          icon: IconWithLabel(ChangeOfName1, "Change of Attributes"),
          onClick: () => handleItemClick("ChangeOfName"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.newConnection,
          ),
        },
        {
          key: "AdjustLastBill",
          label: "",
          icon: IconWithLabel(adjustLastBill, "Adjust Last Bill"),
          onClick: () => handleItemClick("AdjustLastBill"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.adjustLastBill,
          ),
        },

        // {
        //   key: 'ChangeofAttributes', label: 'Change of Attributes',
        //   onClick: () => handleItemClick('ChangeofAttributed'),
        //   permission: CheckPermissions(permissions, permissionsVariables.generalServices, "Change of Attributes"),
        //   icon: IconWithLabel(ChangeOfName1, 'Change of Attributes'), children: [
        //     { key: 'ChangeOfName', label: '', onClick: () => handleItemClick('ChangeOfName'), icon: IconWithLabel(ChangeOfName1, 'Change of Name'), permission: CheckPermissions(permissions, permissionsVariables.generalServices, "Change of Attributes"), },
        //     { key: 'ChangeOfLoad', label: '', onClick: () => handleItemClick('ChangeOfLoad'), icon: IconWithLabel(ChangeOfLoad1, 'Change of Load'), permission: CheckPermissions(permissions, permissionsVariables.generalServices, "Change of Attributes"), },
        //     { key: 'ChangeOfTariff', label: '', onClick: () => handleItemClick('ChangeOfTariff'), icon: IconWithLabel(ChangeOfTariff1, 'Change of Tariff'), permission: CheckPermissions(permissions, permissionsVariables.generalServices, "Change of Attributes"), },
        //   ],
        // },
        // { key: 'ShiftToNetMeter', label: '', icon: IconWithLabel(OptForNetMetering1, 'Shift To Net Meter ('.concat(totalNetMeteringApplications ? numberFormatting(totalNetMeteringApplications) : "0", ")")), onClick: () => handleItemClick('ShiftToNetMeter'), permission: CheckPermissions(permissions, permissionsVariables.generalServices, "Shift to Net Meter"), },
        {
          key: "UpdateTenantCNIC",
          label: "",
          icon: IconWithLabel(cnicupdation, "Update Tenant CNIC"),
          onClick: () => handleItemClick("UpdateTenantCNIC"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.tenantCNICUpdation,
          ),
        },
        {
          key: "MeterChangeRequest",
          label: "",
          icon: IconWithLabel(meterChangeRequest, "Meter Change Order"),
          onClick: () => handleItemClick("MeterChangeRequest"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.generalServices,
            permissionsVariables.mco,
          ),
        },
        {
          key: "DuplicateBill",
          label: "",
          icon: IconWithLabel(duplicateBill, "Duplicate Bill"),
          onClick: () => handleItemClick("DuplicateBill"),
          permission: true,
        },
        // { key: 'PowerComplaintTable', label: '', icon: IconWithLabel(complaints, 'Power Complaints ('.concat(totalComplaintsApplications ? numberFormatting(totalComplaintsApplications) : "0", ")")), onClick: () => handleItemClick('PowerComplaintTable'), permission: true },
        // { key: 'Wrong Reading', label: '', icon: IconWithLabel(complaints, 'Wrong Reading ('.concat(totalComplaintsApplications ? numberFormatting(totalComplaintsApplications) : "0", ")")), onClick: () => handleItemClick('WrongReadingTable'), permission: true },
        {
          key: "CommercialReports",
          label: "",
          icon: IconWithLabel(Reports1, "Reports / Summary"),
          onClick: () => handleItemClick("CommercialReports"),
          permission: true,
          children: [
            {
              key: "NewConnectionReports",
              label: "",
              icon: IconWithLabel(Reports1, "New Connection Reports"),
              onClick: () => handleItemClick("NewConnectionReports"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                permissionsVariables.newConnection,
              ),
              children: [
                {
                  key: "NewConnectionReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "New Connection Summary"),
                  onClick: () => handleItemClick("NewConnectionReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "New Connection Summary",
                  ),
                },
                {
                  key: "NewConnectionPostedToIBSReport",
                  label: "",
                  icon: IconWithLabel(
                    Reports1,
                    "New Connection Posted for Proof Listing",
                  ),
                  onClick: () =>
                    handleItemClick("NewConnectionPostedToIBSReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "Posted to IBS for Proof Listin",
                  ),
                },
                {
                  key: "NewConnectionSubDivisionWiseApplicationsStatus",
                  label: "",
                  icon: IconWithLabel(
                    Reports1,
                    "New Connection Exceeded Application Summary",
                  ),
                  onClick: () =>
                    handleItemClick(
                      "NewConnectionSubDivisionWiseApplicationsStatus",
                    ),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "Exceeded Applicaitons",
                  ),
                },
                {
                  key: "NewConnectionStatusReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "New Connection Status Report"),
                  onClick: () => handleItemClick("NewConnectionStatusReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "Status Report",
                  ),
                },
                {
                  key: "NewConnectionStatusWiseCountReport",
                  label: "",
                  icon: IconWithLabel(
                    Reports1,
                    "New Connection Status Wise Count Report",
                  ),
                  onClick: () =>
                    handleItemClick("NewConnectionStatusWiseCountReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "NC Status-wise Count Report",
                  ),
                },
                {
                  key: "SrReports",
                  label: "",
                  icon: IconWithLabel(Reports1, "SR NC Report"),
                  onClick: () => handleItemClick("SrOnEmail"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.newConnection,
                    "New Connection SR",
                  ),
                },
              ],
            },
            {
              key: "ChangeOfAttributesReports",
              label: "",
              icon: IconWithLabel(Reports1, "Change of Attributes Reports"),
              onClick: () => handleItemClick("ChangeOfAttributesReports"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                permissionsVariables.changeOfAttributes,
              ),
              children: [
                {
                  key: "COASrReports",
                  label: "",
                  icon: IconWithLabel(Reports1, "SR COA Report"),
                  onClick: () => handleItemClick("COASrOnEmail"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    permissionsVariables.changeOfAttributes,
                  ),
                },
              ],
            },
            {
              key: "DueDateExtensionReport",
              label: "",
              icon: IconWithLabel(Reports1, "Due Date Extension Report"),
              onClick: () => handleItemClick("DueDateExtensionReport"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Due Date Extension Report",
              ),
            },
            {
              key: "InstallmentReport",
              label: "",
              icon: IconWithLabel(Reports1, "Installment Reports"),
              onClick: () => handleItemClick("InstallmentReport"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Installment Report",
              ),
            },
            // {
            //   key: "MeterReadingCorrectionReport",
            //   label: "",
            //   icon: IconWithLabel(Reports1, "Meter Reading Correction Report"),
            //   onClick: () => handleItemClick("MeterReadingCorrectionReport"),
            //   permission: CheckPermissions(
            //     permissions,
            //     permissionsVariables.generalServices,
            //     permissionsVariables.reports,
            //     "Meter Reading Correction"
            //   ),
            // },
            {
              key: "CashCollectionReport",
              label: "",
              icon: IconWithLabel(Reports1, "Cash Collection Report"),
              onClick: () => handleItemClick("CashCollectionReport"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Cash Collection Report",
              ),
              children: [
                {
                  key: "CashCollectionSummaryReport",
                  label: "",
                  icon: IconWithLabel(Reports1, "Cash Collection Summary"),
                  onClick: () => handleItemClick("CashCollectionSummaryReport"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    "Cash Collection Report",
                  ),
                },
                {
                  key: "BatchWiseAssessment",
                  label: "",
                  icon: IconWithLabel(Reports1, "(Batch-Wise) Assessment"),
                  onClick: () => handleItemClick("BatchWiseAssessment"),
                  permission: CheckPermissions(
                    permissions,
                    permissionsVariables.generalServices,
                    permissionsVariables.reports,
                    "Cash Collection Report",
                  ),
                },
              ],
            },
            {
              key: "DailyProgressReport",
              label: "",
              icon: IconWithLabel(Reports1, "Daily Progress Report"),
              onClick: () => handleItemClick("DailyProgressReport"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Daily Progress Report",
              ),
            },
            {
              key: "FeederLossesReport",
              label: "",
              icon: IconWithLabel(Reports1, "Feeder Losses Report"),
              onClick: () => handleItemClick("FeederLossesReport"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Feeder Losses Report",
              ),
            },
            {
              key: "DeadDefaulterReport",
              label: "",
              icon: IconWithLabel(Reports1, "Dead Defaulter Report"),
              onClick: () => handleItemClick("DeadDefaulterReport"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Dead Defaulter Report",
              ),
            },
            {
              key: "ComputedBillingAndCollectionAnalysis",
              label: "",
              icon: IconWithLabel(
                Reports1,
                "Collection Vs Computed Assessment (Category Wise)",
              ),
              onClick: () =>
                handleItemClick("ComputedBillingAndCollectionAnalysis"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.generalServices,
                permissionsVariables.reports,
                "Collection Vs Computed Assessm",
              ),
            },
          ],
        },
        // {
        //   key: 'SrReports', label: 'SR Reports',permission: true,
        //   onClick: () => handleItemClick('SrReports'),
        //   permission: CheckPermissions(permissions, 'General Services', 'Reports', "New Connection SR"),
        //   icon: IconWithLabel(ChangeOfName1, 'SR Reports'), children: [
        //     { key: 'SrOnEmail', label: '', onClick: () => handleItemClick('SrOnEmail'), icon: IconWithLabel(ChangeOfName1, 'Sr On Email'), },
        //   ],
        // },
      ],
    },
    {
      key: "TechnicalOperations",
      label: "Technical Operations",
      icon: <></>,
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
      ),
      children: [
        {
          key: "NewComplaint",
          label: "",
          onClick: () => handleItemClick("NewComplaint"),
          icon: IconWithLabel(complaints, "New Complaint"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "New Complaint",
          ),
        },
        {
          key: "LoggedInUsers",
          label: "",
          onClick: () => handleItemClick("LoggedInUsers"),
          icon: IconWithLabel(permissionManagement, "Logged In Users"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Logged In Users",
          ),
        },
        {
          key: "LinemanAPPUserSummary",
          label: "",
          onClick: () => handleItemClick("LinemanAPPUserSummary"),
          icon: IconWithLabel(permissionManagement, "Logged In User Summary"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "User Logged In Summary",
          ),
        },
        {
          key: "ComplaintAndControlCenter",
          label: "",
          icon: IconWithLabel(GIS, "Complaint and Control Center"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
          ),
          children: [
            {
              key: "CircleHome",
              label: "",
              onClick: () => {
                dispatch(updateHomeButton(true));
              },
              icon: IconWithLabel(home1, "Home"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Technical Dashboard",
              ),
            },
            {
              key: "NewComplaintCCC",
              label: "",
              onClick: () => handleItemClick("NewComplaint"),
              icon: IconWithLabel(complaints, "New Complaint"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "New Complaint",
              ),
            },
            {
              key: "Map",
              label: "",
              onClick: () => handleItemClick("ComplaintAndControlCenter"),
              icon: IconWithLabel(GIS, "Map"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "ComplaintAndControlCenter",
              ),
            },
            {
              key: "FeederList",
              label: "",
              onClick: () => handleItemClick("FeederList"),
              icon: IconWithLabel(feederIcon1, "Feeder List"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Feeder List",
              ),
            },
            {
              key: "ApmsList",
              label: "",
              onClick: () => handleItemClick("ApmsList"),
              icon: IconWithLabel(transformer1, "APMS List"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "APMS List",
              ),
            },
            {
              key: "APMSDashboard",
              label: "",
              onClick: () => handleItemClick("APMSDashboard"),
              icon: IconWithLabel(transformer1, "APMS Dashboard"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "APMS List",
              ),
            },

            {
              key: "Linemen",
              label: "",
              onClick: () => handleItemClick("Linemen"),
              icon: IconWithLabel(lineman1, "Linemen"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Line Staff",
              ),
            },
          ],
        },
        // { key: 'LineStaffPerformance', label: '', onClick: () => handleItemClick('LineStaffPerformance'), icon: IconWithLabel(staffPerformance, 'Line Staff Performance'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Line Staff Performance'), },
        {
          key: "LoadSheddingSchedule",
          label: "",
          onClick: () => handleItemClick("LoadSheddingSchedule"),
          icon: IconWithLabel(Disconnection1, "Load Shedding Schedule"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Load Shedding Schedule",
          ),
        },
        {
          key: "MobileAppStats",
          label: "Mobile App Stats",
          onClick: () => handleItemClick("MobileAppStats"),
          icon: IconWithLabel(smartphone, "Mobile App Stats"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Power Smart Mobile App Summary",
          ),
        },
        {
          key: "Complaints Management",
          label: "Complaints Management",
          icon: IconWithLabel(Complaintsmanagemnt, "Complaints Management"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
          ),
          children: [
            {
              key: "PendingComplaints",
              label: "Pending Complaints",
              onClick: () => handleItemClick("PendingComplaints"),
              icon: IconWithLabel(Pending1, "Pending Complaints"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Pending Complaints",
              ),
            },
            {
              key: "AllocatedComplaints",
              label: "Allocated Complaints",
              onClick: () => handleItemClick("AllocatedComplaints"),
              icon: IconWithLabel(Allocated1, "Allocated Complaints"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Allocated Complaints",
              ),
            },
            {
              key: "WorkingComplaints",
              label: "Working Complaints",
              onClick: () => handleItemClick("WorkingComplaints"),
              icon: IconWithLabel(Working1, "Working Complaints"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Working Complaints",
              ),
            },
            {
              key: "OnholdComplaints",
              label: "Onhold Complaints",
              onClick: () => handleItemClick("OnholdComplaints"),
              icon: IconWithLabel(Onhold1, "Onhold Complaints"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Onhold Complaints",
              ),
            },
            {
              key: "EscalatedComplaints",
              label: "Escalated Complaints",
              onClick: () => handleItemClick("EscalatedComplaints"),
              icon: IconWithLabel(Escalated1, "Escalated Complaints"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Escalated Complaints",
              ),
            },

            // {
            //   key: "APMSSummaryReport",
            //   label: "APMS Summary Report",
            //   onClick: () => handleItemClick("APMSSummaryReport"),
            //   icon: IconWithLabel(Reports1, "APMS Summary Report"),
            //   permission: true
            // },
            {
              key: "APMSEscalatedComplaints",
              label: "APMS Escalated Complaints",
              onClick: () => handleItemClick("APMSEscalatedComplaints"),
              icon: IconWithLabel(Escalated1, "APMS Escalated"),
              permission: true,
            },
            // {
            //   key: "APMSComplaintsSummary",
            //   label: "APMS Complaints Summary",
            //   onClick: () => handleItemClick("APMSComplaintsSummary"),
            //   icon: IconWithLabel(Reports1, "APMS Complaints Summary"),
            //   permission: true,
            // },
            {
              key: "ResolvedComplaints",
              label: "Resolved Complaints",
              onClick: () => handleItemClick("ResolvedComplaints"),
              icon: IconWithLabel(Resolved1, "Resolved Complaints"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Resolved Complaints",
              ),
            },
          ],
        },
        {
          key: "ComplaintsReports",
          label: "ComplaintsReports",
          onClick: () => handleItemClick("ComplaintsReports"),
          icon: IconWithLabel(Reports1, "Reports / Summary"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
          ),
          children: [
            {
              key: "ComplaintRegister",
              label: "Complaint Register",
              onClick: () => handleItemClick("ComplaintRegister"),
              icon: IconWithLabel(Reports1, "Complaint Register"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Complaint Register",
              ),
            },
            {
              key: "EscalationComplaints",
              label: "Escalation Complaints",
              onClick: () => handleItemClick("EscalationComplaints"),
              icon: IconWithLabel(Reports1, "Escalation Complaints"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Escalation Complaints",
              ),
            },
            {
              key: "ComplaintsSummary",
              label: "Complaints Summary",
              onClick: () => handleItemClick("ComplaintsSummary"),
              icon: IconWithLabel(Reports1, "Complaints Summary"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                "Complaint Summary",
              ),
            },
            {
              key: "EopsMobileAppUsageSummary",
              label: "EopsMobileAppUsageSummary",
              onClick: () => handleItemClick("EopsMobileAppUsageSummary"),
              icon: IconWithLabel(Reports1, "eOps Mobile App Usage Summary"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                permissionsVariables.reports,
                "eOps Mobile App Usage Summary",
              ),
            },
            {
              key: "NotLoggedInUserInLast24Hours",
              label: "NotLoggedInUserInLast24Hours",
              onClick: () => handleItemClick("NotLoggedInUserInLast24Hours"),
              icon: IconWithLabel(
                Reports1,
                "Not Logged In User In Last 24 Hours",
              ),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                permissionsVariables.reports,
                "Not logged in Users",
              ),
            },
            {
              key: "EopsUsersStatus",
              label: "EopsUsersStatus",
              onClick: () => handleItemClick("EopsUsersStatus"),
              icon: IconWithLabel(Reports1, "Eops Users Status"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                permissionsVariables.reports,
                "eOps Users Status Report",
              ),
            },
            {
              key: "ComplaintSourceWise",
              label: "ComplaintSourceWise",
              onClick: () => handleItemClick("ComplaintSourceWise"),
              icon: IconWithLabel(Reports1, "Source & Complaint Type Wise"),
              permission: CheckPermissions(
                permissions,
                permissionsVariables.powerComplaints,
                permissionsVariables.reports,
                "eOps Users Status Report",
              ),
            },
            {
              key: "TopBestAndWorstPerformer",
              label: "TopBestAndWorstPerformer",
              onClick: () => handleItemClick("TopBestAndWorstPerformer"),
              icon: IconWithLabel(
                Reports1,
                "Top Best And Worst Field Staff Performer",
              ),
              permission:
                CheckPermissions(
                  permissions,
                  permissionsVariables.powerComplaints,
                  permissionsVariables.reports,
                  permissionsVariables.staffPerformance,
                  "Top 5% Best Performers",
                ) ||
                CheckPermissions(
                  permissions,
                  permissionsVariables.powerComplaints,
                  permissionsVariables.reports,
                  permissionsVariables.staffPerformance,
                  "Worst 10% Non-Performers",
                ),
            },
            // { key: 'PendingComplaints', label: 'Pending Complaints', onClick: () => handleItemClick('PendingComplaints'), icon: IconWithLabel(Pending1, 'Pending Complaints'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Pending Complaints'), },
            // { key: 'AllocatedComplaints', label: 'Allocated Complaints', onClick: () => handleItemClick('AllocatedComplaints'), icon: IconWithLabel(Allocated1, 'Allocated Complaints'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Allocated Complaints'), },
            // { key: 'WorkingComplaints', label: 'Working Complaints', onClick: () => handleItemClick('WorkingComplaints'), icon: IconWithLabel(Working1, 'Working Complaints'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Working Complaints'), },
            // { key: 'OnholdComplaints', label: 'Onhold Complaints', onClick: () => handleItemClick('OnholdComplaints'), icon: IconWithLabel(Onhold1, 'Onhold Complaints'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Onhold Complaints'), },
            // { key: 'EscalatedComplaints', label: 'Escalated Complaints', onClick: () => handleItemClick('EscalatedComplaints'), icon: IconWithLabel(Escalated1, 'Escalated Complaints'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Escalated Complaints'), },
            // { key: 'ResolvedComplaints', label: 'Resolved Complaints', onClick: () => handleItemClick('ResolvedComplaints'), icon: IconWithLabel(Resolved1, 'Resolved Complaints'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Resolved Complaints'), },

            // { key: 'ResolvedComplaints', label: 'Logout', onClick: () => handleItemClick('ResolvedComplaints'), icon: IconWithLabel(Resolved1, 'Logout'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints), },
          ],
        },
      ],
    },
    {
      key: "AccessManagement",
      icon: <></>,
      label: "Access Management",
      permission: CheckPermissions(
        permissions,
        permissionsVariables.accessManagement,
      ),
      onClick: () => handleItemClick("AccessManagement"),
      // children: [
      //   { key: 'WorkforceManagement', label: '', onClick: () => handleItemClick('WorkforceManagement'), icon: IconWithLabel(usermanagement, 'Workforce Management'), permission: CheckPermissions(permissions, permissionsVariables.accessManagement, 'User Management') },
      //   { key: 'UserManagement', label: '', onClick: () => handleItemClick('UserManagement'), icon: IconWithLabel(usermanagement, 'User Management'), permission: CheckPermissions(permissions, permissionsVariables.accessManagement, 'User Management') },
      //   { key: 'RoleManagement', label: '', onClick: () => handleItemClick('RoleManagement'), icon: IconWithLabel(roleMgmt, 'Role Management'), permission:   CheckPermissions(permissions, permissionsVariables.accessManagement, 'Role Management') },
      //   { key: 'PermissionManagement', label: '', onClick: () => handleItemClick('PermissionManagement'), icon: IconWithLabel(permissionManagement, 'Permission Management'), permission:  CheckPermissions(permissions, permissionsVariables.accessManagement, 'Role Management') },
      // ]
      children: [
        {
          key: "WorkforceManagement",
          label: "",
          onClick: () => handleItemClick("WorkforceManagement"),
          icon: IconWithLabel(usermanagement, "Workforce Management"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.accessManagement,
            "Workforce Management",
          ),
        },
        {
          key: "UserManagement",
          label: "",
          onClick: () => handleItemClick("UserManagement"),
          icon: IconWithLabel(usermanagement, "User Management"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.accessManagement,
            "User Management",
          ),
        },
        ...(code === "10"
          ? [
              {
                key: "RoleManagement",
                label: "",
                onClick: () => handleItemClick("RoleManagement"),
                icon: IconWithLabel(roleMgmt, "Role Management"),
                permission: CheckPermissions(
                  permissions,
                  permissionsVariables.accessManagement,
                  "Role Management",
                ),
              },
              {
                key: "PermissionManagement",
                label: "",
                onClick: () => handleItemClick("PermissionManagement"),
                icon: IconWithLabel(
                  permissionManagement,
                  "Permission Management",
                ),
                permission: CheckPermissions(
                  permissions,
                  permissionsVariables.accessManagement,
                  "Permission Management",
                ),
              },
            ]
          : []),
      ],
    },
    {
      key: "OrganizationManagement",
      icon: <></>,
      label: "Organization Management",
      onClick: () => handleItemClick("OrganizationManagement"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.organizationManagement,
      ),
      children: [
        {
          key: "Company",
          label: "",
          onClick: () => handleItemClick("Company"),
          icon: IconWithLabel(companyIcon, "Company"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.organizationManagement,
            "Company Management",
          ),
        },
        {
          key: "Circle",
          label: "",
          onClick: () => handleItemClick("Circle"),
          icon: IconWithLabel(circleIcon, "Circle"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.organizationManagement,
            "Circle Management",
          ),
        },
        {
          key: "Division",
          label: "",
          onClick: () => handleItemClick("Division"),
          icon: IconWithLabel(divisionIcon, "Division"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.organizationManagement,
            "Division Management",
          ),
        },
        {
          key: "CFC",
          label: "",
          onClick: () => handleItemClick("CFC"),
          icon: IconWithLabel(
            supportCenterIcon,
            "Customer Facilitation Center",
          ),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.organizationManagement,
            "CSC Management",
          ),
        },
        {
          key: "SubDivision",
          label: "",
          onClick: () => handleItemClick("SubDivision"),
          icon: IconWithLabel(subDivisionIcon, "Sub Division"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.organizationManagement,
            "Sub Division Management",
          ),
        },
      ],
    },
    {
      key: "EopsUpdates",
      icon: <></>,
      label: "eOps Updates",
      onClick: () => handleItemClick("EopsUpdates"),
      permission:
        code == 10 &&
        CheckPermissions(
          permissions,
          permissionsVariables.accessManagement,
          "eOps Updates",
        ),
    },
  ];

  const tacItems = [
    // { icon: IconWithLabel(home1, 'Home'),  permission: CheckPermissions(permissions, permissionsVariables.powerComplaints), },
    {
      key: "HomeTac",
      label: "",
      onClick: () => handleItemClick("HomeTac"),
      icon: IconWithLabel(home1, "Home"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Technical Dashboard",
      ),
    },
    {
      key: "NewComplaint",
      label: "",
      onClick: () => handleItemClick("NewComplaint"),
      icon: IconWithLabel(complaints, "New Complaint"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "New Complaint",
      ),
    },
    {
      key: "ComplaintAndControlCenter",
      label: "",
      onClick: () => handleItemClick("ComplaintAndControlCenter"),
      icon: IconWithLabel(GIS, "ComplaintAndControlCenter"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "ComplaintAndControlCenter",
      ),
    },
    {
      key: "FeederList",
      label: "",
      onClick: () => handleItemClick("FeederList"),
      icon: IconWithLabel(feederIcon1, "Feeder List"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Feeder List",
      ),
    },
    {
      key: "ApmsList",
      label: "",
      onClick: () => handleItemClick("ApmsList"),
      icon: IconWithLabel(transformer1, "APMS List"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "APMS List",
      ),
    },
    {
      key: "APMSDashboard",
      label: "",
      onClick: () => handleItemClick("APMSDashboard"),
      icon: IconWithLabel(transformer1, "APMS Dashboard"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "APMS List",
      ),
    },
    // {
    //   key: "APMSDashboard",
    //   label: "",
    //   onClick: () => handleItemClick("APMSDashboard"),
    //   icon: IconWithLabel(apmsdashboard, "APMS Dashboard"),
    //   permission: CheckPermissions(
    //     permissions,
    //     permissionsVariables.powerComplaints,
    //     "APMS List"
    //   ),
    // },
    {
      key: "Linemen",
      label: "",
      onClick: () => handleItemClick("Linemen"),
      icon: IconWithLabel(lineman1, "Line Staff"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.accessManagement,
        "Workforce Management",
      ),
    },
    // { key: 'LineStaffPerformance', label: '', onClick: () => handleItemClick('LineStaffPerformance'), icon: IconWithLabel(staffPerformance, 'Line Staff Performance'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Line Staff Performance'), },
    {
      key: "LoadSheddingSchedule",
      label: "",
      onClick: () => handleItemClick("LoadSheddingSchedule"),
      icon: IconWithLabel(Disconnection1, "Load Shedding Schedule"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Load Shedding Schedule",
      ),
    },
    {
      key: "MobileAppStats",
      label: "Mobile App Stats",
      onClick: () => handleItemClick("MobileAppStats"),
      icon: IconWithLabel(smartphone, "Mobile App Stats"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Power Smart Mobile App Summary",
      ),
    },
    {
      key: "ComplaintRegister",
      label: "Complaint Register",
      onClick: () => handleItemClick("ComplaintRegister"),
      icon: IconWithLabel(Reports1, "Complaint Register"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Complaint Register",
      ),
    },
    {
      key: "APMSComplaintsSummary",
      label: "APMS Complaints Summary",
      onClick: () => handleItemClick("APMSComplaintsSummary"),
      icon: IconWithLabel(Reports1, "APMS Complaints Summary"),
      permission: true,
    },
    {
      key: "Complaints Management",
      label: "Complaints Management",
      icon: IconWithLabel(Complaintsmanagemnt, "Complaints Management"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
      ),
      children: [
        {
          key: "PendingComplaints",
          label: "Pending Complaints",
          onClick: () => handleItemClick("PendingComplaints"),
          icon: IconWithLabel(Pending1, "Pending Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Pending Complaints",
          ),
        },
        {
          key: "AllocatedComplaints",
          label: "Allocated Complaints",
          onClick: () => handleItemClick("AllocatedComplaints"),
          icon: IconWithLabel(Allocated1, "Allocated Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Allocated Complaints",
          ),
        },
        {
          key: "WorkingComplaints",
          label: "Working Complaints",
          onClick: () => handleItemClick("WorkingComplaints"),
          icon: IconWithLabel(Working1, "Working Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Working Complaints",
          ),
        },
        {
          key: "OnholdComplaints",
          label: "Onhold Complaints",
          onClick: () => handleItemClick("OnholdComplaints"),
          icon: IconWithLabel(Onhold1, "Onhold Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Onhold Complaints",
          ),
        },
        {
          key: "EscalatedComplaints",
          label: "Escalated Complaints",
          onClick: () => handleItemClick("EscalatedComplaints"),
          icon: IconWithLabel(Escalated1, "Escalated Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Escalated Complaints",
          ),
        },

        // {
        //   key: "APMSSummaryReport",
        //   label: "APMS Summary Report",
        //   onClick: () => handleItemClick("APMSSummaryReport"),
        //   icon: IconWithLabel(Reports1, "APMS Summary Report"),
        //   permission: true
        // },
        {
          key: "APMSEscalatedComplaints",
          label: "APMS Escalated Complaints",
          onClick: () => handleItemClick("APMSEscalatedComplaints"),
          icon: IconWithLabel(Escalated1, "APMS Escalated"),
          permission: true,
        },
       
        {
          key: "ResolvedComplaints",
          label: "Resolved Complaints",
          onClick: () => handleItemClick("ResolvedComplaints"),
          icon: IconWithLabel(Resolved1, "Resolved Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Resolved Complaints",
          ),
        },
      ],
    },
    {
      key: "Logout",
      label: "Logout",
      onClick: async () => logoutfunction(),
      icon: IconWithLabel(Logout1, "Logout"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
      ),
    },
  ];

  const tacItemsCircle = [
    // { icon: IconWithLabel(home1, 'Home'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints), },
    {
      key: "HomeTac",
      label: "",
      onClick: () => handleItemClick("HomeTac"),
      icon: IconWithLabel(home1, "Home"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Technical Dashboard",
      ),
    },
    {
      key: "NewComplaint",
      label: "",
      onClick: () => handleItemClick("NewComplaint"),
      icon: IconWithLabel(complaints, "New Complaint"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "New Complaint",
      ),
    },
    {
      key: "LoggedInUsers",
      label: "",
      onClick: () => handleItemClick("LoggedInUsers"),
      icon: IconWithLabel(permissionManagement, "Logged In Users"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Logged In Users",
      ),
    },
    {
      key: "LinemanAPPUserSummary",
      label: "LinemanAPPUserSummary",
      onClick: () => handleItemClick("LinemanAPPUserSummary"),
      icon: IconWithLabel(permissionManagement, "Logged In User Summary"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "User Logged In Summary",
      ),
    },
    {
      key: "ComplaintAndControlCenter",
      label: "",
      onClick: () => handleItemClick("ComplaintAndControlCenter"),
      icon: IconWithLabel(GIS, "ComplaintAndControlCenter"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "ComplaintAndControlCenter",
      ),
    },
    // { key: 'LineStaffPerformance', label: '', onClick: () => handleItemClick('LineStaffPerformance'), icon: IconWithLabel(staffPerformance, 'Line Staff Performance'), permission: CheckPermissions(permissions, permissionsVariables.powerComplaints, 'Line Staff Performance'), },
    {
      key: "LoadSheddingSchedule",
      label: "",
      onClick: () => handleItemClick("LoadSheddingSchedule"),
      icon: IconWithLabel(Disconnection1, "Load Shedding Schedule"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Load Shedding Schedule",
      ),
    },
    {
      key: "APMSDashboard",
      label: "",
      onClick: () => handleItemClick("APMSDashboard"),
      icon: IconWithLabel(transformer1, "APMS Dashboard"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Load Shedding Schedule",
      ),
    },
    // {
    //   key: "APMSDashboard",
    //   label: "",
    //   onClick: () => handleItemClick("APMSDashboard"),
    //   icon: IconWithLabel(apmsdashboard, "APMS Dashboard"),
    //   permission: CheckPermissions(
    //     permissions,
    //     permissionsVariables.powerComplaints,
    //     "Load Shedding Schedule"
    //   ),
    // },
    {
      key: "MobileAppStats",
      label: "Mobile App Stats",
      onClick: () => handleItemClick("MobileAppStats"),
      icon: IconWithLabel(smartphone, "Mobile App Stats"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
        "Power Smart Mobile App Summary",
      ),
    },
    {
      key: "Reports",
      label: "Reports / Summary",
      icon: IconWithLabel(Reports1, "Reports"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
      ),
      children: [
        {
          key: "ComplaintRegister",
          label: "Complaint Register",
          onClick: () => handleItemClick("ComplaintRegister"),
          icon: IconWithLabel(Reports1, "Complaint Register"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Complaint Register",
          ),
        },
        {
          key: "ComplaintsSummary",
          label: "Complaints Summary",
          onClick: () => handleItemClick("ComplaintsSummary"),
          icon: IconWithLabel(Reports1, "Complaints Summary"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Complaint Summary",
          ),
        },
        {
          key: "APMSComplaintsSummary",
          label: "APMS Complaints Summary",
          onClick: () => handleItemClick("APMSComplaintsSummary"),
          icon: IconWithLabel(Reports1, "APMS Complaints Summary"),
          permission: true,
        },
        {
          key: "EopsMobileAppUsageSummary",
          label: "EopsMobileAppUsageSummary",
          onClick: () => handleItemClick("EopsMobileAppUsageSummary"),
          icon: IconWithLabel(Reports1, "eOps App Usage Summary"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "eOps Mobile App Usage Summary",
          ),
        },
        {
          key: "NotLoggedInUserInLast24Hours",
          label: "NotLoggedInUserInLast24Hours",
          onClick: () => handleItemClick("NotLoggedInUserInLast24Hours"),
          icon: IconWithLabel(Reports1, "Not Logged In User In Last 24 Hours"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "Not logged in Users",
          ),
        },
        {
          key: "EopsUsersStatus",
          label: "EopsUsersStatus",
          onClick: () => handleItemClick("EopsUsersStatus"),
          icon: IconWithLabel(Reports1, "Eops Users Status"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "eOps Users Status Report",
          ),
        },
        {
          key: "ComplaintSourceWise",
          label: "ComplaintSourceWise",
          onClick: () => handleItemClick("ComplaintSourceWise"),
          icon: IconWithLabel(Reports1, "Source & Complaint Type Wise"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            permissionsVariables.reports,
            "eOps Users Status Report",
          ),
        },

        {
          key: "TopBestAndWorstPerformer",
          label: "TopBestAndWorstPerformer",
          onClick: () => handleItemClick("TopBestAndWorstPerformer"),
          icon: IconWithLabel(
            Reports1,
            "Top Best And Worst Field Staff Performer",
          ),
          permission:
            CheckPermissions(
              permissions,
              permissionsVariables.powerComplaints,
              permissionsVariables.reports,
              permissionsVariables.staffPerformance,
              "Top 5% Best Performers",
            ) ||
            CheckPermissions(
              permissions,
              permissionsVariables.powerComplaints,
              permissionsVariables.reports,
              permissionsVariables.staffPerformance,
              "Worst 10% Non-Performers",
            ),
        },
      ],
    },
    {
      key: "Complaints Management",
      label: "Complaints Management",
      icon: IconWithLabel(Complaintsmanagemnt, "Complaints Management"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
      ),
      children: [
        {
          key: "PendingComplaints",
          label: "Pending Complaints",
          onClick: () => handleItemClick("PendingComplaints"),
          icon: IconWithLabel(Pending1, "Pending Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Pending Complaints",
          ),
        },
        {
          key: "AllocatedComplaints",
          label: "Allocated Complaints",
          onClick: () => handleItemClick("AllocatedComplaints"),
          icon: IconWithLabel(Allocated1, "Allocated Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Allocated Complaints",
          ),
        },
        {
          key: "WorkingComplaints",
          label: "Working Complaints",
          onClick: () => handleItemClick("WorkingComplaints"),
          icon: IconWithLabel(Working1, "Working Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Working Complaints",
          ),
        },
        {
          key: "OnholdComplaints",
          label: "Onhold Complaints",
          onClick: () => handleItemClick("OnholdComplaints"),
          icon: IconWithLabel(Onhold1, "Onhold Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Onhold Complaints",
          ),
        },
        {
          key: "EscalatedComplaints",
          label: "Escalated Complaints",
          onClick: () => handleItemClick("EscalatedComplaints"),
          icon: IconWithLabel(Escalated1, "Escalated Complaints"),
          permission: true,
        },

        {
          key: "APMSEscalatedComplaints",
          label: "APMS Escalated Complaints",
          onClick: () => handleItemClick("APMSEscalatedComplaints"),
          icon: IconWithLabel(Escalated1, "APMS Escalated"),
          permission: true,
        },
        // {
        //   key: "APMSComplaintsSummary",
        //   label: "APMS Complaints Summary",
        //   onClick: () => handleItemClick("APMSComplaintsSummary"),
        //   icon: IconWithLabel(Reports1, "APMS Complaints Summary"),
        //   permission: true,
        // },
        {
          key: "ResolvedComplaints",
          label: "Resolved Complaints",
          onClick: () => handleItemClick("ResolvedComplaints"),
          icon: IconWithLabel(Resolved1, "Resolved Complaints"),
          permission: CheckPermissions(
            permissions,
            permissionsVariables.powerComplaints,
            "Resolved Complaints",
          ),
        },
      ],
    },
    {
      key: "Logout",
      label: "Logout",
      onClick: async () => logoutfunction(),
      icon: IconWithLabel(Logout1, "Logout"),
      permission: CheckPermissions(
        permissions,
        permissionsVariables.powerComplaints,
      ),
    },
  ];

  const filterItemsByPermissions = (items) => {
    return items
      .filter((item) => item.permission)
      .map((item) => {
        const { permission, ...rest } = item;
        if (rest.children) {
          rest.children = filterItemsByPermissions(rest.children);
        }
        return rest;
      });
  };

  const filteredItems = filterItemsByPermissions(
    roleId == 1135
      ? tacItems
      : roleId == 1148 || roleId == 1154 || roleId == 1153
        ? tacItemsCircle
        : items,
  );

  const [arrayOfShift, setArrayOfShift] = useState([]);

  const handleCheckboxChange = (shiftId) => {
    let temp = [...arrayOfShift];
    const exists = temp.find((item) => item.shiftId === shiftId);

    if (exists) {
      temp = temp.filter((item) => item.shiftId !== shiftId);
    } else {
      let shiftObj = { shiftId: shiftId };
      temp.push(shiftObj);
    }

    setArrayOfShift(temp);

    setSelectedItems((prevSelected) => {
      const updated = prevSelected.includes(shiftId)
        ? prevSelected.filter((id) => id !== shiftId)
        : [...prevSelected, shiftId];

      const formatted = updated.map((id) => ({ shiftId: id }));
      setAddSelectedItems1(formatted);

      return updated;
    });
  };

  const handleCheckboxChange1 = (shiftId) => {
    let temp = [...arrayOfShift];
    const exists = temp.find((item) => item.shiftId === shiftId);

    if (exists) {
      temp = temp.filter((item) => item.shiftId !== shiftId);
    } else {
      let shiftObj = { shiftId: shiftId };
      temp.push(shiftObj);
    }

    setArrayOfShift(temp);

    setEditSelectedItems((prevSelected) => {
      const updated = prevSelected.includes(shiftId)
        ? prevSelected.filter((id) => id !== shiftId)
        : [...prevSelected, shiftId];

      const formatted = updated.map((id) => ({ shiftId: id }));
      setEditSelectedItems1(formatted);

      return updated;
    });
  };

  const handleEditPasswordWF = (WFData) => {
    // setPasswordWF(true)
    if (WFData) {
      setWorkForceToPassword(WFData);
      passwordChangeWorkForceFormik.values.iv_userId = WFData.userId;
      // editWorkForceFormik.values.iv_name = WFData.name
      // editWorkForceFormik.values.iv_designation = WFData.designation

      // const shiftIdsArray = WFData.shift ? WFData.shift.split(",").map(Number) : [];
      // setEditSelectedItems(shiftIdsArray)

      // const shiftIdsArrays = WFData.shift
      //   ? WFData.shift.split(",").map(Number)
      //   : [];

      // const formattedShiftIds = shiftIdsArrays.map(id => ({ shiftId: id }));
      // setEditSelectedItems1(formattedShiftIds);

      // editWorkForceFormik.values.iv_shift = WFData.shift
      // editWorkForceFormik.values.iv_phone = WFData.phoneNo
      // editWorkForceFormik.values.iv_cnic = WFData.cnic
      // editWorkForceFormik.values.iv_employeeCode = WFData.employeeCode
      // editWorkForceFormik.values.iv_userId = WFData.userId
      // editWorkForceFormik.values.iv_password = WFData.password
      // editWorkForceFormik.values.iv_confirm_password = WFData.password
      setPasswordWF(true);
    }
  };
  const [selectedItems, setSelectedItems] = useState([]);
  const [editSelectedItems, setEditSelectedItems] = useState([]);
  const [editSelectedItems1, setEditSelectedItems1] = useState([]);
  const [addSelectedItems1, setAddSelectedItems1] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [officeCodee, setOfficeCodee] = useState("");
  const [circleCodee, setCircleCodee] = useState("");
  const [officeNamee, setOfficeName] = useState("");
  const [circleName, setCircleName] = useState("");
  const [hierarchye, setHierarchye] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const companies = [
    { code: "11", name: "LESCO", logo: LESCODDLOGO },
    { code: "12", name: "GEPCO", logo: GEPCODDLOGO },
    { code: "13", name: "FESCO", logo: FESCODDLOGO },
    { code: "14", name: "IESCO", logo: IESCODDLOGO },
    { code: "15", name: "MEPCO", logo: MEPCODDLOGO },
    { code: "26", name: "PESCO", logo: PESCODDLOGO },
    { code: "27", name: "HAZECO", logo: HAZECODDLOGO },
    { code: "37", name: "HESCO", logo: HESCODDLOGO },
    { code: "38", name: "SEPCO", logo: SEPCODDLOGO },
    { code: "48", name: "QESCO", logo: QESCODDLOGO },
    { code: "59", name: "TESCO", logo: TESCODDLOGO },
  ];

  // Selected officeCode state
  const [selectedOfficeCode, setSelectedOfficeCode] = useState("15");
  const [shifts, setShifts] = useState([
    {
      shiftId: 1,
      shiftName: "Morning",
      startTime: "6:00 AM",
      endTime: "2:00 PM",
    },
    {
      shiftId: 2,
      shiftName: "Evening",
      startTime: "2:00 PM",
      endTime: "10:00 PM",
    },
    {
      shiftId: 3,
      shiftName: "Night",
      startTime: "10:00 PM",
      endTime: "6:00 AM",
    },
  ]);
  const [mode, setMode] = useState("vertical");
  const [theme, setTheme] = useState("light");

  const initialValues = {
    // Classification group Initial Values
    iv_name: "",
    iv_phone_no: "",
    iv_address: "",
    iv_consumer_id: "",
    iv_con_id_ref_no: "",
    // userprofile field
    iv_full_name: "",
    iv_user_phone_no: "",
    iv_user_email: "",
    iv_user_cnic: "",
    iv_profile_picture: "",
    //Search Bar fields
    iv_reference_no: "",
    iv_application_id: "",
    iv_cnic: "",
    iv_applicant_name: "",
  };

  const workForceInitialValues = {
    iv_userId: "",
    iv_name: "",
    iv_designation: "",
    iv_phone: "",
    iv_password: "",
    iv_cnic: "",
    iv_employeeCode: "",
    iv_subDivision: "",
  };
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || [],
  );
  // const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'))

  let subDivList = JSON.parse(window.localStorage.getItem("subDivisions"));
  let userCompany = userCode.slice(0, 2);
  const dispatch = useDispatch();

  let location = useLocation();

  const { officeCode } = useSelector((state) => state.officeCode);
  const [passwordWF, setPasswordWF] = useState(false);
  const [officeNameForDashboard, setOfficeNameForDashboard] = useState(
    officeName(officeCode ? officeCode : code, subDivisions),
  );
  const [workForceToPassword, setWorkForceToPassword] = useState({});
  const [codeForDashboard, setCodeForDashboard] = useState(officeCode);
  const [fieldStaffDesignations, setFieldStaffDesignations] = useState([]);
  const [feederStatus, setFeederStatus] = useState();

  useEffect(() => {
    const getHierarchicalActionableStats = async () => {
      if (officeCode) {
        let officelength = officeCode.toString().length;
        let hierarchy = null;
        if (officelength == 2 || officelength == 3 || officelength == 4) {
          hierarchy = officelength;
        } else {
          hierarchy = 52;
        }
        let codeToAPI = officeCode == 10 ? 15 : officeCode;
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          officeCode: codeToAPI,
          officeLevel: hierarchy,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "actionables/getActionableCountOfficeWise",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            let statsArray = result.data.map((item) => ({
              name:
                item.officeCode == codeToAPI
                  ? "Total"
                  : getName(item.officeCode, subDivisions),
              counter: item.totalCount,
            }));
            setPendings(statsArray);
          })
          .catch((error) => console.error(error));
      }
    };
    if (roleTypeId == 1) {
      getHierarchicalActionableStats();
    }
  }, [officeCode]);

  useEffect(() => {
    if (officeCode) {
      setCodeForDashboard(officeCode);
    }
  }, [officeCode]);

  useEffect(() => {
    if (codeForDashboard) {
      setOfficeNameForDashboard(officeName(officeCode, subDivisions));
    }
  }, [codeForDashboard]);

  const companyCode = code.slice(0, 2);

  const { performanceValue } = useSelector((state) => state.overallPerformance);

  const { data: result1 } = useSelector((state) => state.feederStatus);

  const [open, setOpen] = React.useState(true);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [showComplaintForm, setShowComplaintForm] = useState(false);
  const [showFeederForm, setShowFeederForm] = useState(false);
  const tableref1 = useRef();
  const [showApmsForm, setShowApmsForm] = useState(false);
  const [showApmsSuccessPopup, setShowApmsSuccessPopup] = useState(false);

  const [showLineManForm, setShowLineManForm] = useState(false);
  const [showWorkforceForm, setShowWorkforceForm] = useState(false);

  const [shift1Fields, setShift1Fields] = useState(
    Array(5).fill({
      name: "",
      designation: "",
      phoneNo: "",
      userId: "",
      isModified: false,
    }),
  );
  const [shift2Fields, setShift2Fields] = useState(
    Array(5).fill({
      name: "",
      designation: "",
      phoneNo: "",
      userId: "",
      isModified: false,
    }),
  );
  const [shift3Fields, setShift3Fields] = useState(
    Array(5).fill({
      name: "",
      designation: "",
      phoneNo: "",
      userId: "",
      isModified: false,
    }),
  );
  const [workForceData, setWorkForceData] = useState([]);
  const [showProfileEditPopup, setShowProfileEditPopup] = useState(false);
  const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false);
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState([]);

  const {
    pageSize: complaintsPageSize,
    pageNumber: complaintsPageNumber,
    subDivisionCode: complaintsSubDivisionCode,
    dateFrom: complaintsDateFrom,
    dateTo: complaintsDateTo,
  } = useSelector((state) => state.allComplaints);
  const { data: mdmToken } = useSelector((state) => state.authorization);
  const [apiData, setApiData] = useState([]);
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [selectedTab, setSelectedTab] = useState(0); // Default to the first tab
  const [selectedValueOfTab, setSelectedValueOfTab] = useState(); // Default to the first tab
  const [searchBarrPopupOpen, setSearchBarrPopupOpen] = useState(false);
  const [openDialogOfApplication, setOpenDialogApplication] = useState(false);
  const tabLabels = ["Reference No.", "Application Id", "CNIC", "Name"];
  const [cDateTime, setCDateTime] = useState("");
  const handleDialogOfApplicationOpen = () => {
    setOpenDialogApplication(true);
  };
  const handleDialogOfApplicationClose = () => {
    setOpenDialogApplication(false);
  };
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    searchFormik.resetForm();
  };
  const handleOpenSearchBarPopup = () => setSearchBarrPopupOpen(true);
  const handleCloseSearchBarPopup = () => setSearchBarrPopupOpen(false);
  const [resultSearchedData, setResultSearchedData] = useState([]);
  const [resultSearchedData1, setResultSearchedData1] = useState([]);
  const getWaterMarkLogo = (code) => {
    switch (code) {
      case "11":
        return LESCOWaterMark;
      case "12":
        return GEPCOWaterMark;
      case "13":
        return FESCOWaterMark;
      case "14":
        return IESCOWaterMark;
      case "15":
        return MEPCOWaterMark;
      case "26":
        return PESCOWaterMark;
      case "27":
        return HAZECOWaterMark;
      case "37":
        return HESCOWaterMark;
      case "38":
        return SEPCOWaterMark;
      case "48":
        return QESCOWaterMark;
      case "59":
        return TESCOWaterMark;
      default:
        return MEPCOWaterMark;
    }
  };
  const searchFormik = useSearchFormik({
    selectedTab,
    setSelectedValueOfTab,
    setResultSearchedData,
    setResultSearchedData1,
    token,
    handleDialogOfApplicationOpen,
    handleCloseSearchBarPopup,
    initialValues,
    setViewBackdrop,
  });

  const editWorkForceFormik = useFormik({
    initialValues: workForceInitialValues,
    validationSchema: Yup.object().shape({
      iv_userId: Yup.string().required("UserId is required!"),
      iv_name: Yup.string()
        .min(3, "Name should be atleast 3 characters.")
        .max(30, "Name should be less than 30 characters.")
        .required("Please enter lineman name.")
        .matches(/^[A-Za-z. ]*$/, "Only letters and '.' are allowed."),
      iv_phone: Yup.string()
        .max(11, "Please enter 11 digit phone number.")
        .min(11, "Please enter 11 digit phone number.")
        .required("Please enter valid mobile number.")
        .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
      iv_designation: Yup.mixed().required("Designation is required!"),
      // iv_shift: Yup.mixed().optional(),
      // iv_password: Yup.string().matches(passwordRegex, "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long").required("Password is required"),
      // iv_confirm_password: Yup.string().oneOf([Yup.ref('iv_password'), null], 'Password and Confirm password must match').required("Confirm password is required"),
      iv_cnic: Yup.string()
        .min(13, "CNIC no. can not less than 13 digits.")
        .max(13, "CNIC no. can not greater than 13 digits.")
        .required("CNIC No. is required")
        .matches(/^[0-9]+$/, "Enter CNIC No. as 3520212345678"),
      iv_employeeCode: Yup.string()
        .min(2, "Employee code must be at least 2 characters.")
        .max(14, "Employee code must be at most 14 characters.")
        .required("Employee code is required")
        .matches(
          /^[0-9]+$/,
          "Employee code must contain only numeric characters.",
        ),
    }),
    onSubmit: async (values, { resetForm }) => {
      console.log("Edit WF form values:", values);
      console.log("SubDivision Code:", workForceToEdit.subDivisionCode);
      const sdCode = workForceToEdit.subDivisionCode
        ? String(workForceToEdit.subDivisionCode)
        : "";

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        userId: workForceToEdit.userId,
        employeeName: values.iv_name,
        employeeMobileNo: values.iv_phone,
        employeeCNIC: values.iv_cnic,
        employeeEmail: "",
        updatedBy: userId,
        toBeUpdatedUserId: values.iv_userId,
        designation: values.iv_designation,
        shiftDetails: editSelectedItems1,
        employeeCode: values.iv_employeeCode,
        companyCode: sdCode.slice(0, 2),
        circleCode: sdCode.slice(0, 3),
        divisionCode: sdCode.slice(0, 4),
        subDivisionCode: sdCode.slice(0, 5),
        // password: values.iv_password,
        hierarchy: hierarchy,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "workForce/updateUser", requestOptions)
        .then(async (response) => {
          if (response.status == 200) {
            return response.json();
          } else {
            let res = await response.json();
            setApiError(res.message);
          }
        })
        .then((result) => {
          if (!result.message.startsWith("Failed to edit employee")) {
            setEditWF(false);
            resetForm();
            getWFData();
            setApiError("");
          }
        })
        .catch((error) => console.error(error));
    },
  });

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const [complaintsError, setComplaintsError] = useState("");
  const [enableFullName, setEnableFullName] = React.useState(false);
  const [enablePhone, setEnablePhone] = React.useState(false);
  const [enableEmail, setEnableEmail] = React.useState(false);
  const [apiError, setApiError] = useState("");
  const [arrear, setArrear] = useState("");
  const [meterStatus, setMeterStatus] = useState("");
  const [showComplaintErrorForm, setShowComplaintErrorForm] = useState(false);
  const [isFormModified, setIsFormModified] = useState(false);
  const [isFormModifiedWorkForce, setIsFormModifiedWorkForce] = useState(false);
  const [sliceRefNo, setSliceRefNo] = useState();
  const [selectedOption, setSelectedOption] = useState("referenceNo");
  const [deleteLMWarning, setDeleteLMWarning] = useState(false);
  const offCode = code;
  const [complaintType, setComplaintType] = useState("Technical");

  const [desginationList, setDesginationList] = useState([]);

  const [addWF, setAddWF] = useState(false);
  const [editWF, setEditWF] = useState(false);
  const [workForceToEdit, setWorkForceToEdit] = useState({});
  const [workForceToDelete, setWorkForceToDelete] = useState({});
  const [selectedCompanyCode, setSelectedCompanyCode] = useState("");
  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions,
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              console.error("Error fetching subDivisions:", result.message);
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching subDivisions:", error);
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCodee(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCodee("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCodee("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCodee(selectedCircleCode);
            setOfficeCodee(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode,
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode,
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCodee("");
            setOfficeCodee(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode,
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCodee(selectedCircleCode);
      setOfficeCodee(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode,
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCodee("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCodee(offCode == 10 ? 15 : offCode);
          let officeName = getName(
            offCode == 10 ? "15" : offCode.toString(),
            subDivisions,
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode,
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCodee(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchye(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode,
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCodee(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchye(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode,
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCodee(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode,
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode,
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCodee(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode,
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCodee(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions,
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode),
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions,
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCodee(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode,
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            console.error("Error fetching subDivisions:", result.message);
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching subDivisions:", error);
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCodee(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode,
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions,
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCodee(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCodee(offCode == 10 ? 15 : offCode);
        let offName = getName(
          offCode == 10 ? "15" : offCode.toString(),
          subDivisions,
        );
        setOfficeName(offName);
        setHierarchye(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            setOfficeCodee(15);
            setOfficeName("PITC");
          } else {
            setOfficeCodee(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchye(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCodee(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchye(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCodee(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchye(cfcLevelId);
        }
      } else if (cfcLevelId == 4 || cfcLevelId == 5) {
        if (offCode) {
          setOfficeCodee(offCode.toString().slice(0, 4));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchye(cfcLevelId);
        }
      }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        setCircleCodee(offCode.slice(0, 3));
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode,
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);
  const handleDeleteLMUser = async () => {
    if (workForceToEdit) {
      try {
        await deleteWFData(workForceToEdit, token);
        setEditWF(false);
        getWFData();
        setApiError("");
      } catch (error) {
        console.error("Error deleting workforce data:", error);
      }
    }
  };

  const handleChange1 = (event) => {
    setReferenceNumber("");
    const newValue = event.target.value;
    setSelectedOption(newValue);
    // Set default "Over Voltage" when APMS MSN is selected
    if (newValue === "apmsMsn") {
      setTimeout(() => {
        setTypeId("apms_over_voltage");
        setTypeName("Over Voltage");
      }, 100);
    } else {
      setTypeId("");
      setTypeName("");
    }
  };

  const handleChange2 = (event) => {
    setComplaintType(event.target.value);
    // setReferenceNumber("")
    // setSelectedOption(event.target.value);
  };
  const handleClickFullName = async () => {
    if (!enableFullName) {
      setEnableFullName((prev) => !prev);
    } else {
      nameFormik.handleSubmit();
    }
  };

  const handleClickPhone = async () => {
    if (!enablePhone) {
      setEnablePhone((prev) => !prev);
    } else {
      phoneFormik.handleSubmit();
    }
  };

  const handleClickEmail = async () => {
    if (!enableEmail) {
      setEnableEmail((prev) => !prev);
    } else {
      emailFormik.handleSubmit();
    }
  };

  useEffect(() => {
    if (token) {
      dispatch(
        allStatsAPI({
          officeCode: code,
          officeLevel: hierarchy,
          showAllApplicationsFlag: showAllApplicationsFlag,
        }),
      );
      if (roleTypeId == 1) {
        dispatch(actionableNormal({ pageNumber: 1, pageSize: 20 }));
        dispatch(actionableOverdue({ pageNumber: 1, pageSize: 20 }));
      }
    }
  }, [token]);

  // Extract the current page name from the URL
  const currentPage = location.pathname.split("/")[1]; // Assuming the page name is the first part of the URL path

  const routes = [
    {
      path: "/new-connection-table",
      args: [
        permissionsVariables.generalServices,
        permissionsVariables.newConnection,
      ],
    },
    {
      path: "/reconnection-table",
      args: [
        permissionsVariables.generalServices,
        permissionsVariables.reConnection,
      ],
    },
    {
      path: "/bill-correction-table",
      args: [
        permissionsVariables.generalServices,
        permissionsVariables.newConnection,
      ],
    },
    {
      path: "/change-of-attributes-table",
      args: [
        permissionsVariables.generalServices,
        permissionsVariables.changeOfAttributes,
      ],
    },
    {
      path: "/change-of-load-table",
      args: [permissionsVariables.generalServices, "Change of Load"],
    },
    {
      path: "/change-of-tariff-table",
      args: [permissionsVariables.generalServices, "Change of Tariff"],
    },
    {
      path: "/net-metering",
      args: [permissionsVariables.generalServices, "Shift to Net Meter"],
    },
    {
      path: "/meter-change-request-table",
      args: [permissionsVariables.generalServices, permissionsVariables.mco],
    },
    {
      path: "/meter-reading-correction-table",
      args: [
        permissionsVariables.billingAndCollection,
        "Meter Reading Correction",
      ],
    },
    {
      path: "/due-date-extension-table",
      args: [permissionsVariables.billingAndCollection, "Due Date Extension"],
    },
    {
      path: "/adjust-last-bill-table",
      args: [permissionsVariables.billingAndCollection, "Due Date Extension"],
    },
    {
      path: "/amend-2636-bill-table",
      args: [permissionsVariables.billingAndCollection, "Due Date Extension"],
    },
    {
      path: "/installments-table",
      args: [permissionsVariables.billingAndCollection, "Installments"],
    },
    {
      path: "/set-aside-table",
      args: [permissionsVariables.billingAndCollection, "Installments"],
    },
    {
      path: "/power-complaint-table",
      args: [permissionsVariables.powerComplaints],
    },
    {
      path: "/power-complaint-map",
      args: ["Gis Map"],
    },
    {
      path: "/user-management",
      args: [permissionsVariables.accessManagement, "User Management"],
    },
    {
      path: "/role-management",
      args: [permissionsVariables.accessManagement, "Role Management"],
    },
    {
      path: "/permission-management",
      args: [permissionsVariables.accessManagement, "Permission Management"],
    },
    {
      path: "/company-management",
      args: [permissionsVariables.organizationManagement, "Company Management"],
    },
    {
      path: "/circle-management",
      args: [permissionsVariables.organizationManagement, "Circle Management"],
    },
    {
      path: "/division-management",
      args: [
        permissionsVariables.organizationManagement,
        "Division Management",
      ],
    },
    {
      path: "/support-center-management",
      args: [permissionsVariables.organizationManagement, "CSC Management"],
    },
    {
      path: "/sub-division-management",
      args: [
        permissionsVariables.organizationManagement,
        "Sub Division Management",
      ],
    },
  ];

  const currentPath = location.pathname;
  const isButtonVisible = routes.some((route) => {
    return (
      route.path == currentPath && CheckPermissions(permissions, ...route.args)
    );
  });

  const printApplicationReceipt = (
    applicationID,
    referenceNumber,
    values,
    typeName,
    description,
  ) => {
    const doc = new jsPDF({ compressPdf: true });
    const company = referenceNumber.slice(2, 4);

    // Generate the barcode image using JsBarcode
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, applicationID);

    // Convert the barcode image to data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
    var height = 10;
    var padding = 10;

    doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20);
    const logoWidth =
      company === "12" ||
      company === "13" ||
      company === "11" ||
      company === "16" ||
      company === "27" ||
      company === "48" ||
      company === "59"
        ? 25
        : 30;
    const logoHeight =
      company === "12" ||
      company === "13" ||
      company === "11" ||
      company === "16" ||
      company === "27" ||
      company === "48" ||
      company === "59"
        ? 20
        : 10;
    doc.addImage(getLogo(company), "PNG", 90, 5, logoWidth, logoHeight);

    height = height + 20;

    var increment = 10;
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(
      "Receipt of Complaint",
      doc.internal.pageSize.getWidth() / 2,
      height,
      {
        align: "center",
      },
    );
    doc.setFontSize(12);
    increment = 20;
    height = height + increment;
    var leftMargin = 120;
    doc.text("DISCO / Company: ", padding, height);
    doc.text("Sub Division Code & Name:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");
    increment = 10;
    height = height + increment;
    leftMargin = 120;
    doc.text(companyShortName(company), padding, height);
    doc.text(
      values.iv_con_id_ref_no.slice(2, 7) +
        " / " +
        subdivisionName(values.iv_con_id_ref_no.slice(2, 7), subDivList),
      padding + leftMargin,
      height,
    );

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Tracking ID: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(applicationID.toString(), padding + leftMargin, height);
    leftMargin = 100;
    doc.setFont("helvetica", "bold");

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Name: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_name, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 60;
    doc.setFont("helvetica", "bold");
    doc.text("Applicant Mobile No.: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_phone_no, padding + leftMargin, height);
    let phone = "";
    doc.text(phone, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Address: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(values.iv_address, padding + leftMargin, height);
    let address = "";
    doc.text(address, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Reference No.: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(referenceNumber, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Complaint Type: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(typeName, padding + leftMargin, height);

    increment = 10;
    height = height + increment;
    leftMargin = 40;
    doc.setFont("helvetica", "bold");
    doc.text("Description: ", padding, height);
    doc.setFont("helvetica", "normal");
    doc.text(description, padding + leftMargin, height);

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.addImage(
        getWaterMarkLogo(company),
        "PNG",
        0,
        0,
        doc.internal.pageSize.getWidth(),
        doc.internal.pageSize.getHeight(),
      );
    }

    const pdfBlob = doc.output("blob");
    const pdfDataUrl = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    window.open(pdfDataUrl, "_blank");
  };

  const powerComplaintsMenu =
    currentPath == "/power-complaint-map" ||
    currentPath == "/power-complaint-pending" ||
    currentPath == "/power-complaint-allocated" ||
    currentPath == "/power-complaint-working" ||
    currentPath == "/power-complaint-onhold" ||
    currentPath == "/power-complaint-escalated" ||
    currentPath == "/power-complaint-resolved" ||
    currentPath == "/power-complaint-detail-report" ||
    currentPath == "/power-complaint-display-complaint";

  const displayComplaintPage =
    currentPath == "/power-complaint-display-complaint";

  const drawerWidth = 250;
  // const drawerWidth = !powerComplaintsMenu ? 275 : !displayComplaintPage ? 250 : 0;

  const currentDate = new Date();
  const day = currentDate.getDate();
  const month = currentDate.toLocaleString("en-US", { month: "short" }); // Get month in 'Sep' format
  const year = currentDate.getFullYear();
  const weekday = currentDate.toLocaleString("en-US", { weekday: "short" }); // Get current weekday

  const formattedDate = `${day} ${month}, ${weekday}`;

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const pageRoutes = {
    CFCDashboard: () => navigate("/homecfc"),
    FieldOfficeDashboard: () =>
      navigate("/homefieldoffice", {
        state: { officeCode: code, hierarchy: hierarchy },
      }),
    CFCPerformance: () =>
      navigate("/commercialOperations", {
        state: { officeCode: code, hierarchy: hierarchy },
      }),
    OperationalPerformance: () =>
      navigate("/operationalperformance", {
        state: { officeCode: code, hierarchy: hierarchy },
      }),
    CommercialOperations: () => {
      if (totalActionablesNormal + totalActionablesOverdue > 0) {
        navigate("/actionables-table");
      } else {
        navigate("/new-connection-table");
      }
    },
    Actionables: () => navigate("/actionables-table"),
    NewConnection: () => navigate("/new-connection-table"),
    DueDateExt: () => navigate("/due-date-extension-table"),
    BillInstallments: () => navigate("/installments-table"),
    SetAside: () => navigate("/set-aside-table"),
    Reconnection: () => navigate("/reconnection-table"),
    BillCorrection: () => navigate("/bill-correction-table"),
    MeterReadingCorrection: () => navigate("/meter-reading-correction-table"),
    ChangeOfName: () => navigate("/change-of-attributes-table"),
    ChangeOfLoad: () => navigate("/change-of-load-table"),
    ChangeOfTariff: () => navigate("/change-of-tariff-table"),

    AdjustLastBill: () => navigate("/adjust-last-bill-table"),

    ShiftToNetMeter: () => navigate("/net-metering"),
    UpdateTenantCNIC: () => navigate("/cnic-updation"),
    MeterChangeRequest: () => navigate("/meter-change-request-table"),
    DuplicateBill: () => navigate("/duplicate-bill"),
    AmendDuplicateBill: () => setOpenAmendBillPopup(true),
    AmendBill2636: () => navigate("/amend-2636-bill-table"),

    PowerComplaintTable: () => navigate("/power-complaint-form"),
    TechnicalOperations: () => navigate("/pending-escalated-complaints"),
    ComplaintAndControlCenter: () =>
      navigate("/power-complaint-map-management"),
    Home: () => navigate("/power-complaint-map-management"),
    HomeTac: () => navigate("/technicalOperations"),

    CircleHome: () => {
      {
        dispatch(updateHomeButton(true));
      }
    },
    FeederLossesReport: () => navigate("/feeder-losses-report"),
    NewComplaint: () => setShowComplaintForm(true),
    FeederList: () => setShowFeederForm(true),
    ApmsList: () => setShowApmsForm(true),
    APMSDashboard: () => navigate("/apms-dashboard"),
    Linemen: async () => {
      await getWorkForceDesignations();
      await getWFData();
      setShowWorkforceForm(true);
    },
    MobileAppStats: () => navigate("/mobile-app-stats"),
    LineStaffPerformance: () => navigate("/lineman-staff-performance"),
    LoadSheddingSchedule: () => navigate("/load-shedding-schedule"),
    ComplaintRegister: () => navigate("/power-complaint-detail-report"),
    EscalationComplaints: () => navigate("/escalation-complaints-report"),
    LinemanAPPUserSummary: () => navigate("/lineman-app-user-summary"),
    PendingComplaints: () => navigate("/power-complaint-pending"),
    AllocatedComplaints: () => navigate("/power-complaint-allocated"),
    WorkingComplaints: () => navigate("/power-complaint-working"),
    OnholdComplaints: () => navigate("/power-complaint-onhold"),
    EscalatedComplaints: () => navigate("/power-complaint-escalated"),
    APMSComplaintsSummary: () => navigate("/apms-complaints-summary"),
    APMSEscalatedComplaints: () => navigate("/apms-escalated-complaints"),
    ResolvedComplaints: () => navigate("/power-complaint-resolved"),
    WorkforceManagement: async () => {
      await getWorkForceDesignations();
      await getWFData();
      setShowWorkforceForm(true);
    },
    UserManagement: () => navigate("/user-management"),
    RoleManagement: () => navigate("/role-management"),
    PermissionManagement: () => navigate("/permission-management"),
    EopsUpdates: () => navigate("/eops-updates"),
    Company: () => navigate("/company-management"),
    Circle: () => navigate("/circle-management"),
    Division: () => navigate("/division-management"),
    CFC: () => navigate("/support-center-management"),
    SubDivision: () => navigate("/sub-division-management"),
    MapHome: () => navigate("/power-complaint-map"),
    NewConnectionReport: () => navigate("/new-connection-summary"),
    NewConnectionPostedToIBSReport: () =>
      navigate("/new-connection-posted-to-ibs-report"),
    NewConnectionSubDivisionWiseApplicationsStatus: () =>
      navigate("new-connection-subdivision-wise-applications-status-report"),
    NewConnectionStatusWiseCountReport: () =>
      navigate("new-connection-status-wise-count-report"),
    DueDateExtensionReport: () => navigate("/due-date-extension-reports"),
    MeterReadingCorrectionReport: () =>
      navigate("/meter-reading-correction-reports"),
    InstallmentReport: () => navigate("/installments-reports"),
    CashCollectionSummaryReport: () =>
      navigate("/cash-collection-summary-report"),
    BatchWiseAssessment: () => navigate("batch-wise-assessment-report"),
    DeadDefaulterList: () => navigate("/dead-defaulter-report"),
    DailyProgressReport: () => navigate("/daily-progress-report"),
    FeederLossesReport: () => navigate("/feeder-losses-report"),
    DeadDefaulterReport: () => navigate("dead-defaulter-report"),
    ComputedBillingAndCollectionAnalysis: () =>
      navigate("computed-billing-&-collection-analysis-report"),
    WrongReadingTable: () => navigate("wrong-reading-table"),
    LoggedInUsers: () => navigate("logged-in-users"),
    ComplaintsSummary: () => navigate("subdivision-wise-complaints-summary"),
    EopsMobileAppUsageSummary: () => navigate("eops-mobile-app-usage-summary"),
    NotLoggedInUserInLast24Hours: () =>
      navigate("not-logged-in-user-in-last-24-hours"),
    EopsUsersStatus: () => navigate("eops-users-status-report"),
    ComplaintSourceWise: () => navigate("eops-complaint-source-wise"),
    NewConnectionStatusReport: () => navigate("new-connection-status-reports"),
    WorstPerformer: () => navigate("worst-performer-users-report"),
    TopBestAndWorstPerformer: () =>
      navigate("top-best-and-worst-performer-users-report"),

    SrOnEmail: () => navigate("/sr-on-email"),
    COASrOnEmail: () => navigate("/coa-sr-on-email"),
  };

  const handleItemClick = (nodeId, parentIds = []) => {
    if (pageRoutes[nodeId]) {
      pageRoutes[nodeId]();
    }
  };

  const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
    ({ theme, open }) => ({
      flexGrow: 1,
      padding: theme.spacing(0),
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      margin: `-${drawerWidth}px`,
      ...(open && {
        transition: theme.transitions.create("margin", {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        margin: 0,
      }),
    }),
  );

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(!open && {}),
    ...(open && {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: `${drawerWidth}px`,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      // backgroundColor: pageName === "power-complaint-map" ? 'black' : ''
    }),
  }));

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 0),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  }));

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const LineManFormClose = () => {
    if (isFormModified) {
      lmSignUpFormik.handleSubmit(); // Call API only if the form has been modified
    }
    setShowLineManForm(false); // Close the form
  };

  //#region Complaint submission
  const [typeId, setTypeId] = React.useState(1);
  const [typeName, setTypeName] = React.useState(
    complaintType == "Technical" ? "Power Outage" : "Meter Position",
  );
  const [billMonth, setBillMonth] = useState("");

  const [searchBy, setSearchBy] = useState("consumerId");
  const [latitudeOfRefNo, setLatitudeOfRefNo] = useState("");
  const [logitudeOfRefNo, setLogitudeOfRefNo] = useState("");
  const [transformerLat, setTransformerLat] = useState("");
  const [transformerLong, setTransformerLong] = useState("");
  const [transformerSubDivCode, setTransformerSubDivCode] = useState("");
  const [transformerRefNo, setTransformerRefNo] = useState("");
  const [tariff, setTariff] = useState();
  const [meterType, setMeterType] = useState();
  const [meterNo, setMeterNo] = useState();
  const [phase, setPhase] = useState();
  const [referenceNumber, setReferenceNumber] = useState("");

  const [showOldPassword, setShowOldPassword] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [feederNo, setFeederNo] = useState();

  const [meterPhase, setMeterPhase] = useState();
  const [meterTypes, setMeterTypes] = useState();

  const handleClickShowOldPassword = () => setShowOldPassword((prev) => !prev);
  const handleClickShowNewPassword = () => setShowNewPassword((prev) => !prev);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((prev) => !prev);
  const { data: geoJsonData } = useSelector((state) => state.geoJson);

  const TypeId = (event) => {
    setTypeId(event.target.value);
    setTypeName(event.target.name);
  };

  useEffect(() => {
    if (geoJsonData && hierarchy == 52) {
      const features = geoJsonData.features;
      if (features) {
        const feederArray = [];
        const feederFeatures = features.filter(
          (feature) =>
            feature.properties["Feeder Code"] != null &&
            feature.properties["Feeder Code"] != "11kV",
        );
        let feederString = "";
        feederFeatures.forEach((feature) => {
          const feederCode = feature.properties["Feeder Code"];
          if (!feederArray.includes(feederCode) && feederCode) {
            feederString.concat(feederCode.toString()).concat(",");
            feederArray.push(feederCode);
          }
        });
        feederString = feederArray.join(",");
        dispatch(fetchFeederStatus(feederString));
      }
    }
  }, [geoJsonData]);

  useEffect(() => {
    if (typeId) {
      const typeName = otherComplaintsArray.find(
        (item) => item.code === typeId,
      );
      if (typeName) {
        setTypeName(typeName.name);
      }
    }
  }, [typeId]);

  const today = new Date(); // Setting a specific date for testing
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const yesterdayDate = yesterday.toISOString().split("T")[0];

  const errorCloses = () => {
    setComplaintsError("");
    setApiError("");
  };

  const [groupedFeeders, setGroupedFeeders] = useState({});
  const [groupedAPMS, setGroupedAPMS] = useState({});

  useEffect(() => {
    getAPMSCoordinates();
  }, []);

  const getAPMSCoordinates = async () => {
    try {
      // Check if mdmToken exists before proceeding
      if (!mdmToken?.privatekey) {
        return;
      }

      // const authResponse = await fetch(
      //   "https://api.mdm.pitc.com.pk/api/authorization_service",
      //   {
      //     method: "POST",
      //     headers: {
      //       Accept: "application/json",
      //       "Content-type": "application/json",
      //       username: "admin@kbk",
      //       password: "admin786",
      //       code: "1",
      //     },
      //   }
      // );
      // const authResult = await authResponse.json();

      // console.log(authResult, 'authResult')
      // const privateKey = authResult.privatekey;

      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("privatekey", mdmToken.privatekey);

      const formdata = new FormData();
      formdata.append("organization_code", areaCode);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      await fetch(
        "https://api.mdm.pitc.com.pk/api/get_apms_status",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          setGroupedAPMS(
            result.data.reduce((acc, record) => {
              const grid = "All Data";

              if (!acc[grid]) {
                acc[grid] = [];
              }
              // Check if any of the current values contains a zero
              const currentStatus = [record.i1, record.i2, record.i3].some(
                (currentValue) => currentValue === "0.0",
              )
                ? "ON"
                : record.contactor_status
                  ? "ON"
                  : "OFF";

              acc[grid].push({
                name: record.name,
                msn: record.msn,
                current_load: record.current_load,
                voltage: `${record.v1} / ${record.v2} / ${record.v3}`,
                current: `${record.i1} / ${record.i2} / ${record.i3}`,
                apms_capacity: record.apms_capacity,
                kva: record.kva,
                status: currentStatus,
                last_communication_time: record.last_communication_time.slice(
                  0,
                  16,
                ),
              });

              return acc;
            }, {}),
          );
        })
        .catch((error) => console.error(error));
    } catch (error) {
      console.error("Error fetching APMS data:", error);
    }
  };

  let areaCode = "";
  if (hierarchy !== 52) {
    areaCode = "15171";
  } else {
    areaCode = code.slice(0, 5);
  }

  useEffect(() => {
    if (result1 && result1 && hierarchy == 52) {
      setGroupedFeeders(
        result1.reduce((acc, record) => {
          const grid = record.grid;
          if (!acc[grid]) {
            acc[grid] = [];
          }
          const formattedReportingTime = record.reporting_time.slice(0, 16);

          acc[grid].push({
            last_reporting_time: formattedReportingTime,
            feeder: record.feeder,
            feeder_code: record.feeder_code,
            current: record.current,
            voltage: record.voltage,
            power_factor: record.power_factor,
            active_power_kW: record.active_power_kW,
            current_status: record.current_status,
          });
          return acc;
        }, {}),
      );
    }
  }, [result1]);

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_con_id_ref_no: Yup.string().when("iv_search_by", {
        is: "referenceNo",
        then: Yup.string()
          .length(14, "Reference No. must be exactly 14 digits.")
          .required("Enter reference number."),
      }),
      iv_name: Yup.string()
        .min(3, "Name should be at least 3 characters.")
        .max(200, "Name should be less than 200 characters.")
        .required("Enter applicant name."),
      iv_phone_no: Yup.string()
        .length(11, "Enter a valid 11-digit phone number.")
        .required("Enter valid mobile number.")
        .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter phone number as 03001234567"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      // Handle APMS MSN complaint submission
      if (selectedOption === "apmsMsn") {
        // Validation
        if (!typeId) {
          setComplaintsError(
            "Please select a Complaint Type (Critical Alarm / Tripping / Others).",
          );
          setViewBackdrop(false);
          return;
        }
        if (
          !values.iv_con_id_complaint_details ||
          values.iv_con_id_complaint_details.trim() === ""
        ) {
          setComplaintsError("Complaint Detail is required.");
          setViewBackdrop(false);
          return;
        }

        // Determine complaint category based on typeId prefix
        let complaintCategoryName = "Critical Alarm";
        if (typeId.startsWith("trip_")) {
          complaintCategoryName = "Tripping";
        } else if (typeId === "apms_others") {
          complaintCategoryName = "Others";
        }

        const apmsHeaders = new Headers();
        apmsHeaders.append("Authorization", token);
        apmsHeaders.append("Content-Type", "application/json");

        const apmsRaw = JSON.stringify({
          apmsMeterSerialNo: values.iv_con_id_ref_no,
          submittedThrough: "e-Operations",
          transformerName: values.iv_name,
          feederCode: values.iv_phone_no,
          feederName: values.iv_address,
          complaintCategoryName: complaintCategoryName,
          complaintTypeName: typeName,
          transformerLatitude: parseFloat(transformerLat) || 0,
          transformerLongitude: parseFloat(transformerLong) || 0,
          subDivisionCode:
            parseInt(transformerSubDivCode) || parseInt(code) || 0,
          description: values.iv_con_id_complaint_details,
        });

        const apmsRequestOptions = {
          method: "POST",
          headers: apmsHeaders,
          body: apmsRaw,
          redirect: "follow",
        };

        try {
          const response = await fetch(
            cfpBaseUrl + "apms/registerAPMSComplaint",
            apmsRequestOptions,
          );
          const result = await response.json();

          if (response.status === 200 || result.status === "200") {
            setViewBackdrop(false);
            setShowApmsSuccessPopup(true);
            setShowComplaintForm(false);
            resetForm();
            setSelectedOption("referenceNo");
            setTypeId("");
            setTypeName("");
            setTransformerLat("");
            setTransformerLong("");
            setTransformerSubDivCode("");
            setTransformerRefNo("");
            // Dispatch event to refresh APMS complaints list
            console.log("Dispatching apmsComplaintSubmitted event");
            window.dispatchEvent(new CustomEvent("apmsComplaintSubmitted"));
          } else {
            setViewBackdrop(false);
            setComplaintsError(
              result.message || "Failed to register APMS complaint.",
            );
          }
        } catch (error) {
          console.error("Error submitting APMS complaint:", error);
          setViewBackdrop(false);
          setComplaintsError(
            "Error submitting APMS complaint. Please try again.",
          );
        }
        return;
      }

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", token);

      let raw = {};
      let apiUrl = "";
      const requestOptionss = {
        method: "GET",
        redirect: "follow",
      };

      fetch(
        "https://cp.pitc.com.pk:8071/api/BasicInfo/GetInfo?refno=" +
          referenceNumber,
        requestOptionss,
      )
        .then((response) => response.json())
        .then((result) => {
          if (complaintType == "Technical") {
            raw = JSON.stringify({
              RefNo: referenceNumber,
              Name: values.iv_name,
              Mobile: values.iv_phone_no,
              CNIC: "1234567890123",
              Address: values.iv_address,
              NearByFamousPlace: values.iv_address,
              Province: "punjab",
              Status: "Pending",
              ComplaintNature: "Line Complaints",
              Source: "e-Operations Technical",
              ComplaintType: typeName,
              ComplaintDescription: values.iv_con_id_complaint_details,
              Latitude: result.Table[0].GPSLATI ? result.Table[0].GPSLATI : "",
              Longitude: result.Table[0].GPSLONG ? result.Table[0].GPSLONG : "",
              FeederCode: feederNo,
              ComplaintNatureId: 1,
              ComplaintTypeId: typeId,
            });

            apiUrl = `${cfpBaseUrl}lineComplaints/registerLineComplain`;
          } else {
            raw = JSON.stringify({
              RefNo: referenceNumber,
              Name: values.iv_name,
              Mobile: values.iv_phone_no,
              CNIC: "1234567890123",
              Address: values.iv_address,
              NearByFamousPlace: values.iv_address,
              Province: "punjab",
              Status: "Pending",
              ComplaintNature: "Non Line Complaints",
              Source: "e-Operations Technical",
              ComplaintType: typeName,
              ComplaintDescription: values.iv_con_id_complaint_details,
              Latitude: result.Table[0].GPSLATI ? result.Table[0].GPSLATI : "",
              Longitude: longitude ? longitude : "",
              FeederCode: feederNo,
              ComplaintNatureId: 2,
              ComplaintTypeId: typeId,
            });

            apiUrl = `${cfpBaseUrl}nonLineComplaints/registerNonLineComplaint`;
          }
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          fetch(apiUrl, requestOptions)
            .then((response) => response.json())
            .then(async (result) => {
              if (result.status === "200") {
                setViewBackdrop(false);

                const requestOptions = {
                  method: "GET",
                  redirect: "follow",
                };

                fetch(
                  "https://cp.pitc.com.pk:8071/api/BasicInfo/GetInfo?refno=" +
                    referenceNumber,
                  requestOptions,
                )
                  .then((response) => response.text())
                  .then((result) => console.log(result))
                  .catch((error) => console.error(error));
                printApplicationReceipt(
                  complaintType == "Technical"
                    ? result.EOpsTrackingId
                    : result.CCMSTicketNo,
                  referenceNumber,
                  values,
                  typeName,
                  values.iv_con_id_complaint_details,
                );
                dispatch(
                  fetchPaginatedAllComplaints({
                    pageSize: complaintsPageSize,
                    pageNumber: complaintsPageNumber,
                    subDivisionCode: code,
                    dateFrom: convertDateYYYYMMDD(yesterdayDate),
                    dateTo: convertDateYYYYMMDD(new Date()),
                    roleTypeId: roleTypeId,
                  }),
                );
                setShowComplaintForm(false);
                resetForm();
              } else {
                setViewBackdrop(false);
                if (
                  result.message ===
                  "Complaint already exist against given Ref No in Same Date."
                ) {
                  setComplaintsError(
                    "Complaint already exist against given Ref No in Same Date.",
                  );
                } else {
                  setComplaintsError(result.message);
                }
              }
            })
            .catch((error) => console.error(error));
        })
        .catch((error) => console.error(error));
    },
  });

  const nameFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_full_name: Yup.string()
        .min(3, "Name should be atleast 3 characters.")
        .max(30, "Name should be less than 30 characters.")
        .required("Enter name."),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("userName", userId);
        formdata.append("fullName", values.iv_full_name);

        const requestOptions = {
          method: "PUT",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "customerFaciliationPortal/updateUserProfileName",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              dispatch(updateName(values.iv_full_name));
              setEnableFullName(false);
            } else {
              setApiError(result.Message);
            }
          })
          .catch((error) => {
            setApiError("Unable to update name!");
            console.error(error);
          });
      } catch (e) {
        setApiError("Unable to update name!");
        console.error(e);
      }
      setViewBackdrop(false);
    },
  });

  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();

      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");

      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;
      setCDateTime(formattedDateTime);
    };

    updateDateTime();
    const interval = setInterval(updateDateTime, 60000);

    return () => clearInterval(interval);
  }, []);

  const phoneFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_user_phone_no: Yup.string()
        .max(11, "Enter 11 digit phone number.")
        .min(11, "Enter 11 digit phone number.")
        .required("Enter valid mobile number.")
        .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("userName", userId);
        formdata.append("phoneNo", values.iv_user_phone_no);

        const requestOptions = {
          method: "PUT",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "customerFaciliationPortal/updateUserProfilePhone",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              dispatch(updatePhone(values.iv_user_phone_no));
              setEnablePhone(false);
            } else {
              setApiError(result.Message);
            }
          })
          .catch((error) => {
            setApiError("Unable to update phone!");
            console.error(error);
          });
      } catch (e) {
        setApiError("Unable to update phone!");
      }
      setViewBackdrop(false);
    },
  });

  const emailFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_user_email: Yup.string()
        .email("Enter valid email!")
        .required("Email is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("userName", userId);
        formdata.append("email", values.iv_user_email);

        const requestOptions = {
          method: "PUT",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };

        await fetch(
          cfpBaseUrl + "customerFaciliationPortal/updateUserProfileEmail",
          requestOptions,
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.status === "200") {
              dispatch(updateEmail(values.iv_user_email));
              setEnableEmail(false);
            } else {
              setApiError(result.Message);
            }
          })
          .catch((error) => {
            setApiError("Unable to update phone!");
            console.error(error);
          });
      } catch (e) {
        setApiError("Unable to update phone!");
        console.error(e);
      }
      setViewBackdrop(false);
    },
  });

  const complaintFormClose = () => {
    setMeterStatus("");
    setArrear("");
    values.iv_address = "";
    values.iv_complaint_type = "";
    values.iv_con_id_ref_no = "";
    values.iv_consumer_id = "";
    values.iv_phone_no = "";
    setTypeId("");
    setShowComplaintForm(false);
  };

  const errorCloses1 = () => {
    setArrear("");
    setApiError("");
  };

  // useEffect(async() => {
  //   let codeToGeoJSON = code
  //   if(hierarchy == 52){
  //     dispatch(fetchGeoJson({ subDivisionCode: codeToGeoJSON, roleTypeId: roleTypeId }))
  //   }else {
  //     const codeto = codeToGeoJSON.slice(0, 2);
  //     await Promise.all([
  //       dispatch(fetchGeoJson({ subDivisionCode: codeto, roleTypeId })),
  //       dispatch(fetchDivisionGeoJson({ subDivisionCode: codeto, roleTypeId }))
  //     ]);

  //   }

  // }, [])
  // useEffect(() => {
  //   const fetchData = async () => {
  //     let codeToGeoJSON = code;

  //     if (hierarchy === 52) {
  //       dispatch(fetchGeoJson({ subDivisionCode: codeToGeoJSON, roleTypeId }));
  //     } else {
  //       const codeto = codeToGeoJSON.slice(0, 2);

  //       await Promise.all([
  //         dispatch(fetchGeoJson({ subDivisionCode: codeto, roleTypeId })),
  //         dispatch(fetchDivisionGeoJson({ subDivisionCode: codeto, roleTypeId }))
  //       ]);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      let codeToGeoJSON = code;

      if (hierarchy === 52) {
        await dispatch(
          fetchGeoJson({ subDivisionCode: codeToGeoJSON, roleTypeId }),
        );
      } else {
        const codeto = codeToGeoJSON.slice(0, 2);

        await Promise.all([
          dispatch(
            fetchGeoJson({
              subDivisionCode: hierarchy == 1 ? "15" : codeto,
              roleTypeId,
            }),
          ),
          dispatch(
            fetchDivisionGeoJson({
              subDivisionCode: hierarchy == 1 ? "15" : codeto,
              roleTypeId,
            }),
          ),
        ]);
      }
    };

    fetchData(); // Call the async function

    // Optional cleanup (only if needed)
    return () => {
      // clean up logic here (e.g., abort fetches, remove listeners)
    };
  }, []); // Add dependencies if needed

  // const profilePictureFormik = useFormik({
  //   initialValues,
  //   validationSchema: Yup.object({
  //     iv_profile_picture: Yup.mixed()
  //       .test('fileType', 'Only JPEG and PNG images are allowed', (value) => {
  //         if (typeof value === 'string') return true;
  //         if (!value) return true;
  //         return value && (value.type === 'image/jpeg' || value.type === 'image/png');
  //       })
  //       .test('fileSize', 'File size must be less than 3MB', (value) => {
  //         if (typeof value === 'string') return true;
  //         if (!value) return true;
  //         return value && value.size <= 3 * 1024 * 1024; // Check if size is less than 3MB
  //       })
  //       .optional(),
  //   }),
  //   onSubmit: async (values, { resetForm }) => {
  //     console.log("Consolling Pic handleSubmit.")
  //     setViewBackdrop(true);
  //     try {

  //       const myHeaders = new Headers();
  //       myHeaders.append("Authorization", token);

  //       const formdata = new FormData();
  //       formdata.append("userName", userId);
  //       formdata.append("profilePicture", values.iv_profile_picture);

  //       const requestOptions = {
  //         method: "PUT",
  //         headers: myHeaders,
  //         body: formdata,
  //         redirect: "follow"
  //       };

  //       await fetch(cfpBaseUrl + "customerFaciliationPortal/updateUserProfileImage", requestOptions)
  //         .then((response) => response.json())
  //         .then((result) => {
  //           if (result.stats === "200") {
  //             // dispatch(updateProfilePicture())
  //           }
  //         })
  //         .catch((error) => {
  //           setApiError('Unable to update profile picture.')
  //           console.error(error)
  //         });
  //     }
  //     catch (e) {
  //       setApiError('Unable to update profile picture.')
  //     }
  //     setViewBackdrop(false);
  //   },
  // });
  const profilePictureFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_profile_picture: Yup.mixed()
        .test("fileType", "Only JPEG and PNG images are allowed", (value) => {
          if (typeof value === "string") return true;
          if (!value) return true;
          return (
            value && (value.type === "image/jpeg" || value.type === "image/png")
          );
        })
        .test("fileSize", "File size must be less than 3MB", (value) => {
          if (typeof value === "string") return true;
          if (!value) return true;
          return value && value.size <= 3 * 1024 * 1024;
        })
        .optional(),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      try {
        if (typeof values.iv_profile_picture === "string") {
          setViewBackdrop(false);
          return;
        }

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const formdata = new FormData();
        formdata.append("userName", userId);
        formdata.append("profilePicture", values.iv_profile_picture);

        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/updateUserProfileImage",
          {
            method: "PUT",
            headers: myHeaders,
            body: formdata,
            redirect: "follow",
          },
        );

        const result = await response.json();

        if (result.status === "200") {
          const reader = new FileReader();
          reader.onloadend = () => {
            dispatch(updateProfilePicture(reader.result));
          };
          reader.readAsDataURL(values.iv_profile_picture);
        } else {
          setApiError("Unable to update profile picture.");
        }
      } catch (error) {
        console.error(error);
        setApiError("Unable to update profile picture.");
      }

      setViewBackdrop(false);
    },
  });

  const passwordChangeFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_old_password: Yup.string().required("Old password is required"),
      iv_new_password: Yup.string()
        .matches(
          passwordRegex,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long",
        )
        .required("Password is required"),
      iv_confirm_password: Yup.string()
        .oneOf(
          [Yup.ref("iv_new_password"), null],
          "Password and Confirm password must match",
        )
        .required("Confirm password is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const formdata = new FormData();
      formdata.append("userName", userId);
      formdata.append("newPassword", values.iv_new_password);
      formdata.append("currentPassword", values.iv_old_password);

      var requestOptions = {
        method: "PUT",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "customerFaciliationPortal/updateUserPassword",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            resetForm();
            window.location.reload();
          } else if (result.status === "400") {
            setApiError(result.message);
          }
        })
        .catch((error) => console.log("error", error));
      setViewBackdrop(false);
    },
  });

  const getWFData = async (officeCodee) => {
    setViewBackdrop(true);
    let wfData = await getWorkforceData(
      token,
      officeCodee ? officeCodee : offCode,
    );
    const filteredData = wfData.filter((item) => item.designation !== 1135);
    setWorkForceData(filteredData);
    setViewBackdrop(false);
  };
  useEffect(() => {
    getWFData(code);
  }, []);
  const getWorkForceDesignations = async () => {
    let fieldStaffDesignations = await getFieldStaffDesignations(token);

    setFieldStaffDesignations(fieldStaffDesignations);
  };

  const deleteLmData = async (name) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", wmsPrivateToken);
    const formdata = new FormData();
    formdata.append("UserId", name);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    setViewBackdrop(true);
    await fetch(
      wfsBaseUrl + "api/UserInfo/DeleteEOpsLMUserById",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.Status == "200") {
          setApiError(result.Message);
          setViewBackdrop(false);
        } else {
          setApiError(result.Message);
          setViewBackdrop(false);
        }
      })
      .catch((error) => console.error(error));
  };

  const lmSignUpFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_lm_user_name: Yup.string().optional("Name is required"),
      iv_designation: Yup.string().optional("Designation is required"),
      iv_lm_phone_no: Yup.string().optional("Phone No. is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", wmsPrivateToken);
        myHeaders.append("Content-Type", "application/json");

        const userData = [];

        shift1Fields.forEach((field, index) => {
          if (field.isModified && field.name && field.phoneNo) {
            // Ensure the field is modified and valid
            userData.push({
              UserFullName: field.name,
              PhoneNo: field.phoneNo,
              CompanyCode: hierarchy == 52 ? code.toString().slice(0, 2) : "15",
              CircleCode: hierarchy == 52 ? code.toString().slice(0, 3) : "151",
              DivisionCode:
                hierarchy == 52 ? code.toString().slice(0, 4) : "1517",
              SubDivisionCode: hierarchy == 52 ? code : "15171",
              ShiftId: "1",
              Designation: field.designation,
            });
          }
        });

        shift2Fields.forEach((field, index) => {
          if (field.isModified && field.name && field.phoneNo) {
            // Ensure the field is modified and valid
            userData.push({
              UserFullName: field.name,
              PhoneNo: field.phoneNo,
              CompanyCode: hierarchy == 52 ? code.toString().slice(0, 2) : "15",
              CircleCode: hierarchy == 52 ? code.toString().slice(0, 3) : "151",
              DivisionCode:
                hierarchy == 52 ? code.toString().slice(0, 4) : "1517",
              SubDivisionCode: hierarchy == 52 ? code : "15171",
              ShiftId: "2",
              Designation: field.designation,
            });
          }
        });
        shift3Fields.forEach((field, index) => {
          if (field.isModified && field.name && field.phoneNo) {
            // Ensure the field is modified and valid
            userData.push({
              UserFullName: field.name,
              PhoneNo: field.phoneNo,
              CompanyCode: hierarchy == 52 ? code.toString().slice(0, 2) : "15",
              CircleCode: hierarchy == 52 ? code.toString().slice(0, 3) : "151",
              DivisionCode:
                hierarchy == 52 ? code.toString().slice(0, 4) : "1517",
              SubDivisionCode: hierarchy == 52 ? code : "15171",
              ShiftId: "3",
              Designation: field.designation,
            });
          }
        });

        if (userData.length > 0) {
          const requestBody = JSON.stringify(userData);
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: requestBody,
            redirect: "follow",
          };

          await fetch(wfsBaseUrl + "api/UserInfo/EOpsLMSignUp", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              if (result.status === "200") {
              } else {
                setApiError(result.Message);
              }
            })
            .catch((error) => {
              setApiError(error);
              console.error(error);
            });
        }
      } catch (e) {
        setApiError(e);
        console.error(e);
      }
      setViewBackdrop(false);
    },
  });

  const workForceAddFormik = useFormik({
    initialValues: workForceInitialValues,
    validationSchema: Yup.object().shape({
      iv_name: Yup.string()
        .min(3, "Name should be atleast 3 characters.")
        .max(30, "Name should be less than 30 characters.")
        .required("Please enter lineman name.")
        .matches(/^[A-Za-z. ]*$/, "Only letters and '.' are allowed."),
      iv_designation: Yup.mixed().required("Designation is required!"),
      iv_shift: Yup.mixed().optional(),
      iv_phone: Yup.string()
        .max(11, "Please enter 11 digit phone number.")
        .min(11, "Please enter 11 digit phone number.")
        .required("Please enter valid mobile number.")
        .matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone number as 03001234567"),
      iv_userId: Yup.string().required("User Id is required"),
      iv_password: Yup.string()
        .matches(
          passwordRegex,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long",
        )
        .required("Password is required"),
      iv_confirm_password: Yup.string()
        .oneOf(
          [Yup.ref("iv_password"), null],
          "Password and Confirm password must match",
        )
        .required("Confirm password is required"),
      iv_cnic: Yup.string()
        .min(13, "CNIC no. can not less than 13 digits.")
        .max(13, "CNIC no. can not greater than 13 digits.")
        .required("CNIC No. is required")
        .matches(/^[0-9]+$/, "Enter CNIC No. as 3520212345678"),
      iv_employeeCode: Yup.string()
        .min(2, "Employee code must be at least 2 characters.")
        .max(14, "Employee code must be at most 14 characters.")
        .required("Employee code is required")
        .matches(
          /^[0-9]+$/,
          "Employee code must contain only numeric characters.",
        ),
      iv_subDivision: Yup.string().required("Sub-Division is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      try {
        let newWFArray = {
          employeeName: values.iv_name,
          employeeMobileNo: values.iv_phone,
          employeeDesignationId: values.iv_designation,
          createdBy: userId,
          companyCode: values.iv_subDivision.slice(0, 2),
          circleCode: values.iv_subDivision.slice(0, 3),
          divisionCode: values.iv_subDivision.slice(0, 4),
          subDivisionCode: values.iv_subDivision.slice(0, 5),
          hierarchy: hierarchy == 52 ? hierarchy : 52,
          employeeCode: values.iv_employeeCode,
          password: values.iv_password,
          userId: values.iv_userId,
          shiftDetails: addSelectedItems1,
          employeeCNIC: values.iv_cnic,
          // employeeCode : values.iv_employeeCode
        };
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify(newWFArray);

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        await fetch(cfpBaseUrl + "workForce/addNewEmployeeInfo", requestOptions)
          .then(async (response) => {
            if (response.status == 200) {
              window.location.reload();
              return response.json();
            } else {
              let res = await response.json();
              setApiError(res.message);
            }
          })
          .then((result) => {
            if (!result.message.startsWith("Failed to add employee")) {
              setAddWF(false);
              resetForm();
              getWFData();
              setApiError("");
            }
          })
          .catch((error) => console.error(error));
      } catch (e) {
        setApiError(e);
        console.error(e);
      }
      setViewBackdrop(false);
    },
  });

  useEffect(() => {
    if (!addWF && !editWF) {
      workForceAddFormik.values.iv_userId = "";
      workForceAddFormik.values.iv_name = "";
      workForceAddFormik.values.iv_phone = "";
      workForceAddFormik.values.iv_designation = "";
      workForceAddFormik.values.iv_password = "";
      workForceAddFormik.values.iv_cnic = "";
      workForceAddFormik.values.iv_employeeCode = "";
      workForceAddFormik.values.iv_userId = "";
      editWorkForceFormik.values.iv_name = "";
      editWorkForceFormik.values.iv_phone = "";
      editWorkForceFormik.values.iv_designation = "";
      editWorkForceFormik.values.iv_password = "";
      editWorkForceFormik.values.iv_cnic = "";
      editWorkForceFormik.values.iv_userId = "";
    }
  }, [addWF, editWF]);

  const getCoordinates = async (refNo) => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    await fetch(cpBaseUrl + "?refno=" + refNo, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.tblStatus[0].status) {
          setLatitudeOfRefNo(result.Table[0].GPSLATI);
          setLogitudeOfRefNo(result.Table[0].GPSLONG);
        }
      });
  };

  useEffect(() => {
    const fetchTransformerInfo = async (msnNumber) => {
      console.log("fetchTransformerInfo called with MSN:", msnNumber);
      setViewBackdrop(true);
      try {
        const requestOptions = {
          method: "GET",
          redirect: "follow",
        };

        const response = await fetch(
          `https://ibs-dashboard-data-api.pitc.com.pk/api/v1/common?apiName=eops_transformer_info&P_TRANSF_MTR_NO=${msnNumber}`,
          requestOptions,
        );
        const result = await response.json();

        if (result.rows && result.rows.length > 0) {
          const transformerData = result.rows[0];
          setFieldValue("iv_name", transformerData.TR_LOCATION || "");
          setFieldValue("iv_address", transformerData.FDRNAME || "");
          setFieldValue("iv_phone_no", transformerData.FEEDERCODE || "");
          setTransformerLat(transformerData.TRANS_LOC_LATITUDE || "");
          setTransformerLong(transformerData.TRANS_LOC_LONGITUDE || "");
          setTransformerSubDivCode(transformerData.SDIV_CODE || code || "");
          setTransformerRefNo(transformerData.TRANS_REF_NO || "");
          setComplaintsError("");
        } else {
          setComplaintsError("No transformer data found for this MSN.");
          setFieldValue("iv_name", "");
          setFieldValue("iv_address", "");
          setFieldValue("iv_phone_no", "");
        }
      } catch (error) {
        console.error("Error fetching transformer info:", error);
        setComplaintsError("Error fetching transformer information.");
      }
      setViewBackdrop(false);
    };

    const callBillAPI = async () => {
      if (
        values.iv_con_id_ref_no.length === 10 &&
        selectedOption == "consumerId"
      ) {
        referenceApi(); // function to fetch current information on behalf of reference number
      } else if (
        values.iv_con_id_ref_no.length === 14 &&
        selectedOption == "referenceNo"
      ) {
        referenceApi(); // function to fetch current information on behalf of reference number
      } else if (
        values.iv_con_id_ref_no.length === 12 &&
        selectedOption == "apmsMsn"
      ) {
        fetchTransformerInfo(values.iv_con_id_ref_no); // function to fetch transformer info by MSN
      } else {
        setComplaintsError("");
        setPhase();
        setMeterNo();
        setMeterType();
        setTariff();
        setTypeId(1);
        values.iv_consumer_id = "";
        values.iv_name = "";
        values.iv_phone_no = "";
        values.iv_address = "";
        setReferenceNumber();
        return;
      }
    };

    callBillAPI();
  }, [values.iv_con_id_ref_no, selectedOption]);
  //#endregion

  const feederFormClose = () => {
    setShowFeederForm(false);
  };

  const apmsFormClose = () => {
    setShowApmsForm(false);
  };

  useEffect(() => {
    if (!showProfileEditPopup) {
      nameFormik.values.iv_full_name = "";
      phoneFormik.values.iv_user_phone_no = "";
      emailFormik.values.iv_user_email = "";
      profilePictureFormik.values.iv_profile_picture = "";
    }
  }, [showProfileEditPopup]);

  const referenceApi = async () => {
    setViewBackdrop(true);
    let apiResponse = await dBillAPI(token, values.iv_con_id_ref_no);
    if (apiResponse.status) {
      setMeterNo(apiResponse.metersInfo[0].mtrNo);
      setMeterType(apiResponse.basicInfo.meterType);
      setFeederNo(apiResponse.basicInfo.feederCode);

      setMeterType(apiResponse.basicInfo.meterType);
      setMeterPhase(apiResponse.basicInfo.phase);
      setPhase(apiResponse.basicInfo.phase);
      setTariff(apiResponse.basicInfo.tariffDescription);
      setArrear(apiResponse.basicInfo.arrear);
      setMeterStatus(apiResponse.basicInfo.meter1Status);

      setSliceRefNo(
        apiResponse.basicInfo.refNo.replace(/\s+/g, "").slice(2, 7),
      );

      setReferenceNumber(
        apiResponse.basicInfo.refNo.replace(/ /g, "").slice(0, 14),
      );
      setViewBackdrop(false);

      setBillMonth(apiResponse.basicInfo.billMonth.slice(0, 10));
      values.iv_name = apiResponse.basicInfo.consumerName;
      values.iv_phone_no =
        apiResponse.basicInfo.consumerContactNo.toString().length == 12 &&
        apiResponse.basicInfo.consumerContactNo.toString().startsWith("92")
          ? "0".concat(
              apiResponse.basicInfo.consumerContactNo.toString().slice(2, 12),
            )
          : apiResponse.basicInfo.consumerContactNo;
      values.iv_address =
        apiResponse.basicInfo.consumerAddress1 +
        " " +
        apiResponse.basicInfo.consumerAddress2;
      getCoordinates(
        apiResponse.basicInfo.refNo.replace(/ /g, "").slice(0, 14),
      );

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        code: [apiResponse.basicInfo.feederCode],
        disco_code: apiResponse.basicInfo.refNo.trim().slice(2, 5) + "000",

        // "disco_code":  apiResponse.basicInfo.refNo.slice(2,5) + '000'
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "lineComplaints/GetFeederStatus", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          const currentStatus =
            result?.[0]?.response?.data?.[0]?.current_status || "N/A";
          console.log(currentStatus, "currentStatus");
          setFeederStatus(currentStatus);
          // if (currentStatus === 'OFF') {
          //   setShowComplaintErrorForm(true)
          // }
        })
        .catch((error) =>
          console.error("Error fetching feeder status:", error),
        );

      {
        (apiResponse.basicInfo.arrear < 0 ||
          feederStatus === "OFF" ||
          apiResponse.basicInfo.meter1Status == "P.DISC" ||
          apiResponse.basicInfo.meter1Status == "T.DISC") &&
          setShowComplaintErrorForm(true);
      }
    } else if (apiResponse.status == false) {
      setComplaintsError("No Data Found against this Reference No.");
    } else {
      setComplaintsError("Reference No. not found!");
    }
    setViewBackdrop(false);
  };

  const complaintErrorFormClose = () => {
    setShowComplaintErrorForm(false);
  };

  const handleAddField = (shift, setShiftFields) => {
    setShiftFields([
      ...shift,
      { name: "", designation: "", phoneNo: "", userId: "", isModified: false },
    ]);
  };

  function getCurrentDateFormatted(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const options = { month: "short" };
    const month = date.toLocaleString("en-US", options);
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  }

  const DownloadFeederListPdf = async (print) => {
    return new Promise((resolve, reject) => {
      const title = officeName(officeCode, subDivisions);
      let dateToPrint = getCurrentDateFormatted(new Date());
      const pdf = new jsPDF("landscape", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight,
      );

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text("Feeder List", pageWidth / 2, 18, { align: "center" });
      pdf.setFontSize(10);
      pdf.text(
        `Feeder List for ${title} of ${dateToPrint} `,
        pageWidth / 2,
        25,
        { align: "center" },
      );

      // Add the user details
      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      const headers = [
        { content: "Feeder", styles: { halign: "center" } },
        { content: "Feeder Code", styles: { halign: "center" } },
        { content: "Current (Amps)", styles: { halign: "center" } },
        { content: "Voltage (kV)", styles: { halign: "center" } },
        { content: "P.F (%)", styles: { halign: "center" } },
        { content: "Load (MW)", styles: { halign: "center" } },
        { content: "Status", styles: { halign: "center" } },
        { content: "Last Reporting Time", styles: { halign: "center" } },
      ];

      let bodyData = [];
      let dataAvailable = false;

      Object.keys(groupedFeeders).forEach((gridName) => {
        bodyData.push([
          {
            content: gridName.replace(/132 KV\s*/, "132 KV - "),
            colSpan: 8,
            styles: {
              halign: "start",
              fontSize: 10,
              fontStyle: "bold",
              fillColor: [240, 248, 255],
            },
          },
        ]);

        groupedFeeders[gridName].forEach((feeder) => {
          dataAvailable = true;
          const currentStatus = feeder.current > 3 ? "ON" : "OFF";
          bodyData.push([
            { content: feeder.feeder || "-", styles: { halign: "center" } },
            {
              content: feeder.feeder_code || "-",
              styles: { halign: "center" },
            },
            {
              content: feeder.current > 3 ? Math.abs(feeder.current) : "-",
              styles: { halign: "center" },
            },
            { content: Math.abs(feeder.voltage), styles: { halign: "center" } },
            {
              content:
                currentStatus === "ON" ? Math.abs(feeder.power_factor) : "-",
              styles: { halign: "center" },
            },
            {
              content:
                currentStatus === "ON" ? Math.abs(feeder.active_power_kW) : "-",
              styles: { halign: "center" },
            },
            {
              content: currentStatus,
              styles: {
                halign: "center",
                fontStyle: currentStatus === "ON" ? "bold" : "normal",
              },
            },
            {
              content: feeder.last_reporting_time || "-",
              styles: { halign: "center" },
            },
          ]);
        });
      });

      if (!dataAvailable) {
        bodyData.push([
          {
            content: "No Data Found",
            colSpan: 8,
            styles: {
              halign: "center",
              fontSize: 12,
              fontStyle: "bold",
              fillColor: [255, 255, 255],
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      pdf.autoTable({
        startY: 28,
        head: [headers],
        body: bodyData,
        styles: { cellPadding: 3, fontSize: 8, halign: "center" },
        tableWidth: "wrap",
        theme: "striped",
        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 40 },
          2: { cellWidth: 30 },
          3: { cellWidth: 30 },
          4: { cellWidth: 30 },
          5: { cellWidth: 30 },
          6: { cellWidth: 30 },
          7: { cellWidth: 40 },
        },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      if (print) {
        pdf.save("Feeder-List.pdf");
        resolve(pdf);
      } else {
        resolve(pdf);
      }
    });
  };

  const exportFeederListToExcel = () => {
    const dateToPrint = new Date().toISOString().split("T")[0]; // Get formatted date

    // Prepare data array
    const data = [];
    data.push(["Feeder Information"]); // Add a heading
    data.push([]); // Add an empty row for spacing

    Object.keys(groupedFeeders).forEach((gridName) => {
      data.push([`${gridName.replace(/132 KV\s*/, "132 KV - ")}`]); // Add grid name as a header
      data.push([
        "Feeder",
        "Feeder Code",
        "Current (Amps)",
        "Voltage (kV)",
        "P.F (%)",
        "Load (MW)",
        "Status",
        "Last Reporting Time",
      ]); // Add column headers

      groupedFeeders[gridName].forEach((feeder) => {
        const currentStatus = feeder.current > 3 ? "ON" : "OFF";
        data.push([
          feeder.feeder,
          feeder.feeder_code,
          feeder.current > 3 ? Math.abs(feeder.current) : "-",
          Math.abs(feeder.voltage),
          currentStatus === "ON" ? Math.abs(feeder.power_factor) : "-",
          currentStatus === "ON" ? Math.abs(feeder.active_power_kW) : "-",
          currentStatus,
          feeder.last_reporting_time,
        ]);
      });
      data.push([]); // Add an empty row for spacing
    });

    // Convert data array to worksheet
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Feeder Data");

    // Write the workbook and save it as a file
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const filename = `${dateToPrint} - Feeder-List.xlsx`;
    saveAs(new Blob([wbout]), filename);
  };

  const printFeederListPDF = async () => {
    let pdf = await DownloadFeederListPdf(false);
    const pdfUrl = pdf.output("bloburl");

    // Create an iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  const DownloadAPMSPdf = async (print) => {
    return new Promise((resolve, reject) => {
      const title = officeName(officeCode, subDivisions);
      let dateToPrint = getCurrentDateFormatted(new Date());

      const pdf = new jsPDF("landscape", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight,
      );

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text("APMS Information", pageWidth / 2, 18, { align: "center" });
      pdf.setFontSize(10);
      pdf.text(`APMS List for ${title} of ${dateToPrint} `, pageWidth / 2, 25, {
        align: "center",
      });

      // Add the user details
      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      // Table headers
      const headers = [
        { content: "Capacity (kVA)", styles: { halign: "center" } },
        { content: "Location", styles: { halign: "center" } },
        { content: "MSN", styles: { halign: "center" } },
        { content: "Current (Amps)", styles: { halign: "center" } },
        { content: "Voltage (kV)", styles: { halign: "center" } },
        { content: "Status", styles: { halign: "center" } },
        { content: "Last Communication Time", styles: { halign: "center" } },
      ];

      let bodyData = [];
      let dataAvailable = false;

      // Loop through `groupedAPMS` object
      Object.keys(groupedAPMS).forEach((gridName) => {
        const feeders = groupedAPMS[gridName]
          ? Object.values(groupedAPMS[gridName])
          : [];
        feeders.forEach((feeder) => {
          dataAvailable = true;
          const {
            apms_capacity = "N/A",
            name = "N/A",
            msn = "N/A",
            current = "N/A",
            voltage = "N/A",
            status = "N/A",
            last_communication_time = "N/A",
          } = feeder;

          const statusColor = status === "ON" ? "green" : "red";

          bodyData.push([
            { content: `${apms_capacity} kVA`, styles: { halign: "center" } },
            { content: name, styles: { halign: "center" } },
            { content: msn, styles: { halign: "center" } },
            { content: current, styles: { halign: "center" } },
            { content: voltage, styles: { halign: "center" } },
            {
              content: status,
              styles: { halign: "center", textColor: statusColor },
            },
            { content: last_communication_time, styles: { halign: "center" } },
          ]);
        });
      });

      // If no data, add a row indicating this
      if (!dataAvailable) {
        bodyData.push([
          {
            content: "No Data Found",
            colSpan: 7,
            styles: {
              halign: "center",
              fontSize: 12,
              fontStyle: "bold",
              fillColor: [255, 255, 255],
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      // Generate table with custom column width for Location and MSN
      pdf.autoTable({
        startY: 28,
        head: [headers],
        body: bodyData,
        styles: { cellPadding: 3, fontSize: 8, halign: "center" },
        tableWidth: "wrap",
        theme: "striped",
        columnStyles: {
          0: { cellWidth: 30 },
          1: { cellWidth: 80 },
          2: { cellWidth: 30 },
          3: { cellWidth: 30 },
          4: { cellWidth: 30 },
          5: { cellWidth: 30 },
          6: { cellWidth: 35 },
        },
      });

      // Add footer for page numbers
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      // Save the PDF
      if (print) {
        pdf.save("APMS-List.pdf");
        resolve(pdf);
      } else {
        resolve(pdf);
      }
    });
  };

  const exportAPMSDataToExcel = () => {
    // Get the current date for the filename
    const dateToPrint = new Date().toISOString().split("T")[0];

    // Prepare data array for Excel
    const data = [];
    data.push(["APMS Feeder Information"]); // Add a heading
    data.push([]); // Add an empty row for spacing

    // Iterate through groupedAPMS object
    Object.keys(groupedAPMS).forEach((gridName) => {
      // Add grid name as a section header
      data.push([
        "Capacity (kVA)",
        "Location",
        "Msn",
        "Current (Amps)",
        "Voltage (kV)",
        "Status",
        "Last Communication Time",
      ]); // Add column headers

      groupedAPMS[gridName].forEach((feeder) => {
        const {
          apms_capacity = "N/A",
          name = "N/A",
          msn = "N/A",
          current = "N/A",
          voltage = "N/A",
          status = "N/A",
          last_communication_time = "N/A",
        } = feeder;

        data.push([
          `${apms_capacity} kVA`,
          name,
          msn,
          current,
          voltage,
          status,
          last_communication_time,
        ]);
      });

      data.push([]); // Add an empty row for spacing
    });

    // Convert data array to worksheet
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "APMS Data");

    // Write the workbook and save it as a file
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const filename = `${dateToPrint} - APMS-List.xlsx`;
    saveAs(new Blob([wbout]), filename);
  };
  const printAPMSPDF = async () => {
    let pdf = await DownloadAPMSPdf(false);
    const pdfUrl = pdf.output("bloburl");

    // Create an iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  const handleFieldChange = (
    index,
    field,
    value,
    shiftFields,
    setShiftFields,
  ) => {
    const updatedFields = [...shiftFields];
    updatedFields[index] = {
      ...updatedFields[index],
      [field]: value,
      isModified: true, // Mark this field as modified
    };
    setShiftFields(updatedFields);
    setIsFormModified(true); // Mark the form as modified
  };

  const handleFieldChangeWorkForce = (
    index,
    field,
    value,
    workforceData,
    setWorkForceData,
  ) => {
    const updatedFields = [...workforceData];
    updatedFields[index] = {
      ...updatedFields[index],
      [field]: value,
      isModified: true, // Mark this field as modified
    };

    setWorkForceData(updatedFields);
    setIsFormModifiedWorkForce(true); // Mark the form as modified
  };

  const handleDeleteField = (index, shift, setShiftFields) => {
    const newFields = shift.filter((_, i) => i !== index);
    setShiftFields(newFields);
  };

  const openNewTabAndRefocus = () => {
    setTimeout(() => {
      window.open("/power-complaint-display-complaint", "_blank");
      window.open("/power-complaint-map", "_top");
    }, 0);
  };

  const renderFields = (shiftFields, setShiftFields) =>
    shiftFields.map((field, index) => (
      <Grid
        container
        spacing={2}
        key={index}
        sx={{ marginBottom: "10px", alignItems: "center" }}
      >
        <Grid item lg={4}>
          <TextField
            type="text"
            onBlur={handleBlur}
            value={field.name}
            className="textInputField"
            onChange={(e) =>
              handleFieldChange(
                index,
                "name",
                e.target.value,
                shiftFields,
                setShiftFields,
              )
            }
            fullWidth
            sx={{ backgroundColor: "lightgray", fontSize: "5px" }}
          />
        </Grid>
        <Box className="from-Error">
          {errors.iv_lm_user_name && touched.iv_lm_user_name
            ? errors.iv_lm_user_name
            : null}
        </Box>
        <Grid item xs={3} sx={{ paddingRight: "20px" }}>
          <Select
            autoWidth={false}
            autoFocus
            value={
              field.designation ? field.designation : values.iv_designation
            }
            onChange={(e) =>
              handleFieldChange(
                index,
                "designation",
                e.target.value,
                shiftFields,
                setShiftFields,
              )
            }
            onBlur={handleBlur}
            style={{ color: "black" }}
            placeholder="Designation"
            className="connectionTypeDropDownList"
            name="iv_designation"
            id="iv_designation"
          >
            <MenuItem value="">Select Type</MenuItem>
            <MenuItem value="Ls">LS</MenuItem>
            <MenuItem value="Lm">LM</MenuItem>
            <MenuItem value="Alm">ALM</MenuItem>
          </Select>
          <Box className="from-Error">
            {errors.iv_designation && touched.iv_designation
              ? errors.iv_designation
              : null}
          </Box>
        </Grid>
        <Grid item lg={4}>
          <TextField
            value={field.phoneNo}
            type="text"
            // value={values.iv_name}
            onBlur={handleBlur}
            className="textInputField"
            onChange={(e) =>
              handleFieldChange(
                index,
                "phoneNo",
                e.target.value,
                shiftFields,
                setShiftFields,
              )
            }
            fullWidth
            sx={{ backgroundColor: "lightgray", fontSize: "5px" }}
            inputProps={{ maxLength: 11, autoComplete: "off" }}
          />
        </Grid>
        <Box className="from-Error">
          {errors.iv_lm_phone_no && touched.iv_lm_phone_no
            ? errors.iv_lm_phone_no
            : null}
        </Box>
        {shiftFields.length > 5 && (
          <Grid
            item
            lg={1}
            sx={{ display: "flex", justifyContent: "center" }}
            onClick={() => deleteLmData(field.userId)}
          >
            <IconButton
              onClick={() =>
                handleDeleteField(index, shiftFields, setShiftFields)
              }
              sx={{ backgroundColor: "lightgray", color: "red" }}
            >
              <DeleteIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>
    ));

  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  const DownloadLinemanPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let dateToPrint = getCurrentDateFormatted(new Date());

      // ✅ Shift Mapping
      const shiftMapping = {
        1: "M",
        2: "E",
        3: "N",
      };

      // Define header structure
      const headers = [
        [
          { content: "Name" },
          { content: "SubDiv Code" },
          { content: "Designation" },
          { content: "Employee Code" },
          { content: "Shift" },
          { content: "Phone No." },
          { content: "CNIC" },
          { content: "UserId" },
        ],
      ];

      // Define data rows based on workForceData
      const body = [];

      if (filteredWorkforce && filteredWorkforce.length > 0) {
        filteredWorkforce.forEach((employee) => {
          // ✅ Find Designation Name
          const desg = desginationList.find(
            (d) => d.employeeDesignationId === employee.designation,
          );
          const designationName = desg
            ? desg.employeeDesignationName
            : employee.designation;

          // ✅ Convert shift numbers → letters
          let shiftValue = employee.shift;
          if (shiftValue) {
            shiftValue = shiftValue
              .toString()
              .split(",")
              .map((s) => shiftMapping[s.trim()] || s)
              .join(",");
          }
          body.push([
            employee.name || "-",
            employee.subDivisionCode || "-",
            designationName || "-",
            employee.employeeCode || "-",
            shiftValue || "-",
            employee.phoneNo || "-",
            employee.cnic || "-",
            employee.userId || "-",
          ]);
        });
      } else {
        body.push([
          {
            content: "No Data Found",
            colSpan: 12,
            styles: {
              halign: "center",
              fontSize: 10,
              fontStyle: "bold",
              fillColor: [255, 255, 255],
              textColor: [255, 0, 0],
            },
          },
        ]);
      }

      // Initialize PDF
      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "26" ||
        companyCode === "38" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "26" ||
        companyCode === "38" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "26" ||
        companyCode === "38" ||
        companyCode === "48" ||
        companyCode === "59"
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "26" ||
          companyCode === "38" ||
          companyCode === "48" ||
          companyCode === "59"
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight,
      );

      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 50, 12);
      pdf.text("Name: " + name, pageWidth - 50, 17);
      pdf.text("Designation: " + roleName, pageWidth - 50, 22);

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(`Work Force Management List`, pageWidth / 2, 18, {
        align: "center",
      });
      pdf.setFontSize(10);
      pdf.text(
        `Work Force List for ${officeNamee} of ${dateToPrint}`,
        pageWidth / 2,
        25,
        { align: "center" },
      );

      // ✅ Generate table in PDF
      pdf.autoTable({
        startY: 28,
        head: headers,
        body: body,
        styles: {
          cellPadding: 1,
          fontSize: 8,
          halign: "center",
          lineWidth: 0.25,
          lineColor: "white",
        },
        margin: { top: 2 },
        theme: "striped",
        headStyles: { valign: "middle" },
        bodyStyles: {
          halign: "center",
        },
        columnStyles: {
          0: { halign: "left" },
        },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      if (print) {
        pdf.save(`${officeNamee}-${dateToPrint}-Work-Force-List.pdf`);
      } else {
        resolve(pdf);
      }
    });
  };

  useEffect(() => {
    const getDesgination = async () => {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const raw = "";
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(
        cfpBaseUrl + "workForce/getListOfSubDivisionDesignations",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          setViewBackdrop(false);
          if (result.message == "Data Found.") {
            setDesginationList(result.data);
          }
        })
        .catch((error) => console.error(error));
    };
    getDesgination();
  }, []);

  const exportLinemanToExcel = (fileName = "Workforce_Data") => {
    let dateToPrint = getCurrentDateFormatted(new Date());

    const shiftMapping = {
      1: "M",
      2: "E",
      3: "N",
    };

    const filteredData = filteredWorkforce.map(
      ({ password, designation, shift, ...rest }) => {
        const desg = desginationList.find(
          (d) => d.employeeDesignationId === designation,
        );

        // ✅ Convert shift numbers → letters
        let shiftValue = shift;
        if (shift) {
          shiftValue = shift
            .toString()
            .split(",")
            .map((s) => shiftMapping[s.trim()] || s)
            .join(",");
        }

        return {
          ...rest,
          designation: desg ? desg.employeeDesignationName : designation,
          shift: shiftValue, // ✅ replace with converted value
        };
      },
    );

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const fullFileName = `${officeNamee}-${dateToPrint}-Work-Force-List.xlsx`;
    XLSX.writeFile(workbook, fullFileName);
  };

  const printLinemanPDF = async () => {
    let pdf = await DownloadLinemanPdf(false);
    const pdfUrl = pdf.output("bloburl");

    // Create an iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  // const excelWorkForce = () => {
  //   console.log(workForceData, 'printing workforce data')
  //   const worksheet = XLSX.utils.json_to_sheet(workForceData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  //   // Write the workbook and download it
  //   XLSX.writeFile(workbook, "Workforce Data.xlsx");

  // }

  // const printWorkForce = () => {
  //   const worksheet = XLSX.utils.json_to_sheet(workForceData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  //   XLSX.writeFile(workbook, "Workforce Data.xlsx");
  // }

  const handleEditWF = (WFData) => {
    if (WFData) {
      setWorkForceToEdit(WFData);
      editWorkForceFormik.values.iv_name = WFData.name;
      editWorkForceFormik.values.iv_designation = WFData.designation;

      const shiftIdsArray = WFData.shift
        ? WFData.shift.split(",").map(Number)
        : [];
      setEditSelectedItems(shiftIdsArray);

      const shiftIdsArrays = WFData.shift
        ? WFData.shift.split(",").map(Number)
        : [];

      const formattedShiftIds = shiftIdsArrays.map((id) => ({ shiftId: id }));
      setEditSelectedItems1(formattedShiftIds);

      editWorkForceFormik.values.iv_shift = WFData.shift;
      editWorkForceFormik.values.iv_phone = WFData.phoneNo;
      editWorkForceFormik.values.iv_cnic = WFData.cnic;
      editWorkForceFormik.values.iv_employeeCode = WFData.employeeCode;
      editWorkForceFormik.values.iv_userId = WFData.userId;
      editWorkForceFormik.values.iv_password = WFData.password;
      editWorkForceFormik.values.iv_confirm_password = WFData.password;
      setEditWF(true);
    }
  };
  const passwordChangeWorkForceFormik = useFormik({
    initialValues: workForceInitialValues,
    validationSchema: Yup.object().shape({
      iv_userId: Yup.string().required("UserId is required!"),
      iv_remarks: Yup.string().required("Remarks is required!"),
      iv_password: Yup.string()
        .matches(
          passwordRegex,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long",
        )
        .required("Password is required"),
      iv_confirm_password: Yup.string()
        .oneOf(
          [Yup.ref("iv_password"), null],
          "Password and Confirm password must match",
        )
        .required("Confirm password is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        userId: values.iv_userId,
        remarks: values.iv_remarks,
        password: values.iv_password,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(
        cfpBaseUrl + "customerFaciliationPortal/changePasswordofUser",
        requestOptions,
      )
        .then(async (response) => {
          if (response.status == 200) {
            setPasswordWF(false);
            resetForm();
            getWFData();
            setApiError("");
            return response.json();
          } else {
            let res = await response.json();
            setApiError(res.message);
          }
        })
        .catch((error) => console.error(error));
    },
  });
  const handleDeleteWF = (WFData) => {
    if (WFData) {
      setWorkForceToDelete(WFData);
      setDeleteLMWarning(true);
    }
  };

  const renderFieldsWorkforce = (workforceData, setWorkforceData) => {
    return workforceData.map((field, index) => (
      <Grid
        container
        key={index}
        sx={{
          marginBottom: "10px",
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Grid
          item
          lg={0.5}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <label>{index + 1}</label>
        </Grid>

        <Grid item lg={4} sx={{ paddingRight: "0px" }}>
          <input
            type="text"
            className="textInputField"
            onBlur={workForceAddFormik.handleBlur}
            disabled={!field.isModified}
            name={`workForceData[${index}].name`}
            onChange={(e) => {
              handleFieldChangeWorkForce(
                index,
                "name",
                e.target.value,
                workforceData,
                setWorkforceData,
              );
              workForceAddFormik.setFieldValue(
                `workForceData[${index}].name`,
                e.target.value,
              );
            }}
            value={field.name}
            style={{
              color: "black",
              fontSize: "20px",
              width: "90%",
              padding: 10,
              backgroundColor: "lightgray",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
          />

          <Box className="from-Error">
            {workForceAddFormik.errors.workForceData?.[index]?.name &&
            workForceAddFormik.touched.workForceData?.[index]?.name
              ? workForceAddFormik.errors.workForceData[index].name
              : null}
          </Box>
        </Grid>

        <Grid item xs={2} sx={{ paddingRight: "20px" }}>
          <select
            value={field.designation || ""}
            disabled={!field.isModified}
            onChange={(e) => {
              handleFieldChangeWorkForce(
                index,
                "designation",
                e.target.value,
                workforceData,
                setWorkforceData,
              );
              workForceAddFormik.setFieldValue(
                `workForceData[${index}].designation`,
                e.target.value,
              );
            }}
            onBlur={workForceAddFormik.handleBlur}
            className="connectionTypeDropDownList"
            name={`workForceData[${index}].designation`}
            style={{
              color: "black",
              backgroundColor: "lightgray",
              height: "20%",
              fontSize: "20px",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
          >
            <option value="">Select Type</option>
            {fieldStaffDesignations.map((item, idx) => (
              <option value={item.employeeDesignationId} key={idx}>
                {item.employeeDesignationName}
              </option>
            ))}
          </select>

          <Box className="from-Error">
            {workForceAddFormik.errors.workForceData?.[index]?.designation &&
            workForceAddFormik.touched.workForceData?.[index]?.designation
              ? workForceAddFormik.errors.workForceData[index].designation
              : null}
          </Box>
        </Grid>

        <Grid item lg={3} sx={{ paddingRight: "0px" }}>
          <input
            value={field.phoneNo}
            type="text"
            onBlur={workForceAddFormik.handleBlur}
            disabled={!field.isModified}
            className="textInputField"
            onChange={(e) => {
              handleFieldChangeWorkForce(
                index,
                "phoneNo",
                e.target.value,
                workforceData,
                setWorkforceData,
              );
              workForceAddFormik.setFieldValue(
                `workForceData[${index}].phoneNo`,
                e.target.value,
              );
            }}
            name={`workForceData[${index}].phoneNo`}
            style={{
              color: "black",
              fontSize: "20px",
              width: "80%",
              padding: 10,
              backgroundColor: "lightgray",
              borderRadius: "5px",
              border: "1px solid #ccc",
            }}
          />

          <Box className="from-Error">
            {workForceAddFormik.errors.workForceData?.[index]?.phoneNo &&
            workForceAddFormik.touched.workForceData?.[index]?.phoneNo
              ? workForceAddFormik.errors.workForceData[index].phoneNo
              : null}
          </Box>
        </Grid>

        {!field.isModified &&
        CheckPermissions(
          permissions,
          permissionsVariables.accessManagement,
          "Workforce Management",
          "Update",
        ) ? (
          <>
            <Grid
              item
              lg={0.75}
              sx={{
                display: "flex",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <div
                style={{ paddingRight: 20 }}
                onClick={() => handleEditWF(field)}
              >
                <img
                  src={pencilIcon}
                  alt="edit"
                  width={17.5}
                  height={17.5}
                  title="Change User Information"
                />
              </div>
              <div onClick={() => handleEditPasswordWF(field)}>
                <img
                  src={passwordKey}
                  alt="password"
                  width={17.5}
                  height={17.5}
                  title="Change Password"
                />
              </div>
            </Grid>
          </>
        ) : (
          <Grid item lg={1.5}></Grid>
        )}
      </Grid>
    ));
  };

  const filteredWorkforce = workForceData.filter(
    (item) =>
      item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.phoneNo?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const callLogoutAPI = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        keepalive: true,
      };

      await fetch(
        cfpBaseUrl + "customerFaciliationPortal/logOut",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => console.log(result))
        .catch((error) => console.error(error));
    } catch (e) {}
  };

  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECODDLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      case "91":
        return SUNDARLOGO;
      default:
        return MEPCOLOGO;
    }
  };

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((prev) => !prev);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [error1, setError1] = useState("");
  // const [success, setSuccess] = useState("");

  // Formik Hook
  const amendBill = useFormik({
    initialValues: {
      iv_application_id: "",
    },
    validationSchema: Yup.object({
      iv_application_id: Yup.string()
        .matches(
          /^[A-Za-z]{2}-\d{15}$/,
          "Invalid Application ID format (e.g. DE-131312509030009)",
        )
        .required("Application ID is required"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setViewBackdrop(true);
      setError1("");
      setSuccess("");

      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          applicationId: values.iv_application_id,
        });

        const response = await fetch(
          cfpBaseUrl + "installments/amendDuplicateBill",
          {
            method: "POST",
            headers: myHeaders,
            body: raw,
          },
        );

        const result = await response.json();

        if (result.status === "200" || result.status === 200) {
          setSuccess(result.message || "Bill amended successfully!");

          // Auto open bill
          const billUrl = `https://bill.pitc.com.pk/pitc/route_access/${result.refNo}`;
          window.open(billUrl, "_blank");
        } else {
          setError1(result.message || "Failed to process request.");
        }
      } catch (err) {
        console.error(err);
        setError1("Network error. Please try again.");
      } finally {
        setSubmitting(false);
        setViewBackdrop(false);
      }
    },
  });

  const errorClosesPopup = () => {
    setError1("");
    setSuccess("");
  };

  return (
    <>
      {/* Main Top bar and Side bar */}
      <Box className="side-bar">
        <AppBar
          className="app-bar"
          open={!displayComplaintPage ? open : !open}
          sx={{
            paddingLeft: open ? "0%" : "1%",
            backgroundColor: powerComplaintsMenu ? "black" : "white",
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none" }) }}
            className="icon-button"
          >
            <MenuIcon className="menu-icon" />
          </IconButton>
          <div
            className="navbar"
            style={{
              padding: !powerComplaintsMenu ? "12.5px 15px" : "0px 15px",
            }}
          >
            <div
              style={{
                display: "flex",
                width: "83.5%",
                gap: "40px",
                alignItems: "center",
                justifyContent: "space-between",
                marginLeft: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  gap: "30px",
                }}
              >
                <a href="/operationalperformance">
                  <img
                    src={getLogo(companyCode.toString())}
                    alt="Logo"
                    height="40"
                  />
                </a>
                {
                  <div style={{ width: "auto", minWidth: "600px" }}>
                    <h1
                      style={{
                        fontWeight: "normal",
                        fontSize: "1.55vw",
                        fontFamily: "Times",
                      }}
                    >
                      {
                        // <span style={{ fontFamily: "Times", textAlign: 'end', color: '#505050', }}>
                        //   {/* {
                        //     roleTypeId == 2 &&
                        //     <>
                        //       {officeNameForDashboard}
                        //     </>
                        //   }
                        //   {
                        //     (roleTypeId == 1 && cscID) &&
                        //     <>
                        //       {cscID && cscID != "Power Information Technology Company" && cscID}
                        //     </>
                        //   }
                        //   {
                        //     (roleTypeId == 1 && !cscID) &&
                        //     <>
                        //       {officeNameForDashboard}
                        //     </>
                        //   } */}

                        //   {(hierarchy == 1 || hierarchy == 2) ? getCompanies(code.slice(0, 2)) : officeName(officeCode, subDivisions) }

                        // </span>
                        <span
                          style={{
                            fontFamily: "Times",
                            textAlign: "end",
                            color: "#505050",
                          }}
                        >
                          {roleTypeId == 1 && hierarchy == 1 && (
                            <>{getCompanies(code.slice(0, 2))}</>
                          )}
                          {(roleTypeId == 2 || roleTypeId == 1) &&
                            hierarchy == 2 && <>{officeNameForDashboard}</>}

                          {(roleTypeId == 2 || roleTypeId == 1) &&
                            hierarchy == 3 && <>{officeNameForDashboard}</>}
                          {roleTypeId == 2 && hierarchy == 52 && (
                            <>{officeNameForDashboard}</>
                          )}
                          {roleTypeId == 2 && hierarchy == 4 && (
                            <>{officeNameForDashboard}</>
                          )}
                          {roleTypeId == 1 && hierarchy == 4 && (
                            <>{officeNameForDashboard}</>
                          )}
                          {/* {roleTypeId == 1 && !cscID && (
                            <>{officeNameForDashboard}</>
                          )} */}
                        </span>
                      }
                    </h1>
                  </div>
                }
                {!isButtonVisible &&
                  !powerComplaintsMenu &&
                  performanceValue != 0 && (
                    <div
                      style={{
                        marginLeft: "20px",
                        backgroundColor:
                          performanceValue > 0 ? "#e11b3c" : "#019760",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderRadius: "5px",
                        color: "white",
                        fontSize: "12px",
                        padding: "5px",
                      }}
                    >
                      <div>
                        OverAll <br />
                        Performance
                      </div>
                      <div
                        style={{
                          width: "20%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={
                            performanceValue > 0
                              ? trendingDownIcn
                              : trendingUpIcn
                          }
                          alt="trending"
                          style={{ height: "20%" }}
                        />
                      </div>
                      <p style={{ fontSize: "18px" }}>
                        {performanceValue ? Math.abs(performanceValue) : ""}%
                      </p>
                    </div>
                  )}
                {!powerComplaintsMenu &&
                  !isButtonVisible &&
                  totalActionablesNormal + totalActionablesOverdue > 0 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "5px 10px",
                        borderRadius: "5px",
                        backgroundColor: "#E11B3C",
                        cursor: "pointer",
                        color: "white",
                        width: "auto",
                        minWidth: "150px",
                        position: "relative",
                      }}
                      onClick={() => navigate("/actionables-table")}
                    >
                      <div style={{ position: "relative" }}>
                        <img
                          src={bell}
                          alt="bell"
                          height={40}
                          style={{
                            animation: "blink 1s infinite",
                            transform: `rotate(${15}deg)`,
                          }}
                        />
                      </div>
                      <div
                        style={{
                          marginLeft: "5px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            marginRight: "15px",
                          }}
                        >
                          {totalActionablesNormal + totalActionablesOverdue}
                        </span>
                        <p style={{ marginLeft: "5px", fontSize: "14px" }}>
                          Actions
                          <br />
                          Required
                        </p>
                      </div>
                    </div>
                  )}
              </div>
            </div>
            <div
              style={{
                width: "25%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "20px",
              }}
            >
              {/* Add Button + Search Icon */}
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <AddButton
                  permissions={permissions}
                  isButtonVisible={isButtonVisible}
                />
                {!powerComplaintsMenu &&
                  !(
                    roleTypeId === "2" && [1148, 1135, 1122].includes(roleId)
                  ) && (
                    <SearchIcon
                      sx={{
                        backgroundColor: "#09669d",
                        color: "white",
                        width: 35,
                        height: 35,
                        borderRadius: "10px",
                        padding: "4px",
                        cursor: "pointer",
                      }}
                      onClick={handleOpenSearchBarPopup}
                    />
                  )}
              </div>

              {/* Time or User Info */}
              {powerComplaintsMenu ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    width: "200px",
                    cursor: "pointer",
                  }}
                  onClick={() => setMenuOpen((prev) => !prev)}
                >
                  <Time />
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "1vw",
                      marginBottom: 5,
                    }}
                  >
                    {formattedDate}
                  </p>
                </div>
              ) : (
                <div
                  onClick={() => setMenuOpen((prev) => !prev)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    gap: "10px",
                  }}
                >
                  <div style={{ textAlign: "right" }}>
                    <p className="username" style={{ margin: 0 }}>
                      {name}
                    </p>
                    <p className="userid" style={{ margin: 0 }}>
                      {roleName}
                    </p>
                  </div>
                  <img
                    src={
                      typeof profilePicture === "string"
                        ? profilePicture
                        : profilePicture
                          ? URL.createObjectURL(profilePicture)
                          : UserIconImage
                    }
                    alt="avatar"
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = UserIconImage;
                    }}
                  />
                </div>
              )}

              {/* Dropdown Menu */}
              {menuOpen && (
                <div
                  className="items"
                  style={{
                    position: "absolute",
                    top: "60px",
                    right: "20px",
                    zIndex: 1000,
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <div className="item">
                    <div className="menu" ref={menuRef}>
                      <div
                        className="menu-item"
                        onClick={() => {
                          nameFormik.values.iv_full_name = name;
                          phoneFormik.values.iv_user_phone_no = phoneNo;
                          emailFormik.values.iv_user_email = email;
                          profilePictureFormik.values.iv_profile_picture =
                            profilePicture;
                          setShowProfileEditPopup(true);
                        }}
                      >
                        <div style={{ width: "30px" }}>
                          <img src={Profile1} alt="Profile" height={25} />
                        </div>
                        <h4>Profile</h4>
                      </div>
                      <div
                        className="menu-item"
                        onClick={() => setShowChangePasswordPopup(true)}
                      >
                        <div style={{ width: "30px" }}>
                          <img src={Key1} alt="Key" height={25} />
                        </div>
                        <h4>Change Password</h4>
                      </div>
                      <div
                        className="menu-item"
                        onClick={() =>
                          window.open(
                            cfpBaseUrl + "E-Operations%20User%20Manual.pdf",
                            "_blank",
                          )
                        }
                      >
                        <div style={{ width: "30px" }}>
                          <img src={PDF1} alt="User Manual" height={25} />
                        </div>
                        <h4>User Manual</h4>
                      </div>

                      <div
                        className="menu-item"
                        onClick={() => {
                          navigate("/eops-updates");
                          setMenuOpen(false);
                        }}
                      >
                        <div
                          style={{
                            width: "30px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <UpdateIcon sx={{ color: "#0b5cad", fontSize: 22 }} />
                        </div>
                        <h4>Changelog</h4>
                      </div>
                      <hr style={{ margin: "10px 0px" }} />
                      <div
                        className="menu-item"
                        onClick={async () => {
                          setViewBackdrop(true); // Show loader immediately

                          const sessionId = sessionStorage.getItem("sessionId");
                          let tabs =
                            JSON.parse(localStorage.getItem("appTabs")) || [];

                          tabs = tabs.filter((id) => id !== sessionId);
                          localStorage.setItem("appTabs", JSON.stringify(tabs));

                          try {
                            await callLogoutAPI();

                            // Dispatch all reset actions
                            dispatch(resetStateNcNormal());
                            dispatch(resetStateNcOverdue());
                            dispatch(resetStateConNormal());
                            dispatch(resetStateConOverdue());
                            dispatch(resetStateColNormal());
                            dispatch(resetStateColOverdue());
                            dispatch(resetStateCotNormal());
                            dispatch(resetStateCotOverdue());
                            dispatch(resetStateDueDate());
                            dispatch(resetStateInstallmentsNormal());
                            dispatch(resetStateInstallmentsOverdue());
                            dispatch(removeStats());
                            dispatch(resetOverallPerformanceState());
                            dispatch(resetFeederStatusState());
                            dispatch(resetGeoJsonState());
                            dispatch(resetActionableNormal());
                            dispatch(resetActionableOverdue());
                            dispatch(resetStateAllComplaints());

                            dispatch(signOut());
                          } catch (error) {
                            console.error("Logout failed:", error);
                          } finally {
                            setViewBackdrop(false); // Hide loader after logout
                          }
                        }}
                      >
                        <div style={{ width: "30px" }}>
                          <img src={Logout1} alt="Logout" height={25} />
                        </div>
                        <h4>Logout</h4>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </AppBar>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
          variant="persistent"
          anchor="left"
          open={!displayComplaintPage ? open : !open}
        >
          <DrawerHeader className="header">
            <Typography className="menu-title">
              <a href="/operationalperformance">
                <img src={EOps} alt="Logo" height="50" />
              </a>
            </Typography>
            <IconButton onClick={handleDrawerClose} className="icon-button">
              <ChevronLeftIcon className="menu-icon" />
            </IconButton>
          </DrawerHeader>
          <Menu
            // style={{ width: 256 }}
            defaultSelectedKeys={["1"]}
            defaultOpenKeys={["sub1"]}
            mode={mode}
            theme={theme}
            items={filteredItems}
            triggerSubMenuAction="click"
          />
          {/* {
            (roleId == 1148 || roleId == 1135 || roleId == 1153 || roleId == 1154) ?
              <></>
              :
              <>
                <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                  <div style={{ display: 'flex', gap: '5px', alignItems: 'center', justifyContent: 'center' }}>
                    <img src={Alarm} alt="bell" height='30' />
                    <p style={{ color: '#585858', fontFamily: 'Roboto-Medium', fontSize: '20px' }}>Pending Actions</p>
                  </div>
                  <div style={{ margin: '10px', width: 'auto', height: 'auto', padding: '10px', backgroundColor: "#d5e5ff", borderRadius: '10px' }}>
                    {pendings.map((item, index) => (
                      <div key={index} style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0px' }}>
                        <p style={{ color: '#585858', fontFamily: 'Roboto-Medium' }} >{item.name}</p>
                        <p style={{ color: 'red' }}>{numberFormatting(item.counter)}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </>
          } */}
        </Drawer>
        <Main open={open}>
          <DrawerHeader />
        </Main>
      </Box>

      <p className="font-load">F</p>
      <p className="font-load-digital">F</p>

      {/* Feeders Managment*/}
      <Dialog
        open={showFeederForm}
        onClose={() => feederFormClose()}
        maxWidth="lg"
        className="complaint-alert-popups"
        PaperProps={{
          sx: {
            width: "1000px",
            backgroundColor: "#363940",
            overflow: "hidden",
          },
        }}
      >
        <div
          style={{
            background: "linear-gradient(180deg, #1DB6E8, #003971)",
            display: "flex",
            position: "sticky",
            top: 0,
            zIndex: 10,
            padding: "15px",
          }}
        >
          <p
            style={{
              flex: 1,
              textAlign: "left",
              color: "white",
              fontSize: "22px",
              padding: "20px",
            }}
          >
            {"Feeder Information"}
          </p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div onClick={DownloadFeederListPdf} style={{ height: "40px" }}>
              <img
                src={pdf}
                alt="pdf"
                style={{ ...internalIconStyles, height: "100%" }}
              />
            </div>
            <div onClick={exportFeederListToExcel} style={{ height: "40px" }}>
              <img
                src={excel}
                alt="Excel"
                style={{ ...internalIconStyles, height: "100%" }}
              />
            </div>

            <div onClick={printFeederListPDF} style={{ height: "40px" }}>
              <img
                src={print}
                alt="print"
                style={{ ...internalIconStyles, height: "100%" }}
              />
            </div>
            <img
              src={closeIconWhite}
              style={{ width: 25, height: 25 }}
              onClick={() => setShowFeederForm(false)}
            />
          </div>
        </div>
        <div
          ref={tableref1}
          style={{
            maxHeight: "calc(100vh - 120px)",
            overflowY: "auto",
            width: "100%",
            margin: "0 auto",
            backgroundColor: "#f9f9f9",
          }}
        >
          <Dialog
            open={showFeederForm}
            onClose={() => feederFormClose()}
            maxWidth="lg"
            className="complaint-alert-popups"
            PaperProps={{
              sx: {
                width: "1000px",
                backgroundColor: "#363940",
                overflow: "hidden",
              },
            }}
          >
            <div
              style={{
                background: "linear-gradient(180deg, #1DB6E8, #003971)",
                display: "flex",
                position: "sticky",
                top: 0,
                zIndex: 10,
                padding: "15px",
              }}
            >
              <p
                style={{
                  flex: 1,
                  textAlign: "left",
                  color: "white",
                  fontSize: "22px",
                  padding: "20px",
                }}
              >
                {"Feeder Information"}
              </p>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div onClick={DownloadFeederListPdf} style={{ height: "40px" }}>
                  <img
                    src={pdf}
                    alt="pdf"
                    style={{ ...internalIconStyles, height: "100%" }}
                  />
                </div>
                <div
                  onClick={exportFeederListToExcel}
                  style={{ height: "40px" }}
                >
                  <img
                    src={excel}
                    alt="Excel"
                    style={{ ...internalIconStyles, height: "100%" }}
                  />
                </div>

                <div onClick={printFeederListPDF} style={{ height: "40px" }}>
                  <img
                    src={print}
                    alt="print"
                    style={{ ...internalIconStyles, height: "100%" }}
                  />
                </div>
                <img
                  src={closeIconWhite}
                  style={{ width: 25, height: 25 }}
                  onClick={() => setShowFeederForm(false)}
                />
              </div>
            </div>
            <div
              ref={tableref1}
              style={{
                maxHeight: "calc(100vh - 120px)",
                overflowY: "auto",
                width: "100%",
                margin: "0 auto",
                backgroundColor: "#f9f9f9",
              }}
            >
              <div ref={tableref1} style={{ padding: "20px" }}>
                {Object.keys(groupedFeeders).map((gridName) => (
                  <div key={gridName} style={{ marginBottom: "20px" }}>
                    {/* Grid heading */}
                    <h3 style={{ color: "black", marginLeft: "20px" }}>
                      {gridName.replace(/132 KV\s*/, "132 KV - ")}
                    </h3>

                    {/* Table Header */}
                    <div
                      style={{
                        marginLeft: "20px",
                        marginBottom: "10px",
                        padding: "10px",
                        width: "90%",
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: "bold",
                      }}
                    >
                      <p style={{ width: "5%", textAlign: "center" }}>Sr #</p>
                      <p style={{ width: "25%", fontWeight: "normal" }}>
                        Feeder
                      </p>
                      <p style={{ width: "8%", textAlign: "center" }}>
                        Feeder Code
                      </p>
                      <p style={{ width: "10%", textAlign: "center" }}>
                        Current (Amps)
                      </p>
                      <p style={{ width: "8%", textAlign: "center" }}>
                        Voltage (kV)
                      </p>
                      <p style={{ width: "3%", textAlign: "center" }}>
                        P.F (%)
                      </p>
                      <p style={{ width: "5%", textAlign: "center" }}>
                        Load (MW)
                      </p>
                      <p style={{ width: "5%", textAlign: "center" }}>Status</p>
                      <p style={{ width: "25%", textAlign: "center" }}>
                        Last Reporting Time
                      </p>
                    </div>

                    {/* Data Rows */}
                    {groupedFeeders[gridName].map((feeder, index) => {
                      const currentStatus = feeder.current > 3 ? "ON" : "OFF";

                      const lastReportingTime = new Date(
                        feeder.last_reporting_time,
                      );
                      const currentDateTime = new Date(cDateTime);

                      const timeDifference =
                        currentDateTime - lastReportingTime;
                      const halfHourInMs = 30 * 60 * 1000;

                      const isGrayRow = timeDifference > halfHourInMs;
                      const rowColor = isGrayRow ? "lightgrey" : "white";
                      const textColor = isGrayRow ? "white" : "";

                      return (
                        <div
                          key={index}
                          style={{
                            marginLeft: "20px",
                            marginBottom: "5px",
                            border: "1px solid grey",
                            padding: "10px",
                            borderRadius: "5px",
                            backgroundColor: rowColor,
                            width: "90%",
                            justifyContent: "space-between",
                            display: "flex",
                          }}
                        >
                          {/* ✅ Sr # with fixed width for alignment */}
                          <p
                            style={{
                              width: "5%",
                              textAlign: "center",
                              color: textColor,
                            }}
                          >
                            {index + 1}
                          </p>

                          <p
                            style={{
                              width: "25%",
                              color: currentStatus === "ON" ? textColor : "red",
                            }}
                          >
                            {feeder.feeder}
                          </p>
                          <p
                            style={{
                              width: "8%",
                              textAlign: "center",
                              color: textColor,
                            }}
                          >
                            {feeder.feeder_code}
                          </p>
                          <p
                            style={{
                              width: "10%",
                              textAlign: "center",
                              color: textColor,
                            }}
                          >
                            {feeder.current > 3
                              ? isGrayRow
                                ? "-"
                                : Math.abs(feeder.current)
                              : "-"}
                          </p>
                          <p
                            style={{
                              width: "8%",
                              textAlign: "center",
                              color: textColor,
                            }}
                          >
                            {Math.abs(feeder.voltage)}
                          </p>

                          {currentStatus === "ON" ? (
                            <>
                              <p
                                style={{
                                  width: "3%",
                                  textAlign: "center",
                                  color: textColor,
                                }}
                              >
                                {isGrayRow
                                  ? "-"
                                  : Math.abs(feeder.power_factor)}
                              </p>
                              <p
                                style={{
                                  width: "5%",
                                  textAlign: "center",
                                  color: textColor,
                                }}
                              >
                                {isGrayRow
                                  ? "-"
                                  : Math.abs(feeder.active_power_kW)}
                              </p>
                            </>
                          ) : (
                            <>
                              <p
                                style={{
                                  width: "3%",
                                  textAlign: "center",
                                  color: textColor,
                                }}
                              >
                                -
                              </p>
                              <p
                                style={{
                                  width: "5%",
                                  textAlign: "center",
                                  color: textColor,
                                }}
                              >
                                -
                              </p>
                            </>
                          )}

                          <p
                            style={{
                              width: "5%",
                              textAlign: "center",
                              color: textColor,
                            }}
                          >
                            <span
                              style={{
                                color: isGrayRow
                                  ? "white"
                                  : currentStatus === "ON"
                                    ? "green"
                                    : "red",
                              }}
                            >
                              {isGrayRow ? "-" : currentStatus}
                            </span>
                          </p>

                          <p
                            style={{
                              width: "25%",
                              textAlign: "center",
                              color: textColor,
                            }}
                          >
                            <span>{feeder.last_reporting_time}</span>
                          </p>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            </div>
            <DialogActions
              style={{ backgroundColor: "#f3f4f6" }}
            ></DialogActions>
          </Dialog>
        </div>
        <DialogActions style={{ backgroundColor: "#f3f4f6" }}></DialogActions>
      </Dialog>
      {/* APMS MANAGMENT */}
      <Dialog
        open={showApmsForm}
        onClose={apmsFormClose}
        maxWidth="lg"
        className="complaint-alert-popups"
        PaperProps={{
          sx: {
            width: "1200px",
            height: "800px",
            backgroundColor: "#363940",
            overflow: "hidden",
          },
        }}
      >
        <div
          style={{
            background: "linear-gradient(180deg, #1DB6E8, #003971)",
            display: "flex",
            position: "sticky",
            top: 0,
            zIndex: 10,
            padding: "15px",
          }}
        >
          <p
            style={{
              flex: 1,
              textAlign: "left",
              color: "white",
              fontSize: "22px",
              padding: "20px",
            }}
          >
            {"APMS Information"}
          </p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div onClick={DownloadAPMSPdf} style={{ height: "40px" }}>
              <img
                src={pdf}
                alt="pdf"
                style={{ ...internalIconStyles, height: "100%" }}
              />
            </div>
            <div onClick={exportAPMSDataToExcel} style={{ height: "40px" }}>
              <img
                src={excel}
                alt="Excel"
                style={{ ...internalIconStyles, height: "100%" }}
              />
            </div>

            <div onClick={printAPMSPDF} style={{ height: "40px" }}>
              <img
                src={print}
                alt="print"
                style={{ ...internalIconStyles, height: "100%" }}
              />
            </div>
            <img
              src={closeIconWhite}
              style={{ width: 25, height: 25 }}
              onClick={apmsFormClose}
            />
          </div>
        </div>
        <DialogContent
          className="dialog-content"
          style={{ padding: 0, overflowY: "hidden" }}
        >
          <div
            style={{
              margin: "20px",
              padding: "10px",
              width: "94%",
              fontWeight: "bold",
              // backgroundColor: "#f9f9f9",
              borderBottom: "1px solid grey",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <p style={{ width: "10%", fontWeight: "normal" }}>Capacity</p>
              <p style={{ width: "25%", fontWeight: "normal" }}>Location</p>
              <p style={{ width: "10%" }}>Msn</p>
              <p style={{ width: "10%", textAlign: "center" }}>
                Current (Amps)
              </p>
              <p style={{ width: "8%", textAlign: "center" }}>Voltage (kV)</p>
              <p style={{ width: "8%", textAlign: "center" }}>Status</p>
              <p style={{ width: "15%", textAlign: "center" }}>
                Last Communication Time
              </p>
            </div>
          </div>

          <div
            style={{
              maxHeight: "600px",
              overflowY: "auto",
              padding: "0 20px",
            }}
          >
            {Object.keys(groupedAPMS).length === 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "50px",
                  color: "red",
                  fontWeight: "bold",
                  fontSize: "18px",
                }}
              >
                No Data Found
              </div>
            ) : (
              Object.keys(groupedAPMS).map((gridName) => (
                <div key={gridName} style={{ marginBottom: "20px" }}>
                  {groupedAPMS[gridName].map((feeder, index) => {
                    const {
                      name = "N/A",
                      msn = "N/A",
                      voltage = "N/A",
                      current = "N/A",
                      apms_capacity = "N/A",
                      status = "N/A",
                      last_communication_time = "N/A",
                    } = feeder;
                    const statusColor = status === "ON" ? "green" : "red";
                    return (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "10px",
                          marginBottom: "5px",
                          border: "1px solid grey",
                          borderRadius: "5px",
                          backgroundColor: "#f9f9f9",
                        }}
                      >
                        <p style={{ width: "10%", color: "black" }}>
                          {apms_capacity} {"kVA"}
                        </p>
                        <p style={{ width: "25%", color: "black" }}>{name}</p>
                        <p
                          style={{
                            width: "10%",
                            textAlign: "center",
                            color: "black",
                          }}
                        >
                          {msn}
                        </p>
                        <p
                          style={{
                            width: "10%",
                            textAlign: "center",
                            color: "black",
                          }}
                        >
                          {current}
                        </p>
                        <p
                          style={{
                            width: "10%",
                            textAlign: "center",
                            color: "black",
                          }}
                        >
                          {voltage}
                        </p>
                        <p
                          style={{
                            width: "8%",
                            textAlign: "center",
                            color: statusColor,
                          }}
                        >
                          {status}
                        </p>
                        <p
                          style={{
                            width: "15%",
                            textAlign: "center",
                            color: "black",
                          }}
                        >
                          {last_communication_time}
                        </p>
                      </div>
                    );
                  })}
                </div>
              ))
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Complaint Submission Form  */}
      <Dialog
        open={showComplaintForm}
        onClose={() => complaintFormClose()}
        // fullWidth={true}
        maxWidth="md"
        className="complaint-alert-popups"
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="dialog-title"
        >
          New Complaint
          {meterNo && sliceRefNo != code && (
            <div
              style={{ backgroundColor: "black", color: "yellow", padding: 10 }}
            >
              <p style={{ fontStyle: "italic" }}>
                for
                <strong style={{ marginLeft: 10 }}>
                  {" "}
                  {subdivisionName(referenceNumber.slice(2, 7), subDivisions)}
                  &nbsp; Sub Division{" "}
                </strong>{" "}
              </p>
            </div>
          )}
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => complaintFormClose()}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent className="dialog-content" style={{ width: "auto" }}>
          <DialogContentText
            className="dialog-content-text"
            style={{ gap: "0px" }}
          >
            <form className="complaintform">
              <div>
                <RadioGroup row value={complaintType} onChange={handleChange2}>
                  <FormControlLabel
                    value="Technical"
                    control={<Radio color="primary" />}
                    label="Technical"
                  />
                  <FormControlLabel
                    value="Commercial"
                    control={<Radio color="primary" />}
                    label="Commercial"
                  />
                </RadioGroup>
              </div>
              <Grid container className="container">
                <Grid item lg={6} paddingLeft="20px" paddingRight="20px">
                  <div>
                    {/* <Typography className="fieldLabel">Select an Option:</Typography> */}
                    <RadioGroup
                      row // Aligns radio buttons horizontally
                      value={selectedOption}
                      onChange={handleChange1}
                      sx={{ flexWrap: "nowrap" }}
                    >
                      <FormControlLabel
                        value="referenceNo"
                        control={<Radio color="primary" size="small" />}
                        label="Reference No."
                        sx={{ whiteSpace: "nowrap", marginRight: "10px" }}
                      />
                      <FormControlLabel
                        value="consumerId"
                        control={<Radio color="primary" size="small" />}
                        label="Consumer Id."
                        sx={{ whiteSpace: "nowrap", marginRight: "10px" }}
                      />
                      {complaintType === "Technical" && (
                        <FormControlLabel
                          value="apmsMsn"
                          control={<Radio color="primary" size="small" />}
                          label="APMS MSN"
                          sx={{ whiteSpace: "nowrap" }}
                        />
                      )}
                    </RadioGroup>
                  </div>

                  <TextField
                    type="double"
                    name="iv_con_id_ref_no"
                    value={values.iv_con_id_ref_no}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="textInputField"
                    inputProps={{ maxLength: 14 }}
                    autoComplete="off"
                  />
                  <Box className="from-Error">
                    {errors.iv_con_id_ref_no && touched.iv_con_id_ref_no
                      ? errors.iv_con_id_ref_no
                      : null}
                  </Box>
                </Grid>
                <Grid item lg={6} paddingRight="20px" marginTop="20px">
                  <Typography className="fieldLabel">
                    {selectedOption === "apmsMsn" ? "Transformer Name" : "Name"}
                  </Typography>
                  <TextField
                    type="text"
                    name="iv_name"
                    value={values.iv_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="textInputField"
                    disabled={selectedOption === "apmsMsn"}
                    style={{
                      backgroundColor:
                        selectedOption === "apmsMsn" ? "#f3f4f6" : "#fff",
                    }}
                  />
                  <Box className="from-Error">
                    {errors.iv_name && touched.iv_name ? errors.iv_name : null}
                  </Box>
                </Grid>
                <Grid
                  item
                  lg={7}
                  paddingTop="10px"
                  paddingLeft="20px"
                  paddingRight="20px"
                >
                  <Typography className="fieldLabel">
                    {selectedOption === "apmsMsn" ? "Feeder Name" : "Address"}
                  </Typography>
                  <TextField
                    type="text"
                    name="iv_address"
                    value={values.iv_address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={selectedOption === "apmsMsn"}
                    style={{
                      backgroundColor:
                        selectedOption === "apmsMsn" ? "#f3f4f6" : "#fff",
                    }}
                    className="textInputField"
                  />
                  <Box className="from-Error">
                    {errors.iv_address && touched.iv_address
                      ? errors.iv_address
                      : null}
                  </Box>
                </Grid>
                <Grid item lg={5} paddingRight="20px" paddingTop="10px">
                  <Typography className="fieldLabel">
                    {selectedOption === "apmsMsn" ? "Feeder Code" : "Phone No."}
                  </Typography>
                  <TextField
                    type="text"
                    name="iv_phone_no"
                    value={values.iv_phone_no}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="textInputField"
                    disabled={selectedOption === "apmsMsn"}
                    style={{
                      backgroundColor:
                        selectedOption === "apmsMsn" ? "#f3f4f6" : "#fff",
                    }}
                    inputProps={{
                      maxLength: selectedOption === "apmsMsn" ? 20 : 11,
                    }}
                  />
                  <Box className="from-Error">
                    {errors.iv_phone_no &&
                    touched.iv_phone_no &&
                    selectedOption !== "apmsMsn"
                      ? errors.iv_phone_no
                      : null}
                  </Box>
                </Grid>
              </Grid>
              {/* APMS MSN Complaint Types */}
              {selectedOption === "apmsMsn" ? (
                <Grid
                  container
                  sx={{ overflow: "hidden" }}
                  className="container1"
                >
                  <Grid item lg={12}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        color: "#333",
                        marginBottom: "10px",
                        paddingLeft: "20px",
                      }}
                    >
                      Critical Alarm
                    </Typography>
                    <FormControl sx={{ width: "100%" }}>
                      <RadioGroup
                        sx={{
                          display: "flex",
                          justifyContent: "space-around",
                          alignItems: "center",
                          width: "100%",
                          paddingLeft: "20px",
                          paddingRight: "20px",
                        }}
                        row
                        value={typeId}
                        onChange={TypeId}
                      >
                        <Grid container>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="apms_over_voltage"
                              control={<Radio />}
                              label="Over Voltage"
                              name="Over Voltage"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="apms_under_voltage"
                              control={<Radio />}
                              label="Under Voltage"
                              name="Under Voltage"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="apms_phase_over_current"
                              control={<Radio />}
                              label="Phase Over Current"
                              name="Phase Over Current"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="apms_overload"
                              control={<Radio />}
                              label="Overload"
                              name="Overload"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="apms_high_apparent_power"
                              control={<Radio />}
                              label="High Apparent Power"
                              name="High Apparent Power"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="apms_voltage_unbalance"
                              control={<Radio />}
                              label="Voltage Unbalance"
                              name="Voltage Unbalance"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="apms_current_unbalance"
                              control={<Radio />}
                              label="Current Unbalance"
                              name="Current Unbalance"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          {/* <Grid item lg={3}>
                            <FormControlLabel
                              value="apms_phase_failure"
                              control={<Radio />}
                              label="Phase Failure / Missing Phase"
                              name="Phase Failure / Missing Phase"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid> */}
                          {/* <Grid item lg={3}>
                            <FormControlLabel
                              value="apms_short_circuit"
                              control={<Radio />}
                              label="Short Circuit"
                              name="Short Circuit"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="apms_residual_current"
                              control={<Radio />}
                              label="Residual Current"
                              name="Residual Current"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid> */}
                        </Grid>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item lg={12} sx={{ marginTop: "15px" }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        color: "#333",
                        marginBottom: "10px",
                        paddingLeft: "20px",
                      }}
                    >
                      Tripping
                    </Typography>
                    <FormControl sx={{ width: "100%" }}>
                      <RadioGroup
                        sx={{
                          display: "flex",
                          justifyContent: "space-around",
                          alignItems: "center",
                          width: "100%",
                          paddingLeft: "20px",
                          paddingRight: "20px",
                        }}
                        row
                        value={typeId}
                        onChange={TypeId}
                      >
                        <Grid container>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="trip_over_voltage"
                              control={<Radio />}
                              label="Over Voltage"
                              name="Trip Over Voltage"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="trip_under_voltage"
                              control={<Radio />}
                              label="Under Voltage"
                              name="Trip Under Voltage"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="trip_phase_over_current"
                              control={<Radio />}
                              label="Phase Over Current"
                              name="Trip Phase Over Current"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="trip_overload"
                              control={<Radio />}
                              label="Overload"
                              name="Trip Overload"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="trip_phase_failure"
                              control={<Radio />}
                              label="Phase Failure / Missing Phase"
                              name="Trip Phase Failure"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="trip_short_circuit"
                              control={<Radio />}
                              label="Short Circuit"
                              name="Short Circuit"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="trip_residual_current"
                              control={<Radio />}
                              label="Residual Current"
                              name="Trip Residual Current"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                        </Grid>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item lg={12} sx={{ marginTop: "15px" }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "14px",
                        color: "#333",
                        marginBottom: "10px",
                        paddingLeft: "20px",
                      }}
                    >
                      Others
                    </Typography>
                    <FormControl sx={{ width: "100%" }}>
                      <RadioGroup
                        sx={{
                          display: "flex",
                          justifyContent: "space-around",
                          alignItems: "center",
                          width: "100%",
                          paddingLeft: "20px",
                          paddingRight: "20px",
                        }}
                        row
                        value={typeId}
                        onChange={TypeId}
                      >
                        <Grid container>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value="apms_others"
                              control={<Radio />}
                              label="Others"
                              name="Others"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                        </Grid>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <div style={{ marginTop: 20, width: "100%" }}>
                    <Typography className="fieldLabel">
                      Complaint Detail
                    </Typography>
                    <TextField
                      type="text"
                      name="iv_con_id_complaint_details"
                      value={values.iv_con_id_complaint_details}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="textInputField"
                      autoComplete="off"
                      style={{ width: "100%" }}
                    />
                  </div>
                </Grid>
              ) : complaintType == "Technical" ? (
                <Grid
                  container
                  sx={{ overflow: "hidden" }}
                  className="container1"
                >
                  <Grid item lg={12}>
                    <FormControl sx={{ width: "100%" }}>
                      <RadioGroup
                        sx={{
                          display: "flex",
                          justifyContent: "space-around",
                          alignItems: "center",
                          width: "100%",
                          paddingLeft: "20px",
                          paddingRight: "20px",
                        }}
                        row
                        aria-labelledby="demo-form-control-label-placement"
                        defaultValue="end"
                        value={typeId}
                        onChange={TypeId}
                      >
                        <Grid container>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={powerOutage}
                              control={<Radio />}
                              label="Power Outage "
                              name="Power Outage"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={damagedMeter}
                              control={<Radio />}
                              label="Damaged Meter"
                              name="Damaged Meter"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={electricFire}
                              name="Electric Fire"
                              control={<Radio />}
                              label="Electric Fire"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={fluctuation}
                              name="Fluctuation"
                              control={<Radio />}
                              label="Fluctuation"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={lineFault}
                              name="Line Fault"
                              control={<Radio />}
                              label="Line Fault"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={lowVoltageShortTerm}
                              name="Low/ High Voltage - Short Term"
                              control={<Radio />}
                              label="Low/ High Voltage - Short Term"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={lowVoltageLongTerm}
                              name="Low/ High  - Long Term"
                              control={<Radio />}
                              label="Low/ High Voltage - Long Term"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={others}
                              name="others"
                              control={<Radio />}
                              label="Others"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                        </Grid>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  {(typeId == 1000 ||
                    typeId == 8 ||
                    typeId == 9 ||
                    typeId == 10 ||
                    typeId == 11 ||
                    typeId == 12 ||
                    typeId == 13 ||
                    typeId == 14 ||
                    typeId == 15 ||
                    typeId == 16 ||
                    typeId == 17 ||
                    typeId == 18 ||
                    typeId == 19) && (
                    <Grid item xs={12} sx={{ paddingRight: "20px" }}>
                      <Typography className="fieldLabel">
                        {" "}
                        Select Complaint Type
                      </Typography>
                      <Select
                        autoWidth={false}
                        autoFocus
                        value={typeId}
                        onChange={TypeId}
                        onBlur={handleBlur}
                        displayEmpty
                        style={{ color: "black" }}
                        className="connectionTypeDropDownList"
                        id="iv_complaint_type"
                      >
                        <MenuItem value="">Select Type</MenuItem>
                        {otherComplaintsArray.map((item, index) => {
                          return (
                            <MenuItem value={item.code} key={index}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <Box className="from-Error">
                        {errors.iv_complaint_type && touched.iv_complaint_type
                          ? errors.iv_complaint_type
                          : null}
                      </Box>
                    </Grid>
                  )}
                  <div style={{ marginTop: 20, width: "100%" }}>
                    <Typography className="fieldLabel">
                      Complaint Detail
                    </Typography>
                    <TextField
                      type="text"
                      name="iv_con_id_complaint_details"
                      value={values.iv_con_id_complaint_details}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="textInputField"
                      autoComplete="off"
                      style={{ width: "100%" }}
                    />
                  </div>
                </Grid>
              ) : (
                <Grid
                  container
                  sx={{ overflow: "hidden" }}
                  className="container1"
                >
                  <Grid item lg={12}>
                    <FormControl sx={{ width: "100%" }}>
                      <RadioGroup
                        sx={{
                          display: "flex",
                          justifyContent: "space-around",
                          alignItems: "center",
                          width: "100%",
                          paddingLeft: "20px",
                          paddingRight: "20px",
                        }}
                        row
                        aria-labelledby="demo-form-control-label-placement"
                        defaultValue="end"
                        value={typeId}
                        onChange={TypeId}
                      >
                        <Grid container>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={MeterPosition}
                              control={<Radio />}
                              label="Meter Position"
                              name="Meter Position"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={DetectionBill}
                              control={<Radio />}
                              label="Detection Bill"
                              name="Detection Bill"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={DelayedBillingNewConnection}
                              name="Delayed Billing (New Connection)"
                              control={<Radio />}
                              label="Delayed Billing (New Connection)"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={NonDeliveryofBill}
                              name="Late/Non-Delivery of Bill"
                              control={<Radio />}
                              label="Late/Non-Delivery of Bill"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={ElectricityTheft}
                              name=" Electricity Theft"
                              control={<Radio />}
                              label=" Electricity Theft"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={InstalledTransformerMeterWireTheft}
                              name="Installed Transformer"
                              control={<Radio />}
                              label="Installed Transformer"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={BulkDistributionTheft}
                              name="Bulk Distribution Theft"
                              control={<Radio />}
                              label="Bulk Distribution Theft"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                          <Grid item lg={3}>
                            <FormControlLabel
                              value={others}
                              name="others"
                              control={<Radio />}
                              label="Others"
                              labelPlacement="end"
                              className="complaintsButton"
                            />
                          </Grid>
                        </Grid>
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  {((typeId >= 27 && typeId <= 52) || typeId == 1000) && (
                    <Grid item xs={12} sx={{ paddingRight: "20px" }}>
                      <Typography className="fieldLabel">
                        {" "}
                        Select Complaint Type
                      </Typography>
                      <Select
                        autoWidth={false}
                        autoFocus
                        value={typeId}
                        onChange={TypeId}
                        onBlur={handleBlur}
                        displayEmpty
                        style={{ color: "black" }}
                        className="connectionTypeDropDownList"
                        id="iv_complaint_type"
                      >
                        <MenuItem value="">Select Type</MenuItem>
                        {otherComplaintsArrayCommerical.map((item, index) => {
                          return (
                            <MenuItem value={item.code} key={index}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      <Box className="from-Error">
                        {errors.iv_complaint_type && touched.iv_complaint_type
                          ? errors.iv_complaint_type
                          : null}
                      </Box>
                    </Grid>
                  )}
                  <div style={{ marginTop: 20, width: "100%" }}>
                    <Typography className="fieldLabel">
                      Complaint Detail
                    </Typography>
                    <TextField
                      type="text"
                      name="iv_con_id_complaint_details"
                      value={values.iv_con_id_complaint_details}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="textInputField"
                      autoComplete="off"
                      style={{ width: "100%" }}
                    />
                  </div>
                </Grid>
              )}

              <Grid container>
                <Grid item lg={12} sx={{ margin: "0px 50px 0px 25px" }}>
                  {complaintsError && (
                    <Error
                      error={complaintsError}
                      onClose={() => errorCloses()}
                      backgroundColor="#FFC0CB"
                      textColor="#bb0303"
                      iconColor="#bb0303"
                    />
                  )}
                </Grid>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ backgroundColor: "#f3f4f6" }}>
          <Button
            variant="contained"
            sx={{ width: "15%" }}
            className={
              // Regular complaint (Reference No or Consumer ID)
              (((values.iv_con_id_ref_no.length === 10 ||
                values.iv_con_id_ref_no.length === 14) &&
                values.iv_name != "" &&
                values.iv_phone_no.length === 11 &&
                typeId != "") ||
                // APMS MSN complaint
                (selectedOption === "apmsMsn" &&
                  values.iv_con_id_ref_no.length === 12 &&
                  values.iv_name != "" &&
                  values.iv_phone_no != "" &&
                  typeId != "")) === false
                ? "disabled-button"
                : "button"
            }
            component="label"
            disabled={
              // Regular complaint (Reference No or Consumer ID)
              (((values.iv_con_id_ref_no.length === 10 ||
                values.iv_con_id_ref_no.length === 14) &&
                values.iv_name != "" &&
                values.iv_phone_no.length === 11 &&
                typeId != "") ||
                // APMS MSN complaint
                (selectedOption === "apmsMsn" &&
                  values.iv_con_id_ref_no.length === 12 &&
                  values.iv_name != "" &&
                  values.iv_phone_no != "" &&
                  typeId != "")) === false
            }
            type="submit"
            onClick={async () => {
              if (selectedOption === "apmsMsn") {
                // Handle APMS MSN submission with API call

                if (!typeId) {
                  setComplaintsError(
                    "Please select a Complaint Type (Critical Alarm / Tripping / Others).",
                  );
                  return;
                }
                if (
                  !values.iv_con_id_complaint_details ||
                  values.iv_con_id_complaint_details.trim() === ""
                ) {
                  setComplaintsError("Complaint Detail is required.");
                  return;
                }

                setViewBackdrop(true);

                // Determine complaint category based on typeId prefix
                let complaintCategoryName = "Critical Alarm";
                if (typeId.startsWith("trip_")) {
                  complaintCategoryName = "Tripping";
                } else if (typeId === "apms_others") {
                  complaintCategoryName = "Others";
                }

                const apmsHeaders = new Headers();
                apmsHeaders.append("Authorization", token);
                apmsHeaders.append("Content-Type", "application/json");

                const apmsRaw = JSON.stringify({
                  apmsMeterSerialNo: values.iv_con_id_ref_no,
                  submittedThrough: "e-Operations",
                  transformerName: values.iv_name,
                  feederCode: values.iv_phone_no,
                  feederName: values.iv_address,
                  complaintCategoryName: complaintCategoryName,
                  complaintTypeName: typeName,
                  transformerLatitude: parseFloat(transformerLat) || 0,
                  transformerLongitude: parseFloat(transformerLong) || 0,
                  subDivisionCode:
                    parseInt(transformerSubDivCode) || parseInt(code) || 0,
                  description: values.iv_con_id_complaint_details,
                  referenceNo : transformerRefNo || "" // Include transformer reference number if available
                  
                });

                console.log("APMS Request Body:", apmsRaw);

                const apmsRequestOptions = {
                  method: "POST",
                  headers: apmsHeaders,
                  body: apmsRaw,
                  redirect: "follow",
                };

                try {
                  const response = await fetch(
                    cfpBaseUrl + "apms/registerAPMSComplaint",
                    apmsRequestOptions,
                  );
                  const result = await response.json();
                  console.log("APMS Response:", result);

                  if (response.status === 200 || result.status === "200") {
                    setViewBackdrop(false);
                    setShowApmsSuccessPopup(true);
                    setShowComplaintForm(false);
                    setSelectedOption("referenceNo");
                    setTypeId("");
                    setTypeName("");
                    setTransformerLat("");
                    setTransformerLong("");
                    setTransformerSubDivCode("");
                    setTransformerRefNo("");
                    setFieldValue("iv_con_id_ref_no", "");
                    setFieldValue("iv_name", "");
                    setFieldValue("iv_address", "");
                    setFieldValue("iv_phone_no", "");
                    setFieldValue("iv_con_id_complaint_details", "");
                    // Dispatch event to refresh APMS complaints list
                    console.log(
                      "Dispatching apmsComplaintSubmitted event from onClick",
                    );
                    window.dispatchEvent(
                      new CustomEvent("apmsComplaintSubmitted"),
                    );
                  } else {
                    setViewBackdrop(false);
                    setComplaintsError(
                      result.message || "Failed to register APMS complaint.",
                    );
                  }
                } catch (error) {
                  console.error("Error submitting APMS complaint:", error);
                  setViewBackdrop(false);
                  setComplaintsError(
                    "Error submitting APMS complaint. Please try again.",
                  );
                }
              } else {
                handleSubmit();
              }
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Arear Checking Popup */}
      <Dialog
        open={showComplaintErrorForm}
        onClose={() => complaintErrorFormClose()}
        maxWidth="sm"
        className="complaint-error-alert-popups"
        PaperProps={{
          sx: {
            width: "390px", // Custom width
            height: "160px", // Custom width
            backgroundColor: "#363940", // You can also set the background color here
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            backgroundColor: "#363940",
          }}
        >
          <img src={InfoImage} height={30} />
          <CloseIcon
            id="clearPopup"
            onClick={() => complaintErrorFormClose()}
            sx={{ color: "white", cursor: "pointer" }}
          />
        </DialogTitle>
        <DialogContent className="dialog-content">
          <div
            style={{ cursor: "pointer", padding: 5, color: "white" }}
            onClick={() => errorCloses1()}
          >
            {(arrear < 0 || arrear > 0) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <p style={{ fontSize: 17, fontWeight: "500" }}>
                  Arrear exists.
                </p>
              </div>
            )}
            {feederStatus === "OFF" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <p style={{ fontSize: 17, fontWeight: "500" }}>
                  Feeder Status : OFF.
                </p>
              </div>
            )}
            {meterStatus.toUpperCase() == "P.DISC" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <p style={{ fontSize: 17, fontWeight: "500" }}>
                  Meter is permanently disconnected.
                </p>
              </div>
            )}
            {meterStatus.toUpperCase() == "T.DISC" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <p style={{ fontSize: 17, fontWeight: "500" }}>
                  Meter is permanently disconnected.
                </p>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* APMS Success Popup */}
      <Dialog
        open={showApmsSuccessPopup}
        onClose={() => setShowApmsSuccessPopup(false)}
        maxWidth="sm"
        PaperProps={{
          sx: {
            width: "400px",
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#4CAF50",
            color: "white",
          }}
        >
          <span style={{ fontWeight: 600 }}>Success</span>
          <CloseIcon
            onClick={() => setShowApmsSuccessPopup(false)}
            sx={{ color: "white", cursor: "pointer" }}
          />
        </DialogTitle>
        <DialogContent sx={{ padding: "30px", textAlign: "center" }}>
          <div style={{ fontSize: "48px", marginBottom: "15px" }}>✓</div>
          <p style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}>
            APMS complaint is submitted successfully
          </p>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: "20px" }}>
          <Button
            variant="contained"
            onClick={() => setShowApmsSuccessPopup(false)}
            sx={{
              backgroundColor: "#4CAF50",
              "&:hover": { backgroundColor: "#45a049" },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {/* Workforce Management for Commerical Services*/}
      <Dialog
        open={showWorkforceForm}
        onClose={() => {
          setShowWorkforceForm(false);
          setSearchTerm("");
        }}
        maxWidth="lg"
        className="lineman-alert-popups"
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="dialog-title"
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ fontSize: "18px" }}>Work Force Management</div>
            <div style={{ fontSize: "18px", marginLeft: "10px" }}>
              ({officeNamee})
            </div>
          </div>

          <div>
            <Box
              sx={{
                marginTop: "1%",
                display: "flex",
                gap: "30px",
                alignItems: "center",
              }}
            >
              {CheckPermissions(
                permissions,
                permissionsVariables.accessManagement,
                "Workforce Management",
                "Create ",
              ) && (
                <button
                  style={{
                    backgroundColor: "#B01DB1",
                    color: "white",
                    width: "40px",
                    height: "40px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => setAddWF(true)}
                >
                  <AddIcon sx={{ fontSize: 20 }} />
                </button>
              )}

              {workForceData.length > 0 ? (
                <>
                  <img
                    src={pdf}
                    alt="excel"
                    height={40}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      DownloadLinemanPdf(true);
                    }}
                  />
                  <img
                    src={excel}
                    alt="excel"
                    height={40}
                    style={{ cursor: "pointer" }}
                    onClick={exportLinemanToExcel}
                  />
                  <img
                    src={print}
                    alt="print"
                    height={40}
                    style={{ cursor: "pointer" }}
                    onClick={printLinemanPDF}
                  />
                </>
              ) : (
                <></>
              )}
              <CloseIcon
                id="clearPopup"
                onClick={() => {
                  setShowWorkforceForm(false);
                  setSearchTerm("");
                }}
                sx={{ color: "white", cursor: "pointer" }}
              />
            </Box>
          </div>
        </DialogTitle>

        <DialogContent className="dialog-content" sx={{ overflow: "hidden" }}>
          <div
            className="filter-fields"
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "15px",
              marginTop: "10px",
              marginBottom: "20px",
            }}
          >
            {code == 10 && (
              <div className="field-container">
                <Typography className="field-label">Company</Typography>
                <select
                  className="dropdown-field"
                  style={{
                    backgroundColor: "white",
                    border: "1px solid lightgray",
                  }}
                  value={selectedCompanyCode}
                  onChange={handleChangeCompany}
                >
                  <option value="10">Select Company</option>
                  <option value="11">LESCO</option>
                  <option value="12">GEPCO</option>
                  <option value="13">FESCO</option>
                  <option value="14">IESCO</option>
                  <option value="15">MEPCO</option>
                  <option value="26">PESCO</option>
                  <option value="27">HAZECO</option>
                  <option value="37">HESCO</option>
                  <option value="38">SEPCO</option>
                  <option value="48">QESCO</option>
                  <option value="59">TESCO</option>
                </select>
              </div>
            )}

            {hierarchy <= 2 && (
              <div className="field-container">
                <Typography className="field-label">Circle</Typography>
                <select
                  className="dropdown-field"
                  style={{
                    backgroundColor: "white",
                    border: "1px solid lightgray",
                  }}
                  value={circleCodee || ""}
                  onChange={handleCircleChange}
                >
                  <option value="">All Circle</option>
                  {filteredCircles.map((circle) => (
                    <option key={circle.circleCode} value={circle.circleCode}>
                      {circle.circleName}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {hierarchy <= 3 && (
              <div className="field-container">
                <Typography className="field-label">Division</Typography>
                <select
                  className="dropdown-field"
                  style={{
                    backgroundColor: "white",
                    border: "1px solid lightgray",
                  }}
                  value={selectedDivision || ""}
                  onChange={handleDivisionChange}
                  disabled={!circleCode}
                >
                  <option value="">All Division</option>
                  {filteredDivisions.map((division) => (
                    <option
                      key={division.divisionCode}
                      value={division.divisionCode}
                    >
                      {division.divisionName}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {hierarchy <= 4 && (
              <div className="field-container">
                <Typography className="field-label">Sub-Division</Typography>
                <select
                  className="dropdown-field"
                  style={{
                    backgroundColor: "white",
                    border: "1px solid lightgray",
                  }}
                  value={selectedSubDivision || ""}
                  onChange={handleSubDivisionChange}
                  disabled={!selectedDivision}
                >
                  <option value="">All Sub-Division</option>
                  {filteredSubDivisions.map((subDivision) => (
                    <option
                      key={subDivision.subDivisionCode}
                      value={subDivision.subDivisionCode}
                    >
                      {subDivision.subDivisionName}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {hierarchy !== 52 ? (
              <Button
                variant="contained"
                color="primary"
                style={{ marginTop: "10px" }}
                onClick={() => getWFData(officeCodee)}
              >
                Go
              </Button>
            ) : null}

            <div
              style={{
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                borderRadius: "10px",
                padding: "5px 10px",
                border: "1px solid grey",
                margin: "0px",
                width: "188px",
              }}
            >
              <SearchIcon
                sx={{
                  color: "#09669d",
                  width: 20,
                  height: 20,
                  borderRadius: "8px",
                  marginRight: "8px",
                  cursor: "pointer",
                  transition: "color 0.3s",
                  "&:hover": {
                    color: "#074f7d",
                  },
                }}
              />

              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search Name / Phone"
                maxLength={20}
                style={{
                  flex: 1,
                  padding: "6px",
                  border: "none",
                  backgroundColor: "transparent",
                  outline: "none",
                  fontSize: "13px",
                  minWidth: "100px",
                }}
              />
            </div>
          </div>

          <form className="linemanAlertForm">
            <Grid
              container
              className="container"
              sx={{ backgroundColor: "white" }}
            >
              <Grid item lg={12} sx={{ padding: "10px" }}>
                {filteredWorkforce.length ? (
                  renderFieldsWorkforce(filteredWorkforce, setWorkForceData)
                ) : (
                  <Typography color="red">No Field staff found!</Typography>
                )}
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>

      {/* Profile Edit Popup*/}
      <Dialog
        open={showProfileEditPopup}
        onClose={() => setShowProfileEditPopup(false)}
        fullWidth={true}
        maxWidth="sm"
        className="alert-popups"
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="dialog-title"
        >
          User Profile
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => setShowProfileEditPopup(false)}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <DialogContentText sx={{ height: "600px" }}>
            <form className="complaintform">
              <Grid container sx={{ padding: "20px" }}>
                <Grid
                  item
                  lg={12}
                  sx={{
                    maxHeight: "190px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "35%",
                      padding: "10px",
                      border: "2px solid #006ad1",
                      borderRadius: "10px",
                    }}
                  >
                    <img
                      src={
                        typeof profilePictureFormik.values
                          .iv_profile_picture === "string"
                          ? profilePictureFormik.values.iv_profile_picture
                          : profilePictureFormik.values.iv_profile_picture
                            ? URL.createObjectURL(
                                profilePictureFormik.values.iv_profile_picture,
                              )
                            : UserIconImage
                      }
                      alt="avatar"
                      style={{ width: "100%", height: "165px" }}
                      onError={(e) => {
                        e.target.src = UserIconImage;
                      }}
                    />
                    <div
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50px",
                        backgroundColor: "#006ad1",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: "2px solid white",
                        zIndex: 1,
                        position: "relative",
                        marginLeft: "160px",
                        marginTop: "-35px",
                      }}
                    >
                      <label htmlFor="file">
                        <DriveFolderUploadIcon
                          sx={{
                            cursor: "pointer",
                            size: "medium",
                            color: "white",
                          }}
                        />
                      </label>
                    </div>
                    <input
                      type="file"
                      id="file"
                      accept={imageExtensions}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const isValidFileType =
                            file.type === "image/jpeg" ||
                            file.type === "image/png";
                          const isValidFileSize = file.size <= 3 * 1024 * 1024;

                          if (!isValidFileType) {
                            alert("Only JPEG and PNG images are allowed");
                            return;
                          }

                          if (!isValidFileSize) {
                            alert("File size must be less than 3MB");
                            return;
                          }

                          profilePictureFormik.setFieldValue(
                            "iv_profile_picture",
                            file,
                            true,
                          );
                          setTimeout(() => {
                            profilePictureFormik.handleSubmit(); // Ensure form is updated before submit
                          }, 100);
                        }
                      }}
                      style={{ display: "none" }}
                    />
                  </div>
                  {profilePictureFormik.errors.iv_profile_picture && (
                    <div style={{ color: "red" }}>
                      {profilePictureFormik.errors.iv_profile_picture}
                    </div>
                  )}
                </Grid>

                <Grid item lg={12} sx={{ marginTop: "30px" }}>
                  <Grid container spacing={1}>
                    <Grid
                      item
                      lg={12}
                      sx={{ backgroundColor: "#d5e5ff", padding: "5px" }}
                    >
                      <h4 style={{ color: "#006ad1" }}>User Information</h4>
                    </Grid>
                    <Grid item lg={12}>
                      <Grid container spacing={1}>
                        <Grid item lg={6}>
                          <label>Full Name</label>
                          <TextField
                            type="text"
                            autoComplete="off"
                            // disabled={!enableFullName}
                            disabled
                            onChange={nameFormik.handleChange}
                            name="iv_full_name"
                            value={nameFormik.values.iv_full_name}
                            onBlur={nameFormik.handleBlur}
                            sx={{
                              width: "100%",
                              ".MuiInputBase-input": {
                                height: ".5vh",
                              },
                            }}
                            // InputProps={{
                            //   endAdornment: (
                            //     <InputAdornment position="end">
                            //       <IconButton
                            //         onClick={handleClickFullName}
                            //         edge="end"
                            //       >
                            //         {!enableFullName ? (
                            //           <EditIcon />
                            //         ) : (
                            //           <SaveIcon />
                            //         )}
                            //       </IconButton>
                            //     </InputAdornment>
                            //   ),
                            // }}
                          />
                          <Grid>
                            {nameFormik.errors.iv_full_name &&
                            nameFormik.touched.iv_full_name ? (
                              <p style={{ color: "#f73232", fontSize: "1rem" }}>
                                {nameFormik.errors.iv_full_name}
                              </p>
                            ) : null}
                          </Grid>
                        </Grid>
                        <Grid item lg={6}>
                          <label>Username</label>
                          <TextField
                            type="text"
                            autoComplete="off"
                            name="iv_user_name"
                            value={userId}
                            disabled
                            sx={{
                              width: "100%",
                              ".MuiInputBase-input": {
                                height: "0.5vh",
                                // backgroundColor: "lightgrey",
                              },
                            }}
                          />
                        </Grid>
                        <Grid item lg={6}>
                          <label>Phone No.</label>
                          <TextField
                            type="text"
                            maxLength="11"
                            autoComplete="off"
                            // disabled={!enablePhone}
                            disabled
                            onChange={phoneFormik.handleChange}
                            inputProps={{ maxLength: 11 }}
                            name="iv_user_phone_no"
                            value={phoneFormik.values.iv_user_phone_no}
                            onBlur={phoneFormik.handleBlur}
                            sx={{
                              width: "100%",
                              ".MuiInputBase-input": {
                                height: "0.5vh",
                              },
                            }}
                            // InputProps={{
                            //   endAdornment: (
                            //     <InputAdornment position="end">
                            //       <IconButton
                            //         onClick={handleClickPhone}
                            //         edge="end"
                            //       >
                            //         {!enablePhone ? <EditIcon /> : <SaveIcon />}
                            //       </IconButton>
                            //     </InputAdornment>
                            //   ),
                            // }}
                          />
                          <Grid>
                            {phoneFormik.errors.iv_user_phone_no &&
                            phoneFormik.touched.iv_user_phone_no ? (
                              <p style={{ color: "#f73232", fontSize: "1rem" }}>
                                {phoneFormik.errors.iv_user_phone_no}
                              </p>
                            ) : null}
                          </Grid>
                        </Grid>
                        <Grid item lg={6}>
                          <label>CNIC No.</label>
                          <TextField
                            type="text"
                            maxLength="13"
                            autoComplete="off"
                            name="cnic"
                            disabled
                            inputProps={{ maxLength: 13 }}
                            value={cnic}
                            sx={{
                              width: "100%",
                              ".MuiInputBase-input": {
                                height: "0.5vh",
                                // backgroundColor: "lightgrey",
                              },
                            }}
                          />
                        </Grid>
                        <Grid item lg={12}>
                          <label>Email Address</label>
                          <TextField
                            type="text"
                            autoComplete="off"
                            // disabled={!enableEmail}
                            disabled
                            onChange={emailFormik.handleChange}
                            name="iv_user_email"
                            value={emailFormik.values.iv_user_email}
                            onBlur={emailFormik.handleBlur}
                            sx={{
                              width: "100%",
                              ".MuiInputBase-input": {
                                height: "0.5vh",
                              },
                            }}
                            // InputProps={{
                            //   endAdornment: (
                            //     <InputAdornment position="end">
                            //       <IconButton
                            //         onClick={handleClickEmail}
                            //         edge="end"
                            //       >
                            //         {!enableEmail ? <EditIcon /> : <SaveIcon />}
                            //       </IconButton>
                            //     </InputAdornment>
                            //   ),
                            // }}
                          />
                          <Grid>
                            {emailFormik.errors.iv_user_email &&
                            emailFormik.touched.iv_user_email ? (
                              <p style={{ color: "#f73232", fontSize: "1rem" }}>
                                {emailFormik.errors.iv_user_email}
                              </p>
                            ) : null}
                          </Grid>
                        </Grid>

                        <Grid item lg={12} sx={{ margin: "0px 20px 0px 10px" }}>
                          {(apiError || error) && (
                            <Error
                              error={error || apiError}
                              onClose={() => errorCloses()}
                              backgroundColor="#FFC0CB"
                              textColor="#bb0303"
                              iconColor="#bb0303"
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button sx={{ width: '10%' }} variant="contained" size='medium' onClick={handleSubmit}>
            Submit
          </Button> */}
        </DialogActions>
      </Dialog>

      {/* Change Password Popup*/}
      <Dialog
        open={showChangePasswordPopup}
        onClose={() => setShowChangePasswordPopup(false)}
        fullWidth={true}
        maxWidth="xs"
        className="alert-popups"
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="dialog-title"
        >
          Change Password
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => setShowChangePasswordPopup(false)}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <DialogContentText>
            <form className="complaintform">
              <Grid container sx={{ padding: "20px" }}>
                <Grid item lg={12}>
                  <Grid container spacing={1}>
                    <Grid item lg={12}>
                      <Grid container spacing={1}>
                        <Grid item lg={12}>
                          <label>Current Password</label>
                          <TextField
                            type={showOldPassword ? "text" : "password"}
                            autoComplete="off"
                            onChange={passwordChangeFormik.handleChange}
                            name="iv_old_password"
                            value={passwordChangeFormik.values.iv_old_password}
                            onBlur={passwordChangeFormik.handleBlur}
                            sx={{
                              width: "100%",
                              ".MuiInputBase-input": {
                                height: ".5vh",
                              },
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={handleClickShowOldPassword}
                                    edge="end"
                                  >
                                    {!showOldPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <Grid>
                            {passwordChangeFormik.errors.iv_old_password &&
                            passwordChangeFormik.touched.iv_old_password ? (
                              <p style={{ color: "#f73232", fontSize: "1rem" }}>
                                {passwordChangeFormik.errors.iv_old_password}
                              </p>
                            ) : null}
                          </Grid>
                        </Grid>
                        <Grid item lg={12}>
                          <label>New Password</label>
                          <TextField
                            type={showNewPassword ? "text" : "password"}
                            autoComplete="off"
                            onChange={passwordChangeFormik.handleChange}
                            name="iv_new_password"
                            value={passwordChangeFormik.values.iv_new_password}
                            onBlur={passwordChangeFormik.handleBlur}
                            sx={{
                              width: "100%",
                              ".MuiInputBase-input": {
                                height: ".5vh",
                              },
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={handleClickShowNewPassword}
                                    edge="end"
                                  >
                                    {!showNewPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <Grid>
                            {passwordChangeFormik.errors.iv_new_password &&
                            passwordChangeFormik.touched.iv_new_password ? (
                              <p style={{ color: "#f73232", fontSize: "1rem" }}>
                                {passwordChangeFormik.errors.iv_new_password}
                              </p>
                            ) : null}
                          </Grid>
                        </Grid>
                        <Grid item lg={12}>
                          <label>Confirm New Password</label>
                          <TextField
                            type={showConfirmPassword ? "text" : "password"}
                            autoComplete="off"
                            onChange={passwordChangeFormik.handleChange}
                            name="iv_confirm_password"
                            value={
                              passwordChangeFormik.values.iv_confirm_password
                            }
                            onBlur={passwordChangeFormik.handleBlur}
                            sx={{
                              width: "100%",
                              ".MuiInputBase-input": {
                                height: ".5vh",
                              },
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={handleClickShowConfirmPassword}
                                    edge="end"
                                  >
                                    {!showConfirmPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <Grid>
                            {passwordChangeFormik.errors.iv_confirm_password &&
                            passwordChangeFormik.touched.iv_confirm_password ? (
                              <p style={{ color: "#f73232", fontSize: "1rem" }}>
                                {
                                  passwordChangeFormik.errors
                                    .iv_confirm_password
                                }
                              </p>
                            ) : null}
                          </Grid>
                        </Grid>
                        <Grid item lg={12}>
                          {apiError && (
                            <Error
                              error={apiError}
                              onClose={() => errorCloses()}
                              backgroundColor="#FFC0CB"
                              textColor="#bb0303"
                              iconColor="#bb0303"
                            />
                          )}
                        </Grid>
                        <Grid
                          item
                          lg={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Button
                            sx={{ width: "30%" }}
                            variant="contained"
                            size="medium"
                            onClick={passwordChangeFormik.handleSubmit}
                          >
                            Submit
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* Search Popups */}
      <SearchPopup
        searchBarrPopupOpen={searchBarrPopupOpen}
        handleCloseSearchBarPopup={handleCloseSearchBarPopup}
        selectedTab={selectedTab}
        handleTabChange={handleTabChange}
        tabLabels={tabLabels}
        searchFormik={searchFormik}
      />
      <SearchResultsPopup
        openDialogOfApplication={openDialogOfApplication}
        handleDialogOfApplicationClose={handleDialogOfApplicationClose}
        selectedTab={selectedTab}
        selectedValueOfTab={selectedValueOfTab}
        resultSearchedData={resultSearchedData}
        resultSearchedData1={resultSearchedData1}
        setViewBackdrop={setViewBackdrop}
      />

      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Delete Workforce Warning */}
      <Dialog
        open={deleteLMWarning}
        onClose={() => setDeleteLMWarning(false)}
        className="dialog"
        fullWidth={true}
        maxWidth={"sm"}
        sx={{ zIndex: "9999" }}
        PaperProps={{ style: { borderRadius: 20, width: "70%" } }}
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div style={{ textAlign: "center" }}>
              <img src={batchIcon} alt="batchIcon" width="80px" height="80px" />
            </div>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "500",
                fontSize: "26px",
                color: "#1976d2",
                textAlign: "center",
              }}
            >
              {" "}
              Warning
            </Typography>
            <h5 className="applicationSubmit" style={{ fontSize: "16px" }}>
              Do you want to delete the lineman?
            </h5>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "25px",
              }}
            >
              <Button
                sx={{
                  width: "30%",
                  backgroundColor: "#d32f2f",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#b71c1c" },
                }}
                variant="contained"
                size="small"
                onClick={async () => {
                  await deleteWFData(workForceToDelete, token);
                  await getWFData();
                  setDeleteLMWarning(false);
                }}
              >
                Yes
              </Button>
              <Button
                sx={{
                  width: "30%",
                  backgroundColor: "#4caf50",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#388e3c" },
                }}
                variant="contained"
                size="small"
                onClick={() => {
                  setWorkForceToDelete({});
                  setDeleteLMWarning(false);
                }}
              >
                No
              </Button>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>

      {/* Edit Workforce Warning */}
      <Dialog
        open={editWF}
        onClose={() => {
          editWorkForceFormik.resetForm();
          setEditWF(false);
          setApiError("");
        }}
        maxWidth={"md"}
        className="lineman-alert-popups"
        PaperProps={{
          style: { width: "100%", height: "auto", borderRadius: 20 },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="dialog-title"
        >
          Edit Lineman
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                editWorkForceFormik.resetForm();
                setEditWF(false);
                setApiError("");
                setEditSelectedItems([]);
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid container>
              {apiError && (
                <Grid item lg={12} sx={{ color: "red" }}>
                  {apiError}
                </Grid>
              )}
              <Grid item lg={4} sx={{ paddingRight: "20px" }}>
                <Typography>Name</Typography>
                <input
                  type="text"
                  name="iv_name"
                  onChange={editWorkForceFormik.handleChange}
                  onBlur={editWorkForceFormik.handleBlur}
                  value={editWorkForceFormik.values.iv_name}
                  style={{ padding: "10px 5px", width: "100%" }}
                />
                <div style={{ fontSize: "small", color: "red" }}>
                  {editWorkForceFormik.errors.iv_name &&
                  editWorkForceFormik.touched.iv_name
                    ? editWorkForceFormik.errors.iv_name
                    : null}
                </div>
              </Grid>
              <Grid item xs={4} sx={{ paddingRight: "5px" }}>
                <Typography>Designation</Typography>
                <select
                  name="iv_designation"
                  value={editWorkForceFormik.values.iv_designation}
                  onChange={editWorkForceFormik.handleChange}
                  onBlur={editWorkForceFormik.handleBlur}
                  style={{
                    padding: "10px 5px",
                    width: "100%",
                    backgroundColor: "#eceaea",
                    border: "1px solid rgb(86, 70, 70)",
                    borderRadius: "2px",
                  }}
                  id="iv_designation"
                  disabled
                >
                  {fieldStaffDesignations.map((item, index) => {
                    return (
                      <option value={item.employeeDesignationId} key={index}>
                        {item.employeeDesignationName}
                      </option>
                    );
                  })}
                  )
                </select>
                <div style={{ fontSize: "small", color: "red" }}>
                  {editWorkForceFormik.errors.iv_designation &&
                  editWorkForceFormik.touched.iv_designation
                    ? editWorkForceFormik.errors.iv_designation
                    : null}
                </div>
              </Grid>

              {/* <Grid item xs={4} >
                <Typography>Shift</Typography>
                <select
                  name="iv_shift"
                  value={editWorkForceFormik.values.iv_shift}
                  onChange={editWorkForceFormik.handleChange}
                  onBlur={editWorkForceFormik.handleBlur}
                  style={{ padding: '10px 5px', width: '100%', backgroundColor: 'white', border: '1px solid rgb(86, 70, 70)', borderRadius: '2px', }}
                  id="iv_shift"
                >
                  <option value="">Select Shift</option>
                  {
                    shifts.map((item, index) => {
                      return <option value={item.shiftId} key={index}>{item.shiftName + ' '}{item.startTime + ' ' + item.endTime}</option>
                    })
                  })
                </select>
                <div style={{ fontSize: 'small', color: 'red' }}>
                  {
                    (editWorkForceFormik.errors.iv_shift && editWorkForceFormik.touched.iv_shift)
                      ? editWorkForceFormik.errors.iv_shift
                      : null
                  }
                </div>
              </Grid> */}

              <Grid item xs={4} sx={{ paddingRight: "10px" }}>
                <Typography>Shift</Typography>
                {shifts.map((item) => (
                  <div key={item.shiftId} style={{ marginBottom: "5px" }}>
                    <input
                      type="checkbox"
                      id={`shift_${item.shiftId}`}
                      checked={editSelectedItems.includes(item.shiftId)}
                      onChange={() => handleCheckboxChange1(item.shiftId)}
                    />
                    <label
                      htmlFor={`shift_${item.shiftId}`}
                      style={{ marginLeft: "5px" }}
                    >
                      {item.shiftName} ({item.startTime} - {item.endTime})
                    </label>
                  </div>
                ))}
                {/* Validation Error */}
                <div style={{ fontSize: "small", color: "red" }}>
                  {workForceAddFormik.errors.iv_shift &&
                  workForceAddFormik.touched.iv_shift
                    ? workForceAddFormik.errors.iv_shift
                    : null}
                </div>
              </Grid>

              <Grid item lg={4} sx={{ paddingRight: "20px" }}>
                <Typography>Phone No</Typography>
                <input
                  value={editWorkForceFormik.values.iv_phone}
                  type="text"
                  onBlur={editWorkForceFormik.handleBlur}
                  onChange={editWorkForceFormik.handleChange}
                  style={{ padding: "10px 5px", width: "100%" }}
                  fullWidth
                  maxLength={11}
                  autoComplete="off"
                  name="iv_phone"
                />
                <div style={{ fontSize: "small", color: "red" }}>
                  {editWorkForceFormik.errors.iv_phone &&
                  editWorkForceFormik.touched.iv_phone
                    ? editWorkForceFormik.errors.iv_phone
                    : null}
                </div>
              </Grid>
              <Grid item lg={4} sx={{ paddingRight: "5px" }}>
                <Typography>CNIC</Typography>
                <input
                  value={editWorkForceFormik.values.iv_cnic}
                  type="text"
                  onBlur={editWorkForceFormik.handleBlur}
                  onChange={editWorkForceFormik.handleChange}
                  style={{ padding: "10px 5px", width: "95%" }}
                  fullWidth
                  maxLength={13}
                  autoComplete="off"
                  name="iv_cnic"
                />
                <div style={{ fontSize: "small", color: "red" }}>
                  {editWorkForceFormik.errors.iv_cnic &&
                  editWorkForceFormik.touched.iv_cnic
                    ? editWorkForceFormik.errors.iv_cnic
                    : null}
                </div>
              </Grid>
              <Grid item lg={4}>
                <Typography>Employee Code</Typography>
                <input
                  value={editWorkForceFormik.values.iv_employeeCode}
                  type="text"
                  onBlur={editWorkForceFormik.handleBlur}
                  onChange={editWorkForceFormik.handleChange}
                  style={{ padding: "10px 5px", width: "95%" }}
                  fullWidth
                  maxLength={13}
                  autoComplete="off"
                  name="iv_employeeCode"
                />
                <div style={{ fontSize: "small", color: "red" }}>
                  {editWorkForceFormik.errors.iv_cnic &&
                  editWorkForceFormik.touched.iv_employeeCode
                    ? editWorkForceFormik.errors.iv_employeeCode
                    : null}
                </div>
              </Grid>
              <Grid item lg={4} sx={{ paddingRight: "20px" }}>
                <Typography>User Id.</Typography>
                <input
                  value={editWorkForceFormik.values.iv_userId}
                  type="text"
                  onBlur={editWorkForceFormik.handleBlur}
                  onChange={editWorkForceFormik.handleChange}
                  style={{
                    color: "black",
                    padding: "12px 5px",
                    width: "100%",
                    backgroundColor: "#eceaea",
                    border: "1px solid rgb(182, 179, 179)",
                    borderRadius: "2px",
                  }}
                  fullWidth
                  autoComplete="off"
                  name="iv_userId"
                  disabled
                />
                <div style={{ fontSize: "small", color: "red" }}>
                  {editWorkForceFormik.errors.iv_userId &&
                  editWorkForceFormik.touched.iv_userId
                    ? editWorkForceFormik.errors.iv_userId
                    : null}
                </div>
              </Grid>
              {/* <Grid item lg={4} sx={{ paddingRight: '5px' }}>
                <label>Password</label>
                <TextField maxLength='16'
                  type={showPassword ? 'text' : 'password'}
                  autoComplete='off'
                  onChange={editWorkForceFormik.handleChange}
                  name="iv_password"
                  value={editWorkForceFormik.values.iv_password}
                  onBlur={editWorkForceFormik.handleBlur}
                  sx={{
                    width: '100%', '.MuiInputBase-input': {
                      height: '1vh',
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end">

                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )
                    ),
                  }}
                />
                <Grid>
                  {editWorkForceFormik.errors.iv_password && editWorkForceFormik.touched.iv_password ? (
                    <p style={{ color: '#f73232', fontSize: '1rem' }}>
                      Password should:
                      <ul>
                        <li>have length between 8 to 16 characters.</li>
                        <li>contain at least 1 lower case letter.</li>
                        <li>contain at least 1 upper case letter.</li>
                        <li>contain at least 1 number.</li>
                        <li>contain at least 1 special character.</li>
                      </ul>
                    </p>
                  ) : null}
                </Grid>
              </Grid>
              <Grid item lg={4} >
                <label>Password Confirmation</label>
                <TextField
                  maxLength="16"
                  type={showConfirmPassword ? 'text' : 'password'}
                  autoComplete="off"
                  onChange={editWorkForceFormik.handleChange}
                  name="iv_confirm_password"
                  value={editWorkForceFormik.values.iv_confirm_password}
                  onBlur={editWorkForceFormik.handleBlur}
                  sx={{
                    width: '100%',
                    '.MuiInputBase-input': {
                      height: '1vh',
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle confirm password visibility"
                            onClick={handleClickShowConfirmPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      )
                    ),
                  }}
                />
                <Grid>
                  {editWorkForceFormik.errors.iv_confirm_password && editWorkForceFormik.touched.iv_confirm_password ? (
                    <p style={{ color: '#f73232', fontSize: '1rem' }}>
                      {editWorkForceFormik.errors.iv_confirm_password}
                    </p>
                  ) : null}
                </Grid>
              </Grid> */}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button sx={{ width: '20%', backgroundColor: 'red', '&:hover': { backgroundColor: 'red' } }} variant="contained" size='medium' onClick={handleDeleteLMUser}>
            Delete
          </Button> */}
          <Button
            sx={{ width: "20%" }}
            variant="contained"
            size="medium"
            onClick={editWorkForceFormik.handleSubmit}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Workforce Warning */}
      <Dialog
        open={addWF}
        onClose={() => {
          workForceAddFormik.resetForm();
          setAddWF(false);
          setApiError("");
          window.location.reload();
        }}
        fullWidth={true}
        maxWidth={"md"}
        className="lineman-alert-popups"
        PaperProps={{
          style: { width: "100%", height: "auto", borderRadius: 20 },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="dialog-title"
        >
          Add WorkForce
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                workForceAddFormik.resetForm();
                setAddWF(false);
                setApiError("");
                window.location.reload();
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid container>
              {apiError && (
                <Grid item lg={12} sx={{ color: "red" }}>
                  {apiError}
                </Grid>
              )}

              {code == 10 && (
                <Grid item xs={4} sx={{ paddingRight: "10px" }}>
                  <Typography>Company</Typography>
                  <select
                    className="dropdown-field"
                    style={{
                      color: "black",
                      padding: "10px 5px",
                      width: "100%",
                    }}
                    value={selectedCompanyCode}
                    onChange={handleChangeCompany}
                  >
                    <option value="10">Select Company</option>
                    <option value="11">LESCO</option>
                    <option value="12">GEPCO</option>
                    <option value="13">FESCO</option>
                    <option value="14">IESCO</option>
                    <option value="15">MEPCO</option>
                    <option value="26">PESCO</option>
                    <option value="37">HESCO</option>
                    <option value="38">SEPCO</option>
                    <option value="48">QESCO</option>
                    <option value="59">TESCO</option>
                  </select>
                </Grid>
              )}
              {hierarchy <= 2 && (
                <Grid item xs={4} sx={{ paddingRight: "10px" }}>
                  <Typography>Circle</Typography>
                  <select
                    className="dropdown-field"
                    style={{
                      color: "black",
                      padding: "10px 5px",
                      width: "100%",
                    }}
                    value={circleCodee || ""}
                    onChange={handleCircleChange}
                  >
                    <option value="">All Circle</option>
                    {filteredCircles.map((circle) => (
                      <option key={circle.circleCode} value={circle.circleCode}>
                        {circle.circleName}
                      </option>
                    ))}
                  </select>
                </Grid>
              )}

              {hierarchy <= 3 && (
                <Grid item xs={4} sx={{ paddingRight: "10px" }}>
                  <Typography>Division</Typography>
                  <select
                    className="dropdown-field"
                    style={{
                      color: "black",
                      padding: "10px 5px",
                      width: "100%",
                    }}
                    value={selectedDivision || ""}
                    onChange={handleDivisionChange}
                    disabled={!circleCode}
                  >
                    <option value="">All Division</option>
                    {filteredDivisions.map((division) => (
                      <option
                        key={division.divisionCode}
                        value={division.divisionCode}
                      >
                        {division.divisionName}
                      </option>
                    ))}
                  </select>
                </Grid>
              )}

              {hierarchy <= 4 && (
                <Grid item xs={4} sx={{ paddingRight: "10px" }}>
                  <Typography>Sub-Division</Typography>
                  <select
                    className="dropdown-field"
                    style={{
                      color: "black",
                      padding: "10px 5px",
                      width: "100%",
                    }}
                    name="iv_subDivision"
                    value={workForceAddFormik.values.iv_subDivision}
                    onChange={(e) => {
                      workForceAddFormik.handleChange(e); // Update Formik state
                      handleSubDivisionChange(e); // Your existing handler for sub-division
                    }}
                    onBlur={workForceAddFormik.handleBlur}
                    disabled={!selectedDivision}
                  >
                    <option value="">All Sub-Division</option>
                    {filteredSubDivisions.map((subDivision) => (
                      <option
                        key={subDivision.subDivisionCode}
                        value={subDivision.subDivisionCode}
                      >
                        {subDivision.subDivisionName}
                      </option>
                    ))}
                  </select>
                  <div style={{ fontSize: "small", color: "red" }}>
                    {workForceAddFormik.errors.iv_subDivision &&
                    workForceAddFormik.touched.iv_subDivision
                      ? workForceAddFormik.errors.iv_subDivision
                      : null}
                  </div>
                </Grid>
              )}

              <Grid item xs={4} sx={{ paddingRight: "10px" }}>
                <Typography>Designation</Typography>
                <select
                  name="iv_designation"
                  value={workForceAddFormik.values.iv_designation}
                  onChange={workForceAddFormik.handleChange}
                  onBlur={workForceAddFormik.handleBlur}
                  style={{ color: "black", padding: "10px 5px", width: "100%" }}
                  id="iv_designation"
                >
                  <option value="">Select Type</option>
                  {fieldStaffDesignations.map((item, index) => {
                    return (
                      <option value={item.employeeDesignationId} key={index}>
                        {item.employeeDesignationName}
                      </option>
                    );
                  })}
                </select>
                <div style={{ fontSize: "small", color: "red" }}>
                  {workForceAddFormik.errors.iv_designation &&
                  workForceAddFormik.touched.iv_designation
                    ? workForceAddFormik.errors.iv_designation
                    : null}
                </div>
              </Grid>

              <Grid item lg={4} sx={{ paddingRight: "20px" }}>
                <Typography>Name</Typography>
                <input
                  type="text"
                  name="iv_name"
                  onChange={workForceAddFormik.handleChange}
                  onBlur={workForceAddFormik.handleBlur}
                  value={workForceAddFormik.values.iv_name}
                  style={{ padding: "10px 5px", width: "100%" }}
                />
                <div style={{ fontSize: "small", color: "red" }}>
                  {workForceAddFormik.errors.iv_name &&
                  workForceAddFormik.touched.iv_name
                    ? workForceAddFormik.errors.iv_name
                    : null}
                </div>
              </Grid>

              <Grid item xs={4} sx={{ paddingRight: "10px" }}>
                <Typography>Shift</Typography>

                {shifts.map((item) => (
                  <div key={item.shiftId} style={{ marginBottom: "5px" }}>
                    <input
                      type="checkbox"
                      id={`shift_${item.shiftId}`}
                      checked={selectedItems.includes(item.shiftId)}
                      onChange={() => handleCheckboxChange(item.shiftId)}
                    />
                    <label
                      htmlFor={`shift_${item.shiftId}`}
                      style={{ marginLeft: "5px" }}
                    >
                      {item.shiftName} ({item.startTime} - {item.endTime})
                    </label>
                  </div>
                ))}

                {/* Validation Error */}
                <div style={{ fontSize: "small", color: "red" }}>
                  {workForceAddFormik.errors.iv_shift &&
                  workForceAddFormik.touched.iv_shift
                    ? workForceAddFormik.errors.iv_shift
                    : null}
                </div>
              </Grid>

              <Grid item lg={4} sx={{ paddingRight: "30px" }}>
                <Typography>Phone No</Typography>
                <input
                  value={workForceAddFormik.values.iv_phone}
                  type="text"
                  onBlur={workForceAddFormik.handleBlur}
                  onChange={workForceAddFormik.handleChange}
                  style={{ padding: "10px 5px", width: "100%" }}
                  fullWidth
                  maxLength={11}
                  autoComplete="off"
                  name="iv_phone"
                />
                <div style={{ fontSize: "small", color: "red" }}>
                  {workForceAddFormik.errors.iv_phone &&
                  workForceAddFormik.touched.iv_phone
                    ? workForceAddFormik.errors.iv_phone
                    : null}
                </div>
              </Grid>

              <Grid item lg={4} sx={{ paddingRight: "20px" }}>
                <Typography>Employee Code</Typography>
                <input
                  value={workForceAddFormik.values.iv_employeeCode}
                  type="text"
                  onBlur={workForceAddFormik.handleBlur}
                  onChange={workForceAddFormik.handleChange}
                  style={{ padding: "10px 5px", width: "100%" }}
                  fullWidth
                  maxLength={13}
                  autoComplete="off"
                  name="iv_employeeCode"
                />
                <div style={{ fontSize: "small", color: "red" }}>
                  {workForceAddFormik.errors.iv_employeeCode &&
                  workForceAddFormik.touched.iv_employeeCode
                    ? workForceAddFormik.errors.iv_employeeCode
                    : null}
                </div>
              </Grid>

              <Grid item lg={4} sx={{ paddingRight: "20px" }}>
                <Typography>CNIC</Typography>
                <input
                  value={workForceAddFormik.values.iv_cnic}
                  type="text"
                  onBlur={workForceAddFormik.handleBlur}
                  onChange={workForceAddFormik.handleChange}
                  style={{ padding: "10px 5px", width: "100%" }}
                  fullWidth
                  maxLength={13}
                  autoComplete="off"
                  name="iv_cnic"
                />
                <div style={{ fontSize: "small", color: "red" }}>
                  {workForceAddFormik.errors.iv_cnic &&
                  workForceAddFormik.touched.iv_cnic
                    ? workForceAddFormik.errors.iv_cnic
                    : null}
                </div>
              </Grid>

              <Grid item lg={4} sx={{ paddingRight: "20px" }}>
                <Typography>User Id.</Typography>
                <input
                  value={workForceAddFormik.values.iv_userId}
                  type="text"
                  onBlur={workForceAddFormik.handleBlur}
                  onChange={workForceAddFormik.handleChange}
                  style={{ padding: "10px 5px", width: "100%" }}
                  fullWidth
                  autoComplete="off"
                  name="iv_userId"
                />
                <div style={{ fontSize: "small", color: "red" }}>
                  {workForceAddFormik.errors.iv_userId &&
                  workForceAddFormik.touched.iv_userId
                    ? workForceAddFormik.errors.iv_userId
                    : null}
                </div>
              </Grid>

              <Grid item lg={4} sx={{ paddingRight: "20px" }}>
                <label>Password</label>
                <TextField
                  maxLength="16"
                  type={showPassword ? "text" : "password"}
                  autoComplete="off"
                  onChange={workForceAddFormik.handleChange}
                  name="iv_password"
                  value={workForceAddFormik.values.iv_password}
                  onBlur={workForceAddFormik.handleBlur}
                  sx={{
                    width: "100%",
                    ".MuiInputBase-input": {
                      height: "1vh",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Grid>
                  {workForceAddFormik.errors.iv_password &&
                  workForceAddFormik.touched.iv_password ? (
                    <p style={{ color: "#f73232", fontSize: "1rem" }}>
                      Password should:
                      <ul>
                        <li>have length between 8 to 16 characters.</li>
                        <li>contain at least 1 lower case letter.</li>
                        <li>contain at least 1 upper case letter.</li>
                        <li>contain at least 1 number.</li>
                        <li>contain at least 1 special character.</li>
                      </ul>
                    </p>
                  ) : null}
                </Grid>
              </Grid>

              <Grid item lg={4}>
                <label>Password Confirmation</label>
                <TextField
                  maxLength="16"
                  type={showConfirmPassword ? "text" : "password"}
                  autoComplete="off"
                  onChange={workForceAddFormik.handleChange}
                  name="iv_confirm_password"
                  value={workForceAddFormik.values.iv_confirm_password}
                  onBlur={workForceAddFormik.handleBlur}
                  sx={{
                    width: "100%",
                    ".MuiInputBase-input": {
                      height: "1vh",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle confirm password visibility"
                          onClick={handleClickShowConfirmPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showConfirmPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Grid>
                  {workForceAddFormik.errors.iv_confirm_password &&
                  workForceAddFormik.touched.iv_confirm_password ? (
                    <p style={{ color: "#f73232", fontSize: "1rem" }}>
                      {workForceAddFormik.errors.iv_confirm_password}
                    </p>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ width: "20%" }}
            variant="contained"
            size="medium"
            onClick={workForceAddFormik.handleSubmit}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={passwordWF}
        onClose={() => {
          setPasswordWF(false);
          passwordChangeWorkForceFormik.resetForm();
          // setEditWF(false);
          setApiError("");
          // setEditSelectedItems([]);
        }}
        maxWidth={"md"}
        className="lineman-alert-popups"
        PaperProps={{
          style: { width: "100%", height: "auto", borderRadius: 20 },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="dialog-title"
        >
          Change Password
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => {
                passwordChangeWorkForceFormik.resetForm();
                setPasswordWF(false);
                setApiError("");
              }}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid container>
              {apiError && (
                <Grid item lg={12} sx={{ color: "red" }}>
                  {apiError}
                </Grid>
              )}

              <Grid item lg={6} sx={{ paddingRight: "20px" }}>
                <Typography>User Id.</Typography>
                <input
                  value={passwordChangeWorkForceFormik.values.iv_userId}
                  type="text"
                  onBlur={passwordChangeWorkForceFormik.handleBlur}
                  onChange={passwordChangeWorkForceFormik.handleChange}
                  style={{
                    color: "black",
                    padding: "12px 5px",
                    width: "100%",
                    backgroundColor: "#eceaea",
                    border: "1px solid rgb(182, 179, 179)",
                    borderRadius: "2px",
                  }}
                  fullWidth
                  autoComplete="off"
                  name="iv_userId"
                  disabled
                />
                <div style={{ fontSize: "small", color: "red" }}>
                  {passwordChangeWorkForceFormik.errors.iv_userId &&
                  passwordChangeWorkForceFormik.touched.iv_userId
                    ? passwordChangeWorkForceFormik.errors.iv_userId
                    : null}
                </div>
              </Grid>
              <Grid item lg={6} sx={{ paddingRight: "5px" }}>
                <label>Remarks</label>
                <TextField
                  maxLength="16"
                  type={"text"}
                  autoComplete="off"
                  onChange={passwordChangeWorkForceFormik.handleChange}
                  name="iv_remarks"
                  value={passwordChangeWorkForceFormik.values.iv_remarks}
                  onBlur={passwordChangeWorkForceFormik.handleBlur}
                  sx={{
                    width: "100%",
                    ".MuiInputBase-input": {
                      height: "1vh",
                    },
                  }}
                />
                <div style={{ fontSize: "small", color: "red" }}>
                  {passwordChangeWorkForceFormik.errors.iv_remarks &&
                  passwordChangeWorkForceFormik.touched.iv_remarks
                    ? passwordChangeWorkForceFormik.errors.iv_remarks
                    : null}
                </div>
              </Grid>

              <Grid item lg={6} sx={{ paddingRight: "5px" }}>
                <label>Password</label>
                <TextField
                  maxLength="16"
                  type={showPassword ? "text" : "password"}
                  autoComplete="off"
                  onChange={passwordChangeWorkForceFormik.handleChange}
                  name="iv_password"
                  value={passwordChangeWorkForceFormik.values.iv_password}
                  onBlur={passwordChangeWorkForceFormik.handleBlur}
                  sx={{
                    width: "100%",
                    ".MuiInputBase-input": {
                      height: "1vh",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Grid>
                  {passwordChangeWorkForceFormik.errors.iv_password &&
                  passwordChangeWorkForceFormik.touched.iv_password ? (
                    <p style={{ color: "#f73232", fontSize: "1rem" }}>
                      Password should:
                      <ul>
                        <li>have length between 8 to 16 characters.</li>
                        <li>contain at least 1 lower case letter.</li>
                        <li>contain at least 1 upper case letter.</li>
                        <li>contain at least 1 number.</li>
                        <li>contain at least 1 special character.</li>
                      </ul>
                    </p>
                  ) : null}
                </Grid>
              </Grid>
              <Grid item lg={6}>
                <label>Password Confirmation</label>
                <TextField
                  maxLength="16"
                  type={showConfirmPassword ? "text" : "password"}
                  autoComplete="off"
                  onChange={passwordChangeWorkForceFormik.handleChange}
                  name="iv_confirm_password"
                  value={
                    passwordChangeWorkForceFormik.values.iv_confirm_password
                  }
                  onBlur={passwordChangeWorkForceFormik.handleBlur}
                  sx={{
                    width: "100%",
                    ".MuiInputBase-input": {
                      height: "1vh",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle confirm password visibility"
                          onClick={handleClickShowConfirmPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showConfirmPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Grid>
                  {passwordChangeWorkForceFormik.errors.iv_confirm_password &&
                  passwordChangeWorkForceFormik.touched.iv_confirm_password ? (
                    <p style={{ color: "#f73232", fontSize: "1rem" }}>
                      {passwordChangeWorkForceFormik.errors.iv_confirm_password}
                    </p>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button sx={{ width: '20%', backgroundColor: 'red', '&:hover': { backgroundColor: 'red' } }} variant="contained" size='medium' onClick={handleDeleteLMUser}>
                  Delete
                </Button> */}
          <Button
            sx={{ width: "20%" }}
            variant="contained"
            size="medium"
            onClick={passwordChangeWorkForceFormik.handleSubmit}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAmendBillPopup}
        onClose={() => {
          setOpenAmendBillPopup(false);
          amendBill.resetForm();
          setError1("");
          setSuccess("");
        }}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: { borderRadius: "16px", overflow: "hidden" } }}
      >
        <form onSubmit={amendBill.handleSubmit}>
          <DialogTitle
            sx={{
              position: "relative",
              background: "linear-gradient(to bottom, #1e52a7, #a0bbe7)",
              color: "white",
              fontWeight: 600,
              padding: "16px 48px",
              textAlign: "center",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Amend Duplicate Bill
            </Typography>
            <IconButton
              onClick={() => {
                setOpenAmendBillPopup(false);
                amendBill.resetForm();
                setError1("");
                setSuccess("");
              }}
              sx={{
                position: "absolute",
                right: 12,
                top: "50%",
                transform: "translateY(-50%)",
                color: "white",
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12} md={5}>
                <Typography className="fieldLabel" gutterBottom>
                  Application ID <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  name="iv_application_id"
                  value={amendBill.values.iv_application_id}
                  onChange={amendBill.handleChange}
                  onBlur={amendBill.handleBlur}
                  inputProps={{ maxLength: 18, inputMode: "numeric" }}
                  placeholder="Enter 18-digit ID"
                  fullWidth
                  size="small"
                  autoFocus
                  error={
                    amendBill.touched.iv_application_id &&
                    Boolean(amendBill.errors.iv_application_id)
                  }
                  helperText={
                    amendBill.touched.iv_application_id &&
                    amendBill.errors.iv_application_id
                  }
                />
              </Grid>
            </Grid>

            {/* Alerts */}
            <Box sx={{ mt: 2 }}>
              {error1 && <Error error={error1} onClose={() => setError1("")} />}
              {success && (
                <Success error={success} onClose={() => setSuccess("")} />
              )}
            </Box>
          </DialogContent>

          <DialogActions sx={{ justifyContent: "flex-end", p: 2, gap: 1 }}>
            <Button
              onClick={() => {
                setOpenAmendBillPopup(false);
                amendBill.resetForm();
                setError1("");
                setSuccess("");
              }}
              variant="outlined"
              color="secondary"
            >
              Cancel
            </Button>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              // disabled={amendBill.isSubmitting || !amendBill.isValid || !amendBill.dirty}
              startIcon={
                amendBill.isSubmitting ? <CircularProgress size={18} /> : null
              }
            >
              {amendBill.isSubmitting ? "Processing..." : "Submit & Download"}
            </Button>
          </DialogActions>
        </form>

        <Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={viewBackdrop}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
    </>
  );
};

const MemorizedSideBar = React.memo(Sidebar);
export default MemorizedSideBar;
